// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  overflow-x: hidden;
}

.mob-menu {
  display: none;
}

.mob-hide {
  display: block;
}

@media (max-width: 955px) {
  .mob-menu {
    display: block;
  }
  .mob-hide {
    display: none !important;
  }
}
.logo {
  width: 100px;
  margin-right: 100px;
}

.top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}

.user-name {
  display: flex;
  align-items: center;
}

.user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.user-name p {
  display: flex;
  align-items: center;
}

.user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}

.top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}

.dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}

ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

p {
  margin-bottom: 10px;
}

.scroll-div {
  position: absolute;
  top: calc(var(--app-header) + 24px) !important;
  width: 100%;
}

.scroll-div .dash-text {
  padding: 15px;
}

ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}

ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}

ul li:hover {
  color: #000;
}

ul li:hover:before {
  /* background: #fff;
    color: #212529; */
  width: 100%;
}

.table-bordered {
  border: 0px;
}

.detail-description {
  /* width: 100%; */
  height: 100%;
  padding: 0px;
  width: calc(100% - 250px);
  position: absolute;
  left: 250px;
  top: 120px;
  /* background: purple; */
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}

h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}

.com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
}
.com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}

.ico-box {
  width: 40px;
  height: 40px;
  background: #efeeee;
  display: flex;
  align-items: center;
  justify-content: center;
}

.table-wrap {
  padding: 30px;
  position: absolute;
  top: 150px;
  width: 100%;
  /* width:calc(100% - 76px); */
}

.box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}

.filter-ico li {
  width: 40px;
}

.filter-ico li i {
  color: #000;
}

.text {
  padding-right: 10px;
}

.table-parent {
  overflow-x: auto;
  margin-top: -8px;
  overflow-y: auto;
}

table {
  margin-bottom: 20px;
  border-left: 0px;
  border-bottom: 0px;
  border: 0px;
  overflow-y: auto;
  width: 100%;
}

th,
td {
  border-bottom: 0px;
  border: 1px solid gray;
  /* background: white; */
  color: #000;
  padding: 10px 10px;
  border-width: 1px !important;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: top;
}

th {
  background: #fefeff;
  color: #fff;
}

td[scope=row] {
  position: relative;
}

.inner {
  width: 100%;
  margin-bottom: 0px;
}
.inner td {
  padding: 5px;
  border: 0px;
}
.inner td:first-child {
  width: 30px;
}

td[scope=row]:before {
  content: "";
  width: 5px;
  height: calc(100% + 2px);
  position: absolute;
  left: 0px;
  top: -1px;
  background: #ffffff;
}

tbody tr:hover {
  background: #ffffff;
}
tbody tr:hover td {
  color: #000;
}
tbody tr span {
  display: flex;
  align-items: center;
}

.filter {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  border: 1px solid #ddd;
  border-bottom: 0px;
  padding: 10px 10px;
}

.filter-title {
  flex: 1;
}

.filter ul {
  display: flex;
  float: right;
}

.filter-bar {
  display: flex;
  width: 100%;
}

.filter-ico {
  flex: 1;
}

.search-container {
  position: relative;
}

.search-input {
  width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.search-input + i {
  position: absolute;
  right: 20px;
  top: 37%;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.chekbox-image {
  display: flex;
}
.chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.chekbox-image td:first-child span {
  padding-left: 13px;
}
.chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}

.image-sec img {
  max-width: 100%;
  max-height: 80px;
  object-fit: cover;
}

.mobile-design {
  display: none;
}

@media (max-width: 992px) {
  .detail-list {
    display: none;
  }
  .detail-description {
    width: 100%;
    left: 0px;
  }
  .followers-tag {
    flex-wrap: wrap;
  }
  .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .followers-tag .box .text {
    flex: 1;
  }
  .com-record {
    padding: 15px;
  }
  .com-record:after {
    height: 130px;
  }
  .search-container .search-input {
    width: 100%;
  }
  .top-menu-wrap {
    display: none;
  }
  .table-wrap {
    top: unset;
  }
  .table-wrap .table-parent {
    display: none;
  }
  .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
  }
  .mobile-design .tile {
    background: #fff;
    padding: 10px;
  }
  .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .mobile-design .tile p {
    color: #5ea1d8 !important;
  }
  .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .mobile-design .first-tile .img img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
  }
  .mobile-design .common-tile {
    display: flex;
  }
  .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
.setting-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}

.setting-label {
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

.toggle-button {
  width: 40px;
  height: 20px;
  -webkit-appearance: none;
  appearance: none;
  background-color: #ddd;
  border-radius: 10px;
  position: relative;
  outline: none;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.toggle-button:checked {
  background-color: rgb(94, 161, 216);
}

.toggle-button:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.toggle-button:checked:before {
  transform: translateX(20px);
}

.settings-container {
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
}

label {
  display: block;
  margin-bottom: 10px;
}

h3,
h4 {
  margin-bottom: 20px;
}

.price-per-slot {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.error {
  color: red;
  font-size: 0.9em;
  margin-top: 5px;
}

.btn-primary {
  background-color: #5ea1d8;
  border: none;
}

/* styles.css */
table {
  border-collapse: collapse;
  width: 100%;
}

th,
td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: left;
}

th {
  background-color: #5ea1d8;
  color: #fff;
}

tr:nth-child(even) {
  background-color: #f2f2f2;
}

tr:hover {
  background-color: #ddd;
  color: #000;
}

.generate-btn {
  padding: 10px 20px 10px 10px;
  text-align: right;
}

.input-container {
  display: flex;
  align-items: center;
  position: relative;
}

.prefix {
  position: absolute;
  left: 10px; /* Adjust based on input padding */
  pointer-events: none; /* Prevent interactions with the prefix */
}

.input-container input {
  padding-left: 17px; /* Add padding to make room for the £ sign */
}

.setting-btn {
  padding: 10px;
  border: 1px solid #5ea1d8;
  border-radius: 18px;
  display: block;
  margin: 0 12px 12px 0;
}

.setting-page input[type=time],
.setting-page input[type=number] {
  max-width: 100%;
  height: 40px;
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
}
.setting-page table button {
  padding: 5px 10px;
  border: 1px solid #5ea1d8;
  border-radius: 18px;
  display: block;
  margin: 0 12px 12px 0;
  font-size: 12px !important;
}

.setting-input {
  border: 1px solid lightgray;
  border-radius: 5px;
}

body {
  overflow-x: hidden;
}

.logo {
  width: 100px;
  margin-right: 100px;
}

.top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}

.user-name {
  display: flex;
  align-items: center;
}

.user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}

.user-name p {
  display: flex;
  align-items: center;
}

.user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}

.dashbored-wrap {
  width: 100%;
  height: 100vh;
  background: #fff;
  /* background: red; */
}

.top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}

.dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}

ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}

p {
  margin-bottom: 10px;
}

.scroll-div {
  position: absolute;
  top: 120px !important;
  width: 100%;
}

.scroll-div .dash-text {
  padding: 15px;
}

ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}

ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}

ul li:hover {
  color: #000;
}

ul li:hover:before {
  /* background: #fff;
    color: #212529; */
  width: 100%;
}

.detail-description {
  /* width: 100%; */
  height: 100%;
  padding: 0px;
  width: calc(100% - 250px);
  position: absolute;
  left: 250px;
  top: 120px;
  /* background: purple; */
}

.followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}

h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}

.com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
}
.com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}

.com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
}

.ico-box {
  width: 40px;
  height: 40px;
  background: #efeeee;
  display: flex;
  align-items: center;
  justify-content: center;
}

.box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}

.filter-ico li {
  width: 40px;
}

.filter-ico li i {
  color: #000;
}

.text {
  padding-right: 10px;
}

.filter {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  border: 1px solid #ddd;
  border-bottom: 0px;
  padding: 10px 10px;
}

.filter-title {
  flex: 1;
}

.filter ul {
  display: flex;
  float: right;
}

.filter-bar {
  display: flex;
  width: 100%;
}

.filter-ico {
  flex: 1;
}

.search-container {
  position: relative;
}

.search-input {
  width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}

.search-input + i {
  position: absolute;
  right: 20px;
  top: 37%;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}

.chekbox-image {
  display: flex;
}
.chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.chekbox-image td:first-child span {
  padding-left: 13px;
}
.chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}

.image-sec img {
  max-width: 100%;
  max-height: 80px;
  object-fit: cover;
}

.mobile-design {
  display: none;
}

@media (max-width: 992px) {
  .detail-list {
    display: none;
  }
  .detail-description {
    width: 100%;
    left: 0px;
  }
  .followers-tag {
    flex-wrap: wrap;
  }
  .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .followers-tag .box .text {
    flex: 1;
  }
  .com-record {
    padding: 15px;
  }
  .com-record:after {
    height: 130px;
  }
  .search-container .search-input {
    width: 100%;
  }
  .top-menu-wrap {
    display: none;
  }
  .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
  }
  .mobile-design .tile {
    background: #fff;
    padding: 10px;
  }
  .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .mobile-design .tile p {
    color: #5ea1d8 !important;
  }
  .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .mobile-design .first-tile .img img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
  }
  .mobile-design .common-tile {
    display: flex;
  }
  .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
.setting-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 0;
}

.setting-label {
  font-size: 16px;
  color: #333;
  cursor: pointer;
}

.toggle-button {
  width: 40px;
  height: 20px;
  -webkit-appearance: none;
  appearance: none;
  background-color: #ddd;
  border-radius: 10px;
  position: relative;
  outline: none;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

.toggle-button:checked {
  background-color: rgb(94, 161, 216);
}

.toggle-button:before {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.toggle-button:checked:before {
  transform: translateX(20px);
}

.settings-container {
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
}

label {
  display: block;
  margin-bottom: 10px;
}

h3,
h4 {
  margin-bottom: 20px;
}

.error {
  color: red;
  font-size: 0.9em;
  margin-top: 5px;
}

.btn-primary {
  background-color: #5ea1d8;
  border: none;
}

.generate-btn {
  padding: 10px 20px 10px 10px;
  text-align: right;
}

.input-container {
  display: flex;
  align-items: center;
  position: relative;
}

.prefix {
  position: absolute;
  left: 10px; /* Adjust based on input padding */
  pointer-events: none; /* Prevent interactions with the prefix */
}

.input-container input {
  padding-left: 17px; /* Add padding to make room for the £ sign */
}

.setting-btn {
  padding: 10px;
  border: 1px solid #5ea1d8;
  border-radius: 18px;
  display: block;
  margin: 0 12px 12px 0;
}

.setting-page input[type=time],
.setting-page input[type=number] {
  max-width: 100%;
  height: 40px;
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid lightgray;
  border-radius: 5px;
}

.setting-input {
  border: 1px solid lightgray;
  border-radius: 5px;
}

* {
  padding: 0px;
  margin: 0px;
}

body {
  background: #efeeee;
  counter-reset: my-sec-counter;
}

.view-flow {
  background: #efeeee;
  padding-top: 10px;
  /*description wrapper starts here*/
}
.view-flow .container1 {
  max-width: 1040px;
  margin: 0px auto;
  background: transparent;
  padding-bottom: 30px;
  padding: 0px 40px 20px;
}
.view-flow .container1 .user-sec {
  display: flex;
  padding: 20px 20px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px;
  position: relative;
}
.view-flow .container1 .user-sec .user-details {
  flex: 1;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .user-ico {
  flex: 1;
  display: none !important;
}
.view-flow .container1 .user-sec .user-details .user-ico img {
  width: 180px !important;
  height: 180px;
  border-radius: 100%;
  object-fit: cover;
  max-width: 200px;
}
.view-flow .container1 .user-sec .user-details .ico-details {
  flex: 4;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
}
.view-flow .container1 .user-sec .user-details .ico-details p {
  margin-bottom: 20px !important;
  margin-top: 0px !important;
  justify-content: flex-end !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {
  max-width: 500px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div {
  width: auto;
  margin-right: 20px;
  display: block;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div:last-child span {
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner > div:last-child span .mat-icon {
  color: rgba(0, 0, 0, 0.54) !important;
  font-size: 18px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .u-ico {
  margin-right: 15px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .qrcode {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .qrcode span {
  font-weight: 400 !important;
  color: #212427;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic p {
  margin: 0px !important;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic > div:last-child {
  margin-right: 0px;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic img {
  border-radius: 50%;
  cursor: pointer;
}
.view-flow .container1 .user-sec .user-details .ico-details .like {
  max-width: 100%;
  margin-bottom: 0px;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul {
  max-width: 500px;
  width: 100%;
  display: flex;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li {
  height: 100%;
  justify-content: flex-start;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
  font-size: 25px;
  color: gray;
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  margin-bottom: 5px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
  font-size: 10px;
  font-family: "Raleway";
  font-weight: 600;
  text-align: center;
  color: #212427 !important;
  padding: 0px !important;
  min-height: 30px;
  margin-left: 0px;
}
.view-flow .container1 .user-sec .user-details .ico-details .like div {
  flex: 1;
  text-align: right;
}
.view-flow .container1 .viewflow-step {
  width: calc(100% - 40px);
  display: flex;
  padding: 20px 20px;
  padding: 20px 10px 20px;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  position: relative;
  border-radius: 10px;
  flex-wrap: wrap;
  display: flex;
  background: #fff;
  margin: 10px 20px 10px 20px;
}
.view-flow .container1 .viewflow-step .des-item {
  border-radius: 0px;
  border-right: 1px solid lightgray;
  max-width: calc(50% - 20px);
  padding-right: 10px;
  flex-basis: calc(50% - 20px);
  margin-right: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 2;
}
.view-flow .container1 .viewflow-step .des-item .des {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px;
  flex: 1;
  border: 1px solid #ddd;
  border: 0px !important;
  margin-bottom: 0px;
  border-radius: 0px;
  padding: 0px 0px;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  box-shadow: none !important;
}
.view-flow .container1 .viewflow-step .des-item .des > div {
  flex: none;
  color: #212427;
  display: flex;
  flex-wrap: wrap;
}
.view-flow .container1 .viewflow-step .des-item .des p {
  max-height: 287px;
  padding-right: 10px;
}
.view-flow .container1 .viewflow-step .des-item .des .s-num {
  font-size: 16px;
  width: 30px;
  height: 30px;
  color: #fff;
  border: 0px solid #f3f3f3;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-family: "Raleway";
  font-weight: 600;
  margin-top: 0px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}
.view-flow .container1 .viewflow-step .des-item .des .s-num:before {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  left: 0px;
  top: 0px;
  position: absolute;
  background: lightgray;
  z-index: -1;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn {
  display: flex;
  align-items: center;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn > div {
  flex: 1;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn > div:first-child {
  justify-content: flex-start;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn > div:last-child {
  justify-content: right;
  text-align: end;
}
.view-flow .container1 .viewflow-step .des-item .btm-btn .lock {
  display: flex;
  align-items: center;
  font-family: "Raleway";
}
.view-flow .container1 .viewflow-step .des-item .btm-btn .lock > span {
  display: flex;
  align-items: center;
}
.view-flow .container1 .viewflow-step .step-sec {
  box-shadow: none;
  border: 0px;
  padding: 0px 0px 0px 0px;
  margin-left: 10px;
  width: 50%;
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 40px;
}
.view-flow .container1 .viewflow-step .step-sec .progressbar {
  border: 2px solid lightgray;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 10px;
  padding: 5px;
}
.view-flow .container1 .viewflow-step .step-sec .progressbar .w3-round {
  height: 7px;
  background: #5ea1d8;
  background: lightgrey;
}
.view-flow .container1 .viewflow-step .step-sec .img-wrap {
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.view-flow .container1 .viewflow-step .step-sec .img-wrap img {
  max-width: 100% !important;
  height: 100%;
  object-fit: cover;
  margin: 0px auto;
  width: 100% !important;
}
.view-flow .container1 .viewflow-step .step-sec .img-wrap + .item {
  width: calc(100% - 0px) !important;
  margin: 17px 0px !important;
  border: 0px !important;
}
.view-flow .clickarrow {
  width: 100%;
  display: block;
  position: absolute;
  margin-top: 0px;
  width: 100%;
  height: 35px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  position: fixed;
  max-width: 1000px;
}
.view-flow .clickarrow button.owl-prev {
  position: absolute;
  background: #fafafa !important;
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  left: 0px;
}
.view-flow .clickarrow button.owl-prev span {
  font-size: 57px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -15px;
  font-weight: 400 !important;
  color: #5ea1d8;
}
.view-flow .clickarrow button.owl-next {
  position: absolute;
  background: #fafafa !important;
  background: rgba(250, 250, 250, 0.7) !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  right: 0px;
}
.view-flow .clickarrow button.owl-next span {
  font-size: 57px;
  line-height: 0px;
  display: flex;
  align-items: center;
  margin-top: -15px;
  font-weight: 400 !important;
  color: #5ea1d8;
}
.view-flow .partOfBundle {
  padding: 0px 20px 20px;
  background: #fff;
  background: transparent;
  margin: 0px 20px 0px 0px;
  border-radius: 10px;
  overflow-x: scroll;
}
.view-flow .partOfBundle h2 {
  margin-top: 0px;
  margin-bottom: 0px !important;
}
.view-flow .partOfBundle .row {
  flex-wrap: nowrap !important;
  width: -moz-fit-content;
  width: fit-content;
  margin-top: 10px !important;
}
.view-flow .partOfBundle .item {
  background: #fff;
  margin-left: 0px;
  width: 170px !important;
  padding: 10px;
  margin-right: 10px;
  position: relative;
}
.view-flow .partOfBundle .item > div:first-child img {
  height: 150px !important;
}
.view-flow .partOfBundle .item > div:last-child p {
  height: 25px !important;
}
.view-flow .qr-ico {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
  position: absolute;
  right: 20px;
}
.view-flow .qr-ico i {
  flex: 1;
  font-size: 25px;
  color: grey;
}
.view-flow .qr-ico p {
  font-weight: 600;
}
.view-flow .material-icons,
.view-flow .align-items-center {
  color: #212427 !important;
  font-weight: normal !important;
  cursor: pointer;
  display: flex;
}
.view-flow img {
  width: 100%;
}
.view-flow p {
  font-family: "Raleway";
  font-size: 15px;
  line-height: 20px;
}
.view-flow button {
  padding: 3px 10px;
  border: 0px;
  font-size: 15px;
  border-radius: 15px;
}
.view-flow button.active {
  background: #5ea1d8;
  color: white;
}
.view-flow h2 {
  font-family: "Raleway";
  margin-bottom: 20px;
}
.view-flow h2 a {
  color: #212427 !important;
}
.view-flow h3 {
  font-family: "Raleway";
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
.view-flow ul {
  display: flex;
  list-style: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.view-flow li {
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.view-flow .like .qrcode {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
}
.view-flow .description-wrapper .des-item .des {
  /*max-height:200px;*/
}
.view-flow .description-wrapper .des-item .des p {
  max-height: 100px;
  overflow-y: auto;
}
.view-flow .des-item .des > div span {
  flex: 1;
  font-family: "RALEWAY";
}
.view-flow .des-item .des > div span.material-icons.ng-star-inserted {
  max-width: 30px;
}
.view-flow .des-item .des > div span:first-child {
  align-items: flex-start;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.view-flow .des-item .des > div span:last-child {
  text-align: flex-end;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.view-flow .des-item .des > div span i {
  margin-right: 5px;
}
.view-flow .des-item .item {
  flex: 1;
  border: 1px solid #ddd;
  border-radius: 40px;
  padding: 40px 20px;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin-top: 20px;
}
.view-flow .des-item .item .list {
  display: flex;
  /* padding: 20px 0px; */
  max-height: 150px;
  overflow-y: auto;
  align-items: flex-start;
}
.view-flow .des-item .item .list ul {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin: 0px 0px 20px;
  padding: 5px;
}
.view-flow .des-item .item .list ul li {
  font-family: "Raleway";
  font-size: 14px;
  line-height: 28px;
  word-break: break-all;
  position: relative;
  padding-left: 17px;
}
.view-flow .des-item .item .list ul li:before {
  content: "";
  width: 8px;
  height: 8px;
  background: grey;
  position: absolute;
  left: 0px;
  top: 10px;
  border-radius: 50%;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}
.view-flow .des-item .item .list ul li:first-child {
  padding-left: 0px;
}
.view-flow .des-item .item .list ul li:first-child:before {
  display: none;
}
.view-flow .des-item .item .list ul li:first-child {
  font-weight: 600;
}
.view-flow video {
  max-width: 100% !important;
  margin: 0px auto;
  width: 100% !important;
}
.view-flow:empty {
  display: none !important;
}

.step-sec .img-wrap:after {
  content: "›";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  right: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.step-sec .img-wrap:before {
  content: "‹";
  background: #fafafa !important;
  box-shadow: 0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12);
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  position: absolute;
  left: -49px;
  top: calc(50% - 20px);
  font-size: 35px;
  margin-top: -8px;
  display: none;
}

.des-item .des p::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .des p::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.des-item .item .list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}

.des-item .item .list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.des-item .item .list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.step-sec {
  text-align: center;
  display: flex;
  flex-direction: column;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
}

.progressbar ul {
  display: flex;
  flex-basis: 100%;
}

.progressbar ul li {
  flex: 1;
  display: flex;
  align-items: center;
}

.progressbar ul li a {
  width: 20px;
  height: 20px;
  background: #5ea1d8;
  border-radius: 50%;
  color: #fff;
  text-decoration: none;
  text-align: center;
  font-size: 12px;
  font-family: "RALEWAY";
  display: flex;
  align-items: center;
  justify-content: center;
}

.progressbar ul li a:before {
  counter-increment: my-sec-counter;
  content: "" counter(my-sec-counter) "";
}

img {
  max-width: 100%;
}

@media only screen and (max-width: 1025px) and (min-width: 320px) {
  .view-flow h2 {
    font-size: 22px !important;
  }
}
@media only screen and (max-width: 992px) and (min-width: 320px) {
  .view-flow .container1 {
    display: flex;
    flex-direction: column;
    padding: 0px 15px 20px;
  }
  .view-flow .container1 .user-sec {
    flex-direction: column;
  }
  .view-flow .container1 .user-sec .user-details {
    flex-direction: column;
    order: 2;
  }
  .view-flow .container1 .user-sec .user-details .user-ico {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like {
    display: flex;
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: 0px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li i {
    font-size: 20px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 0px !important;
  }
  .view-flow .container1 .user-sec .qr-code {
    padding: 10px 0px;
  }
  .view-flow .description-wrapper {
    flex-direction: column;
    margin: 0px;
    margin-bottom: 20px;
  }
  .view-flow .description-wrapper .des-item {
    margin-right: 0px;
    margin-bottom: 20px;
    flex-basis: 100%;
    max-width: unset;
    border-right: 0px;
    padding-right: 0px;
  }
  .view-flow .description-wrapper .des-item .des > div span:first-child {
    justify-content: flex-start;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap {
    display: flex;
    flex-direction: column;
    flex: none;
    color: #212427;
  }
  .view-flow .description-wrapper .des-item .des .timer-wrap > * {
    margin-right: 10px;
  }
  .view-flow .viewflow-step {
    width: 100%;
    margin: 0px auto 20px;
  }
  .view-flow .viewflow-step .des-item {
    flex-basis: 100%;
    max-width: unset;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 20px;
  }
  .view-flow .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .viewflow-step .step-sec {
    padding: 0px;
    margin-left: 0px;
    width: 100%;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 25px;
    height: 25px;
  }
  .view-flow .ico-details .profilepic {
    flex-wrap: nowrap;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner {
    width: 100% !important;
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner + .qrcode {
    width: 100%;
    justify-content: flex-end;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic + .like-list {
    flex-direction: column;
  }
  .view-flow .container1 .viewflow-step .step-sec {
    width: 100%;
    margin: 0px;
  }
  .supportingdoc {
    position: relative !important;
    padding: 10px 10px 10px 0px !important;
  }
}
.like-list .fashion-btn {
  display: block;
}

.qr-code .lock,
.qr-code .fashion-btn {
  display: none;
}

@media only screen and (max-width: 992px) and (min-width: 461px) {
  .view-flow .container1 .user-sec .user-details {
    flex-direction: row;
  }
  .view-flow .container1 .user-sec .user-details .ico-details {
    padding-left: 15px;
    max-width: 100%;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul {
    margin-left: -15px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like .qrcode span {
    margin-right: 15px !important;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 14px !important;
  }
  .view-flow .container1 .description-wrapper {
    width: auto;
    margin: 10px 20px;
  }
  .view-flow .container1 .description-wrapper .step-sec .img-wrap {
    max-height: unset;
  }
  .view-flow .container1 .viewflow-step .des-item .des {
    padding-bottom: 20px;
    border-radius: 0px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-next {
    right: -8px;
  }
  .view-flow .container1 .viewflow-step .clickarrow button.owl-prev {
    left: -8px;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .view-flow .viewflow-step .clickarrow button {
    width: 35px;
    height: 35px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: -45px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: -45px;
  }
}
@media only screen and (max-width: 460px) and (min-width: 320px) {
  .view-flow .container1 .user-sec .user-details .ico-details .profilepic > div p {
    font-size: 11px !important;
  }
  .ico-details .profilepic > div:last-child span {
    font-size: 11px;
  }
  .view-flow .viewflow-step .clickarrow button {
    width: 35px;
    height: 35px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-prev {
    left: 0px;
  }
  .view-flow .viewflow-step .clickarrow button.owl-next {
    right: 0px;
  }
  .view-flow .viewflow-step {
    width: auto;
    margin: 10px 0px;
  }
  .qr-code {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
  }
  .qr-code .priceIcon-wp {
    position: relative !important;
    top: -2px;
  }
  .qr-code .lock > span {
    display: flex;
    align-items: center;
  }
  .qr-code .lock,
  .qr-code .fashion-btn {
    display: block;
  }
  .profilepic .lock {
    display: none !important;
  }
  .like-list .fashion-btn {
    display: none !important;
  }
  .view-flow h2 span {
    font-size: 20px !important;
    word-break: break-word;
  }
  .view-flow .container1 .user-sec {
    padding: 10px;
    margin: 0px;
  }
  .ico-details .profilepic .profinner > div {
    margin-right: 5px;
  }
  .ico-details .profilepic > div {
    margin-right: 0px;
  }
  .viewflow-step .des-item .des p {
    max-height: 133px;
  }
  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {
    font-size: 9px;
  }
  .partOfBundle {
    padding: 0px;
    margin-right: 5px;
  }
}
button.common {
  padding: 3px 6px !important;
  background: #5ea1d8 !important;
  border: 0px !important;
  color: #fff !important;
  font-size: 13px !important;
  border-radius: 5px !important;
}

@media (max-width: 500px) {
  .ico-details .profilepic .qrcode {
    justify-content: center;
  }
}
.example-list {
  max-width: 100%;
  height: auto;
  display: flex;
  background: white;
  flex-direction: column;
  overflow-y: auto;
}
.example-list .example-box {
  display: flex;
  padding: 15px 10px;
  border-bottom: 1px solid lightgrey;
  background: white !important;
  flex: 1;
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-list .example-box .item-name {
  text-align: left;
  width: 70%;
}
.example-list .example-box .item-value {
  text-align: left;
  width: 30%;
}
.example-list .example-box .item-name,
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder,
.example-list .example-box .item-value {
  text-align: left;
  padding: 5px;
  font-size: 14px;
  font-weight: 400 !important;
  overflow-wrap: break-word;
}
.example-list .example-box .item-delete,
.example-list .example-box .item-reorder {
  float: right;
  cursor: pointer;
  font-size: 20px;
  width: 10%;
}
.example-list .example-box:last-child {
  border-bottom: 0px;
}
.example-list .example-box img {
  border-bottom: 0px;
  width: 40px !important;
  max-width: 40px;
  height: 40px !important;
  object-fit: cover;
}
.example-list .example-box > * {
  flex: 1;
  color: #212427 !important;
  font-weight: normal !important;
}
.example-list .example-box a {
  color: #007bff !important;
}
.example-list::-webkit-scrollbar {
  width: 4px;
  height: 100px;
}
.example-list::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
.example-list::-webkit-scrollbar-thumb {
  background-color: #5ea1d8;
  outline: 1px solid #5ea1d8;
}

.example-box {
  padding: 15px 10px;
  border-bottom: solid 1px lightgray;
  color: rgba(0, 0, 0, 0.87);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  cursor: move;
  background: white;
  font-size: 14px;
}
.example-box > div {
  width: 50%;
  display: flex !important;
}
.example-box > div:first-child {
  width: 80%;
}
.example-box > div:last-child {
  width: 17%;
}
.example-box > div > span {
  text-align: left;
  word-break: keep-all;
  display: flex;
  align-items: center;
}
.example-box > div > span:first-child {
  flex: 1;
  width: 50%;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}
.example-box > div > span:last-child {
  width: 50%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: end;
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: 400 !important;
}

.itemremove span:first-child {
  width: 90% !important;
}
.img-div-left {
  position: fixed;
  z-index: 9999999 !important;
  height: 100px;
  width: 100px;
  overflow: visible;
  margin: auto;
  top: 5% !important;
  left: 0;
  bottom: 0;
  right: 0;
}
.img-div-left img {
  width: 100%;
  height: 100%;
  position: absolute !important;
  top: 0% !important;
}

/*new design starts here*/
.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

.mat-accent {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.example-list .example-box .item-name {
  padding-left: 10px !important;
  border-right: 1px solid #ddd;
}
.example-list .example-box .item-value {
  padding-left: 10px !important;
}

.textcolor {
  background-color: #5ea1d8;
  color: white;
  position: relative;
  text-decoration: none;
  padding: 5px 10px;
  font-family: "Raleway";
  font-weight: 500;
  cursor: pointer;
  border-radius: 5px;
}

.item .img {
  height: 150px !important;
  background-color: lightgray;
}

p {
  margin: 0px;
}

.zoom {
  cursor: pointer;
  width: 100%;
  height: 70%;
  transition: transform 0.1s;
  /* Animation */
}

.zoom:hover {
  border-radius: 5px;
  transform: scale(1.1);
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.owl-carousel .owl-nav button.owl-next,
.owl-carousel .owl-nav button.owl-prev,
.owl-carousel button.owl-dot {
  font-size: 55px !important;
}

.owl-theme .owl-nav [class*=owl-] {
  font-size: 55px !important;
}

button span {
  font-size: 55px;
}

.owl-nav {
  display: none;
}

.with-icon {
  display: flex;
  align-items: center;
}

.mat-badge-content {
  background: #5ea1d8;
}

.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  overflow: hidden;
  z-index: 100;
}

.user-pro .row {
  justify-content: left;
}
.user-pro .ng-star-inserted {
  width: 15.6%;
  margin-right: 1%;
}
.user-pro .item {
  width: 100% !important;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dddddd;
  margin: 0px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.user-pro .item > div {
  margin: 5px;
}
.user-pro .item p {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.user-pro .item p:last-of-type {
  height: auto !important;
}
.user-pro .item .with-icon {
  width: 100%;
  font-family: "Raleway";
  display: flex;
  align-items: center;
}
.user-pro .item .with-icon > div {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-right: 5px;
}
.user-pro .item .with-icon img {
  object-fit: cover;
  height: 40px !important;
  border: 0px;
}
.user-pro .item .zoom {
  margin: 5px;
  width: calc(100% - 10px);
  background-color: transparent;
}
.user-pro .item img {
  height: 150px;
  object-fit: cover;
  width: 100%;
  border: 1px solid #dddddd;
}

@media only screen and (max-width: 1024px) and (min-width: 993px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 18% !important;
    width: 18% !important;
    margin: 1% !important;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    max-width: 100% !important;
    width: 100% !important;
    font-family: "Raleway";
    display: flex;
    align-items: center;
    max-width: 100% !important;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
}
@media only screen and (max-width: 992px) and (min-width: 768px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 23% !important;
    width: 23% !important;
    margin: 1% !important;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 20px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    max-width: 100% !important;
    width: 100% !important;
    font-family: "Raleway";
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 12px;
  }
}
@media only screen and (max-width: 767px) and (min-width: 461px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 31.3% !important;
    width: 31.3% !important;
    margin: 1%;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    width: 100%;
    font-family: "Raleway";
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .with-icon.ng-star-inserted {
    max-width: 100% !important;
    width: 100% !important;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 12px;
  }
}
@media screen and (max-width: 460px) {
  .user-pro .row {
    justify-content: left;
    text-align: start;
  }
  .user-pro .ng-star-inserted {
    max-width: 48% !important;
    width: 48% !important;
    margin: 1%;
  }
  .user-pro .item {
    max-width: 100% !important;
    width: 100% !important;
    overflow: hidden;
    background: #fff;
    border: 1px solid #dddddd;
    margin: 0px;
    margin-right: 0px;
    margin-bottom: 0px;
  }
  .user-pro .item > div {
    margin: 5px;
  }
  .user-pro .item p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 33px !important;
    white-space: normal;
    word-break: break-word;
  }
  .user-pro .item .with-icon {
    width: 100%;
    font-family: "Raleway";
    display: flex;
    align-items: center;
  }
  .user-pro .item .with-icon > div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    margin-right: 5px;
  }
  .user-pro .item .with-icon img {
    object-fit: cover;
    height: 40px !important;
    border: 0px;
  }
  .user-pro .item .with-icon.ng-star-inserted {
    max-width: 100% !important;
    width: 100% !important;
  }
  .user-pro .item .zoom {
    margin: 5px;
    width: calc(100% - 10px);
    background-color: transparent;
  }
  .user-pro .item img {
    height: 150px;
    object-fit: cover;
    width: 100%;
    border: 1px solid #dddddd;
  }
  h3 {
    padding-left: 7px;
  }
}
.scroll .item .uni-wrapper .bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  max-width: 25px !important;
  height: 25px !important;
}
.scroll .item .uni-wrapper .bundleIcon img {
  width: 100% !important;
  height: 20px !important;
  object-fit: contain;
  border: none;
}

.uni-wrapper P {
  flex: 1;
}

/*new design starts here new bundle*/
.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
.bundleIcons {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px !important;
  height: 25px !important;
  padding-left: 5px;
}
.bundleIcons img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

.partOfBundle .item .uni-wrapper {
  display: flex;
}
.partOfBundle .item .uni-wrapper p {
  justify-content: flex-start !important;
}

.uni-wrapper P {
  flex: 1;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.viewbundle .step-sec + .row {
  margin-top: 40px !important;
  display: flex;
  justify-content: flex-start;
  width: 100%;
}
.viewbundle .step-sec + .row > div {
  width: 25% !important;
}
.viewbundle .step-sec + .row > div .item {
  box-shadow: none !important;
}
.viewbundle .step-sec + .row > div .item img {
  width: calc(100% - 20px) !important;
  object-fit: cover;
  margin: 10px !important;
}
.viewbundle .step-sec + .row > div .item p {
  padding-left: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  height: 33px !important;
  white-space: normal;
  word-break: break-word;
}
.viewbundle .step-sec + .row > div .item .with-icon {
  display: flex;
}
.viewbundle .step-sec + .row > div .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 20px !important;
}

@media (max-width: 460px) {
  .viewbundle .step-sec + .row > div {
    width: 50% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media only screen and (min-width: 461px) and (max-width: 767px) {
  .viewbundle .step-sec + .row > div {
    width: 33% !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon {
    display: flex;
    align-items: center;
  }
  .viewbundle .step-sec + .row > div .item .with-icon > div {
    width: 30px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon img {
    margin: 0px !important;
  }
  .viewbundle .step-sec + .row > div .item .with-icon p {
    padding-left: 5px !important;
  }
}
@media (max-width: 1024px) {
  .view-flow .container1 .user-sec {
    margin: 0px !important;
  }
  .view-flow .viewflow-step {
    width: 100% !important;
    margin: 10px 0px !important;
  }
  .partOfBundle {
    padding: 0px;
    margin-right: 5px;
  }
}
@media (max-width: 992px) {
  .view-flow .viewflow-step .des-item {
    padding: 0px;
    border: 0px;
    flex-basis: 100% !important;
    max-width: 100% !important;
    margin: 0px !important;
    padding: 0px !important;
    border: 0px !important;
  }
  .view-flow .viewflow-step .des-item .des {
    padding: 0px;
    padding: 0px 0px 20px !important;
  }
  .view-flow .viewflow-step .des-item .des p {
    margin: 0px;
  }
  .view-flow .qr-ico {
    position: relative;
    right: 0px;
  }
}
.font16 {
  font-size: 14px !important;
  font-family: "Raleway";
  color: rgba(0, 0, 0, 0.54) !important;
  font-weight: bold;
}

.priceIcon-p .font16 {
  font-size: 10px !important;
  color: #fff !important;
}

.timer-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.timer-wrap br {
  display: none;
}
.timer-wrap h6 {
  width: 100%;
  display: block;
  margin-bottom: 15px;
}
.timer-wrap .icon-wrap {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}
.timer-wrap .icon-wrap .textbodycolor {
  justify-content: flex-start !important;
  padding-left: 10px;
}

.newdesignadd {
  display: block;
  width: 100%;
  color: #212427;
  border: 1px solid lightgray;
  border: 0px !important;
  padding-left: 0px;
}
.newdesignadd .item-name {
  justify-content: flex-start !important;
}
.newdesignadd .item-name a {
  color: #5ea1d8;
}

.timer-wrap + h6 {
  margin-bottom: 15px;
}

.not-draggable {
  -webkit-user-drag: none; /* Safari/Chrome */ /* Firefox */ /* IE10+ */
  -webkit-user-select: none;
          user-select: none; /* Standard syntax */
  cursor: default; /* Optional: Change the cursor style */
  transform: translate(0, 0) !important;
}

.divscroll {
  width: 100% !important;
  display: flex;
  flex-direction: row;
  max-height: 100px;
  overflow-y: auto;
  overflow-x: hidden;
}
.divscroll div {
  width: 100% !important;
}

.view-flow .container1 .viewflow-step .step-sec .img-wrap {
  flex: none !important;
}

@media (max-width: 767px) {
  .partOfBundle {
    padding: 0px 0px 20px 0px !important;
    margin-right: 0px !important;
  }
  .partOfBundle h2 {
    margin-top: 0px !important;
  }
  .view-flow .container1 .viewflow-step {
    margin-bottom: 10px !important;
  }
  .view-flow .partOfBundle h2 {
    margin-top: 15px !important;
  }
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) {
  position: relative;
}
.view-flow .container1 .user-sec .user-details .ico-details .profilepic .profinner div:nth-child(4) span {
  position: relative;
}

/*chatbot design*/
.chatbot-wrapper {
  position: fixed;
  bottom: 0px;
  right: 20px;
  padding: 20px;
  display: flex;
  padding: 20px 0px 0px;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
  margin: 0px 20px 0px 20px;
  border-radius: 10px 10px 0px 0px;
  max-width: 400px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1000;
  flex-wrap: wrap;
  min-height: 400px;
  max-height: calc(100% - 120px);
  overflow-y: hidden;
  flex-direction: row;
}
.chatbot-wrapper:before {
  content: "";
  width: 100%;
  height: 31%;
  height: 124px;
  background: rgb(94, 161, 216) !important;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: -1;
}
.chatbot-wrapper .chatbot-msg {
  padding: 0px 20px;
  width: 100%;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .flora-close {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  margin-bottom: 15px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .flora-close h5 {
  color: #fff;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text {
  color: #fff;
  margin-bottom: 15px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text h2 {
  color: #fff !important;
  font-size: 20px !important;
  margin-bottom: 10px !important;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .welcome-text p {
  color: #fff !important;
  font-weight: 400 !important;
  margin: 0px !important;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 100%;
  overflow: hidden;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .image {
  margin-bottom: 20px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category {
  display: flex;
  flex-wrap: wrap;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul {
  margin: 0px;
  margin-top: 10px !important;
  padding: 0px !important;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  background: transparent !important;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul li {
  padding: 10px;
  background: rgb(94, 161, 216) !important;
  border-radius: 10px;
  border: 1px solid #ddd;
  margin: 0px;
  margin-right: 5px;
}
.chatbot-wrapper .chatbot-msg .chatbot-msgdetails .chabot-category ul li a {
  color: #fff !important;
}
.chatbot-wrapper .chatbot-btn {
  width: 100%;
  cursor: pointer;
  margin-bottom: 0px;
  padding: 0px 0px 0px 20px;
  display: flex;
  align-items: end;
  justify-content: flex-end;
  flex: 1;
  margin-bottom: 10px;
}
.chatbot-wrapper .chatbot-btn img {
  width: 80px;
}
.chatbot-wrapper .chatbot-converasation {
  margin-bottom: 20px;
  padding: 0px 20px;
  width: 100%;
}
.chatbot-wrapper .chatbot-converasation .chat-user,
.chatbot-wrapper .chatbot-converasation .new-user {
  max-width: 75%;
  padding: 10px 10px;
  background: #f6f6f6;
  display: inline-flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  align-items: flex-start;
  position: relative;
  margin-left: 35px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
}
.chatbot-wrapper .chatbot-converasation .chat-user p,
.chatbot-wrapper .chatbot-converasation .new-user p {
  margin: 0px !important;
}
.chatbot-wrapper .chatbot-converasation .chat-user:before,
.chatbot-wrapper .chatbot-converasation .new-user:before {
  content: "";
  background: url('chat-bot.png');
  background-repeat: no-repeat;
  background-size: contain;
  width: 30px;
  height: 30px;
  position: absolute;
  left: -35px;
  top: 50%;
  transform: translateY(-50%);
}
.chatbot-wrapper .chatbot-converasation .new-user {
  display: flex;
  justify-content: flex-end;
  float: right;
}
.chatbot-wrapper .chatbot-converasation .new-user:before {
  display: none;
}
.chatbot-wrapper .chatbot-stickyfooter {
  width: 100%;
  position: sticky;
  bottom: 0px;
  padding: 5px 20px;
  background: #5ea1d8;
  display: flex;
  height: 50px;
}
.chatbot-wrapper .chatbot-stickyfooter .input {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  flex: 1;
  margin-right: 10px;
}
.chatbot-wrapper .chatbot-stickyfooter .input input {
  width: 100%;
  border: 1px solid #000;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 0px;
  height: 40px;
  border: 0px;
  padding-left: 30px;
  outline: none !important;
}
.chatbot-wrapper .chatbot-stickyfooter .input i {
  position: absolute;
  z-index: 2;
  left: 6px;
}
.chatbot-wrapper .chatbot-stickyfooter .mic {
  width: 40px;
  height: 100%;
  background: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scroll-div {
  min-height: 224px !important;
  overflow-y: scroll;
  padding-bottom: 0px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: end;
}

.sticky-chat {
  position: sticky;
  top: -20px;
  z-index: 1000;
  padding: 10px;
  width: 100%;
  height: 104px;
}

.sticky-default {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 10000;
}
.sticky-default img {
  width: 80px;
}

.chatbot-msg {
  height: 104px;
}

.scroll-div {
  max-height: 425px;
}
.scroll-div .chatbot-msg {
  height: auto !important;
}
.scroll-div .faq-list {
  padding: 0px 20px;
}

@media (max-width: 767px) {
  .chatbot-wrapper {
    position: fixed;
    bottom: 0px;
    right: 0px;
    padding: 20px;
    display: flex;
    padding: 20px 0px 0px;
    background: #fff;
    border: 1px solid #ddd;
    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);
    margin: 0px 20px 0px 20px;
    border-radius: 10px 10px 0px 0px;
    max-width: 388px;
    width: 100%;
    box-sizing: border-box;
    z-index: 1000;
    flex-wrap: wrap;
    max-height: 400px;
    min-height: 400px;
    height: 100%;
    overflow-y: hidden;
    flex-direction: row;
    left: 0px;
  }
}
.flow-container {
  display: flex;
  gap: 20px;
}

/* Left: Expansion Panel */
.steps-panel {
  width: 100%;
  border-right: 2px solid #ddd;
  padding-right: 10px;
}

mat-expansion-panel {
  background: #f8f9fa;
  margin-bottom: 5px;
}

mat-expansion-panel-header {
  font-weight: bold;
  color: white;
  cursor: pointer;
}

mat-expansion-panel-header:hover {
  background-color: rgba(200, 193, 193, 0.5);
}

/* Right: Step Content */
.step-content {
  width: 100%;
  padding-left: 10px;
}

.step-content h3 {
  margin-bottom: 10px;
}

.step-content video,
.step-content img {
  display: block;
  margin-top: 10px;
  border-radius: 5px;
}

.viewflow-step .flow-container {
  width: 100%;
}
.viewflow-step .description {
  width: 100%;
}

.steps-list {
  margin-bottom: 10px;
  display: flex;
}
.steps-list button {
  white-space: nowrap;
  margin-bottom: 10px !important;
}

.step-scroll {
  overflow-x: scroll;
  width: 100%;
}

.toggle-container {
  display: flex;
  gap: 10px; /* Adds spacing between elements */
}

.toggle-button {
  transform: scale(1.2); /* Slightly increases the size of the checkbox */
}

.toggle-description {
  max-width: 300px; /* Adjust width as needed */
}

mat-menu {
  display: block !important;
}

/* Ensure custom menu panel is visible */
.custom-menu-panel {
  display: block !important;
  opacity: 1 !important;
  visibility: visible !important;
}
.custom-menu-panel .active {
  background-color: #5ea1d8;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}

/* Ensure parent element does not block menu */
.menu-container {
  position: relative;
  z-index: 1000;
}

/* Ensure the icon button is clickable */
.menu-icon-button {
  background: transparent;
  border: none;
  cursor: pointer;
}

/* Override any hidden styles */
.custom-mat-menu {
  display: block !important;
}

/* Hamburger Menu Styles */
.hamburger-menu {
  display: none; /* Hidden by default on desktop */
  padding: 10px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  width: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.hamburger-btn {
  background-color: #5ea1d8;
  color: white !important;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hamburger-btn .active {
  background-color: #5ea1d8;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}

.hamburger-lines {
  width: 30px;
  height: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.hamburger-lines span {
  display: block;
  width: 100%;
  height: 3px;
  background: #212529;
  border-radius: 2px;
  transition: all 0.3s ease;
}

/* Optional: Transform lines into 'X' when menu is open */
.hamburger-btn[aria-expanded=true] .hamburger-lines span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}

.hamburger-btn[aria-expanded=true] .hamburger-lines span:nth-child(2) {
  opacity: 0;
}

.hamburger-btn[aria-expanded=true] .hamburger-lines span:nth-child(3) {
  transform: rotate(-45deg) translate(6px, -6px);
}

@media screen and (min-width: 993px) {
  .mobileonly {
    display: none;
  }
  .analyticmobile {
    display: none;
  }
}
.active {
  background-color: #5ea1d8;
  color: white;
  font-weight: bold;
  border-radius: 4px;
}

body {
  overflow-x: hidden;
}

.dashbored-wrap {
  width: 100%;
  height: 100vh;
  background: #fff;
}
.dashbored-wrap .logo {
  width: 100px;
  margin-right: 100px;
}
.dashbored-wrap .top-menu-wrap {
  display: flex;
  align-items: center;
  padding: 20px 10px;
}
.dashbored-wrap .user-name {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-details {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.dashbored-wrap .user-name p {
  display: flex;
  align-items: center;
}
.dashbored-wrap .user-name span {
  width: 40px;
  height: 40px;
  background: red;
  border-radius: 50%;
  display: block;
  margin-right: 10px;
}
.dashbored-wrap .top-menu-wrap {
  width: 100%;
  height: 100px;
  background: #fff;
}
.dashbored-wrap .dash-details {
  width: 100%;
  display: flex;
  max-height: 100vh;
  /* background: green; */
}
.dashbored-wrap ul {
  list-style: none;
  padding: 0px;
  margin: 0px;
}
.dashbored-wrap p {
  margin-bottom: 10px;
}
.dashbored-wrap ul li {
  margin-bottom: 10px;
  height: 40px;
  padding: 0px 10px;
  position: relative;
  z-index: 1;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
}
.dashbored-wrap ul li:before {
  bottom: 0;
  content: "";
  display: block;
  height: 100%;
  left: 0px;
  position: absolute;
  background: #fff;
  transition: width 0.3s ease 0s, left 0.3s ease 0s;
  width: 0%;
  z-index: -1;
}
.dashbored-wrap ul li:hover {
  color: #000;
}
.dashbored-wrap ul li:hover:before {
  /* background: #fff;
  color: #212529; */
  width: 100%;
}
.dashbored-wrap .table-bordered {
  border: 0px;
}
.dashbored-wrap .detail-description {
  width: 100%;
  height: 100%;
  padding: 0px;
  position: absolute;
  /* background: purple; */
}
.dashbored-wrap .followers-tag {
  display: flex;
  position: relative;
  z-index: 1;
}
.dashbored-wrap h3 {
  position: relative;
  z-index: 3;
  color: #fff;
  font-weight: normal;
}
.dashbored-wrap .com-record {
  width: calc(100% - 250px);
  width: 100%;
  height: auto;
  position: relative;
  z-index: 0;
  padding: 20px 30px 30px;
}
.dashbored-wrap .com-record .followers-tag .box .text p.number {
  font-family: Arial !important;
}
.dashbored-wrap .com-record:after {
  content: "";
  width: 100%;
  height: 60%;
  /* background: gray; */
  top: 0px;
  position: absolute;
  left: 0px;
  z-index: 0;
  background: #5ea1d8;
}
.dashbored-wrap .ico-box {
  width: 40px;
  height: 40px;
  background: #efeeee;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dashbored-wrap .table-wrap {
  padding: 30px 30px 30px 0px;
  position: absolute;
  top: 150px;
  width: calc(100% - 30px);
  width: 100%;
  left: 0px;
  /* width:calc(100% - 76px); */
}
.dashbored-wrap .box {
  width: auto;
  padding: 5px 10px;
  background: #fff;
  margin-right: 20px;
  border: 1px solid #ddd;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);
}
.dashbored-wrap .filter-ico li {
  width: 40px;
}
.dashbored-wrap .filter-ico li i {
  color: #000;
}
.dashbored-wrap .text {
  padding-right: 10px;
}
.dashbored-wrap .table-parent {
  overflow-x: auto;
  margin-top: -8px;
  overflow-y: auto;
}
.dashbored-wrap table {
  margin-bottom: 20px;
  border-left: 0px;
  border-bottom: 0px;
  border: 0px;
  overflow-y: auto;
  width: 100%;
}
.dashbored-wrap th,
.dashbored-wrap td {
  border-bottom: 0px;
  border: 1px solid gray;
  /* background: white; */
  color: #000;
  padding: 10px 10px;
  border-width: 1px !important;
  min-width: 100px;
  font-family: "Raleway";
  vertical-align: top;
}
.dashbored-wrap th {
  background: #5ea1d8;
  color: #fff;
}
.dashbored-wrap td[scope=row] {
  position: relative;
}
.dashbored-wrap .inner {
  width: 100%;
  margin-bottom: 0px;
}
.dashbored-wrap .inner td {
  padding: 5px;
  border: 0px;
}
.dashbored-wrap .inner td:first-child {
  width: 30px;
}
.dashbored-wrap td[scope=row]:before {
  content: "";
  width: 5px;
  height: calc(100% + 2px);
  position: absolute;
  left: 0px;
  top: -1px;
  background: #5ea1d8;
}
.dashbored-wrap tbody tr:hover {
  background: #5ea1d8;
}
.dashbored-wrap tbody tr:hover td {
  color: #fff;
}
.dashbored-wrap tbody tr span {
  display: flex;
  align-items: center;
}
.dashbored-wrap .filter {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  border: 1px solid #ddd;
  border-bottom: 0px;
  padding: 10px 10px;
}
.dashbored-wrap .filter-title {
  flex: 1;
}
.dashbored-wrap .filter ul {
  display: flex;
  float: right;
}
.dashbored-wrap .filter-bar {
  display: flex;
  width: 100%;
}
.dashbored-wrap .filter-ico {
  flex: 1;
}
.dashbored-wrap .search-container {
  position: relative;
}
.dashbored-wrap .search-input {
  width: 400px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  position: relative;
}
.dashbored-wrap .search-input + i {
  position: absolute;
  right: 20px;
  top: 37%;
}
.dashbored-wrap .search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
}
.dashbored-wrap .chekbox-image {
  display: flex;
}
.dashbored-wrap .chekbox-image td:first-child {
  width: unset;
  flex: 1;
  min-width: 150px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .chekbox-image td:first-child span {
  padding-left: 13px;
}
.dashbored-wrap .chekbox-image td:last-child {
  min-width: unset;
  width: 40px;
  display: flex;
  align-items: flex-start;
}
.dashbored-wrap .image-sec img {
  max-width: 100%;
  max-height: 80px;
  object-fit: cover;
}
.dashbored-wrap .mobile-design {
  display: none;
}

@media (max-width: 992px) {
  .dashbored-wrap .detail-list {
    display: none;
  }
  .dashbored-wrap .detail-description {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .followers-tag {
    flex-wrap: wrap;
  }
  .dashbored-wrap .followers-tag .box {
    margin: 10px;
    width: 100%;
  }
  .dashbored-wrap .followers-tag .box .text {
    flex: 1;
  }
  .dashbored-wrap .com-record {
    padding: 15px;
  }
  .dashbored-wrap .com-record:after {
    height: 130px;
  }
  .dashbored-wrap .search-container .search-input {
    width: 100%;
  }
  .dashbored-wrap .top-menu-wrap {
    display: none;
  }
  .dashbored-wrap .table-wrap {
    top: unset;
  }
  .dashbored-wrap .table-wrap .table-parent {
    display: none;
  }
  .dashbored-wrap .mobile-design {
    padding: 20px 10px;
    background: lightblue;
    display: block;
  }
  .dashbored-wrap .mobile-design .tile {
    background: #fff;
    padding: 10px;
  }
  .dashbored-wrap .mobile-design .tile > div {
    border-bottom: 1px solid #ddd;
  }
  .dashbored-wrap .mobile-design .tile p {
    color: #5ea1d8 !important;
  }
  .dashbored-wrap .mobile-design .tile p.bold {
    font-weight: 700 !important;
    font-family: Arial, Helvetica, sans-serif !important;
  }
  .dashbored-wrap .mobile-design .tile .main-title {
    display: flex;
    align-items: center;
    background: #5ea1d8;
    padding: 10px;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .tile .main-title h3 {
    margin-bottom: 0px !important;
    color: #fff !important;
  }
  .dashbored-wrap .mobile-design .first-tile div {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .dashbored-wrap .mobile-design .first-tile div span {
    display: flex;
    align-items: center;
  }
  .dashbored-wrap .mobile-design .first-tile input {
    position: relative;
    margin: 0px 10px 0px 0px;
    width: 20px;
    height: 20px;
  }
  .dashbored-wrap .mobile-design .first-tile .img {
    display: flex;
    align-items: flex-start;
  }
  .dashbored-wrap .mobile-design .first-tile .img .bundle {
    width: 30px;
    margin-right: 10px;
    height: 30px;
  }
  .dashbored-wrap .mobile-design .first-tile .img img {
    width: 100%;
    max-height: 80px;
    object-fit: cover;
  }
  .dashbored-wrap .mobile-design .common-tile {
    display: flex;
  }
  .dashbored-wrap .mobile-design .common-tile .title-tile {
    flex: 1;
    padding: 3px;
  }
}
/* new setting common design starts here*/
.setting-dashboard {
  padding: 0;
  position: relative;
  margin-top: 0;
  background: #fff;
}
.setting-dashboard .row {
  flex-direction: row;
  height: 100%;
  margin: 0px;
}
.setting-dashboard .left-user {
  background: #5ea1d8;
  position: relative;
  padding: 0 0 0 30px;
  position: fixed;
  top: 120px;
  height: calc(100vh - 100px);
  z-index: 3;
}
.setting-dashboard .left-user .collapse-btn {
  position: absolute;
  width: 25px;
  height: 25px;
  background: #5ea1d8;
  border-radius: 50%;
  right: -12.5px;
  top: 26px;
  border: 2px solid #fff;
  box-shadow: 0 0 3px #171717;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  transform: rotate(180deg);
}
.setting-dashboard .left-user .dash-elemenet {
  height: calc(100vh - 180px);
}
.setting-dashboard .left-user .dash-elemenet ul {
  padding: 0px;
  margin: 0px;
  width: 100%;
  list-style-type: none;
}
.setting-dashboard .left-user .dash-elemenet ul li {
  height: 40px;
  margin-bottom: 10px;
  position: relative;
  display: flex;
  align-items: center;
  transition: all 0.5s linear;
  padding-left: 10px;
}
.setting-dashboard .left-user .dash-elemenet ul li:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #1d67a3;
  transition: all 0.5s linear;
  width: 0;
  z-index: -1;
}
.setting-dashboard .left-user .dash-elemenet ul li:hover:after, .setting-dashboard .left-user .dash-elemenet ul li:active:after, .setting-dashboard .left-user .dash-elemenet ul li:focus:after {
  content: "";
  width: 100%;
  left: 0;
  transition: all 0.5s linear;
}

.dashbored-wrap {
  padding-left: 10px;
  margin-top: 120px;
}

.setting-dashboard .left-user .dash-title {
  position: unset;
  width: 100%;
}

.setting-dashboard .dash-title {
  height: 80px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: #fff;
  position: fixed;
  z-index: 2;
  top: 120px;
}

.setting-dashboard .dash-title h6,
.setting-dashboard .dash-title .h6 {
  display: flex;
  align-items: center;
  font-weight: 500 !important;
  color: #fff !important;
}

.setting-dashboard .dash-title h6 span,
.setting-dashboard .dash-title .h6 span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

.setting-dashboard .dash-elemenet {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 1rem;
  height: calc(100vh - 220px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 20px;
}

.setting-dashboard .dash-elemenet > div {
  width: 100%;
  line-height: 26px;
  margin-bottom: 10px;
  font-size: 13px;
  font-weight: 400;
  cursor: pointer;
  color: #fff;
  transition: all 0.5slinear;
  position: relative;
  padding-bottom: 0;
  z-index: 2;
  min-height: 40px;
  display: flex;
  align-items: center;
}

.left-user .selected-item {
  background: #1d67a3 !important;
  padding-left: 10px;
}

.setting-dashboard .left-user .dash-elemenet > div span {
  width: auto !important;
  font-size: 20px;
  margin-right: 10px;
}

/* In your component CSS */
li.active {
  background: #1d67a3 !important;
  padding-left: 10px;
}

/*right section*/
.setting-dashboard .submission-field {
  left: 16.666667%;
  padding-right: 0;
  position: fixed;
  position: absolute;
  top: 0px;
  width: 83.333333%;
  padding-left: 0px;
  border-left: 1px solid #fff;
}

.setting-dashboard .submission-field .hamburger {
  width: 100%;
  background: #985ce1;
  display: flex;
  position: relative;
}

.setting-dashboard .submission-field .hamburger .dash-title {
  padding-left: 15px;
  background: #5ea1d8;
  display: flex;
  color: #fff;
  width: 83.333333%;
}

.scroll-div {
  position: sticky;
  top: 180px !important;
  margin-top: 80px !important;
  width: 100%;
  padding-bottom: 20px;
}
.scroll-div .dash-text {
  padding: 15px 15px 0;
  padding: 15px;
}

.mat-mdc-tab-group {
  display: flex;
  flex-direction: column;
  max-width: 100%;
}

.setting-dashboard .dash-elemenet > div:after {
  bottom: 0;
  content: "";
  display: block;
  height: 1px;
  height: 100%;
  left: 0%;
  position: absolute;
  background: #fff;
  background: #6322b2;
  transition: width 0.5sease 0s, left 0.5sease 0s;
  width: 0;
  z-index: -1;
}

.setting-dashboard .dash-elemenet > div span:last-child {
  font-size: 12px !important;
}

@media (max-width: 767px) {
  /* Make the mobile Settings subheader stick right under the app header */
  .mob-menu {
    background: #5d9fd5 !important;
    position: sticky;
    top: var(--app-header, 56px);
    z-index: 1500;
    width: 100%;
    display: block !important;
  }
  .navbar {
    justify-content: flex-start;
    margin-bottom: 0px;
  }
  .mob-menu button {
    background: #5d9fd5 !important;
    margin-bottom: 0 !important;
    color: #fff;
    font-size: 14px;
    padding: 10px 5px;
    text-transform: capitalize;
    border: 1px solid #fff !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center;
  }
  /* Override mob-hide when show-menu is applied */
  .setting-dashboard .row.show-menu,
  .setting-dashboard .show-menu.mob-hide,
  .setting-dashboard .mob-hide.show-menu {
    display: block !important;
  }
  /* Slide-in left menu should start below header + subheader */
  .setting-dashboard .left-user {
    width: 59vw;
    position: fixed;
    top: calc(var(--app-header, 56px) + 48px);
    height: calc(100vh - (var(--app-header, 56px) + 48px));
    padding-left: 10px;
    left: -59vw;
    transition: left 0.5s linear;
    display: block !important;
    z-index: 1600;
  }
  .setting-dashboard .show-menu .left-user {
    left: 0px;
    transition: left 0.5s linear;
  }
  .setting-dashboard .submission-field {
    width: 100%;
    left: 0px;
  }
  .dashbored-wrap .table-wrap {
    padding: 0px;
  }
  .setting-dashboard .submission-field .hamburger .dash-title {
    width: 100%;
    top: calc(var(--app-header, 56px) + 48px);
    height: 40px;
  }
  .setting-dashboard .left-user .dash-title {
    display: none;
  }
  .setting-dashboard .left-user .collapse-btn {
    display: none;
  }
  /* Push page content below the sticky subheader */
  .dashbored-wrap .mobile-design {
    padding: 20px;
  }
  .dashbored-wrap .com-record:after {
    height: 133px;
  }
}
/* NOTE: We intentionally do NOT hide the Settings subheader or left menu on small
   screens anymore so that the mobile hamburger + slide-out menu continue to work
   consistently across dashboard and settings pages. */
/* Dark mode foundation for settings + child pages */
:host-context(body.theme-dark) {
  /* Hardening: catch routed child content outside dashbored-wrap */
  /* Title/header bars: remove white patches */
  /* Title card container (child pages) */
}
:host-context(body.theme-dark) .setting-dashboard,
:host-context(body.theme-dark) .dashbored-wrap,
:host-context(body.theme-dark) .dashbored-wrap .top-menu-wrap,
:host-context(body.theme-dark) .dashbored-wrap .detail-description,
:host-context(body.theme-dark) .dashbored-wrap .table-wrap,
:host-context(body.theme-dark) .dashbored-wrap .com-record,
:host-context(body.theme-dark) .dashbored-wrap .mobile-design,
:host-context(body.theme-dark) .dashbored-wrap .tile,
:host-context(body.theme-dark) .dashbored-wrap .box,
:host-context(body.theme-dark) .dashbored-wrap .filter,
:host-context(body.theme-dark) .dashbored-wrap .search-input,
:host-context(body.theme-dark) .dashbored-wrap .detail-list,
:host-context(body.theme-dark) .settings-container,
:host-context(body.theme-dark) .setting-page,
:host-context(body.theme-dark) .price-per-slot {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
  box-shadow: none !important;
}
:host-context(body.theme-dark) .setting-dashboard .left-user,
:host-context(body.theme-dark) .setting-dashboard .dash-title,
:host-context(body.theme-dark) .setting-dashboard .submission-field {
  background: #0f172a !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dashbored-wrap p,
:host-context(body.theme-dark) .dashbored-wrap span,
:host-context(body.theme-dark) .dashbored-wrap label,
:host-context(body.theme-dark) .dashbored-wrap li,
:host-context(body.theme-dark) .dashbored-wrap td,
:host-context(body.theme-dark) .dashbored-wrap th,
:host-context(body.theme-dark) .dashbored-wrap h1,
:host-context(body.theme-dark) .dashbored-wrap h2,
:host-context(body.theme-dark) .dashbored-wrap h3,
:host-context(body.theme-dark) .dashbored-wrap h4,
:host-context(body.theme-dark) .dashbored-wrap h5,
:host-context(body.theme-dark) .dashbored-wrap h6,
:host-context(body.theme-dark) .dashbored-wrap i,
:host-context(body.theme-dark) .setting-label,
:host-context(body.theme-dark) .prefix {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .dashbored-wrap table,
:host-context(body.theme-dark) .dashbored-wrap thead,
:host-context(body.theme-dark) .dashbored-wrap tbody,
:host-context(body.theme-dark) .dashbored-wrap tr,
:host-context(body.theme-dark) .dashbored-wrap td,
:host-context(body.theme-dark) .dashbored-wrap th {
  background: #111827 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .dashbored-wrap tbody tr:hover {
  background: #1f2937 !important;
}
:host-context(body.theme-dark) .setting-page input,
:host-context(body.theme-dark) .setting-page select,
:host-context(body.theme-dark) .setting-page textarea,
:host-context(body.theme-dark) .setting-input,
:host-context(body.theme-dark) .toggle-button {
  background: #0f172a !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.35) !important;
}
:host-context(body.theme-dark) .dashbored-wrap [style*="background: white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:white"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: #fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:#fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: #ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:#ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: #fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:#fff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: #ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:#ffffff"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: rgb(255, 255, 255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background:rgb(255,255,255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: rgb(255, 255, 255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color:rgb(255,255,255)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background: var(--white)"],
:host-context(body.theme-dark) .dashbored-wrap [style*="background-color: var(--white)"] {
  background: #111827 !important;
  background-color: #111827 !important;
  color: #ffffff !important;
}
:host-context(body.theme-dark) .setting-dashboard router-outlet ~ *,
:host-context(body.theme-dark) .setting-dashboard router-outlet + *,
:host-context(body.theme-dark) .setting-dashboard .submission-field > *,
:host-context(body.theme-dark) .setting-dashboard .submission-field > * *,
:host-context(body.theme-dark) .setting-dashboard .detail-description,
:host-context(body.theme-dark) .setting-dashboard .detail-description *,
:host-context(body.theme-dark) .setting-dashboard .scroll-div,
:host-context(body.theme-dark) .setting-dashboard .scroll-div * {
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .setting-dashboard router-outlet ~ *[style*=background],
:host-context(body.theme-dark) .setting-dashboard router-outlet + *[style*=background],
:host-context(body.theme-dark) .setting-dashboard .submission-field *[style*=background],
:host-context(body.theme-dark) .setting-dashboard .detail-description *[style*=background],
:host-context(body.theme-dark) .setting-dashboard .scroll-div *[style*=background] {
  background: #111827 !important;
  background-color: #111827 !important;
}
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-card,
:host-context(body.theme-dark) .setting-dashboard .mat-card,
:host-context(body.theme-dark) .setting-dashboard .mat-expansion-panel,
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-tab-body-content,
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-tab-body,
:host-context(body.theme-dark) .setting-dashboard .mat-mdc-tab-body-wrapper,
:host-context(body.theme-dark) .setting-dashboard .table,
:host-context(body.theme-dark) .setting-dashboard table,
:host-context(body.theme-dark) .setting-dashboard tbody,
:host-context(body.theme-dark) .setting-dashboard tr,
:host-context(body.theme-dark) .setting-dashboard td {
  background: #111827 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .setting-dashboard .dash-title,
:host-context(body.theme-dark) .setting-dashboard .submission-field .hamburger .dash-title,
:host-context(body.theme-dark) .setting-dashboard .left-user .dash-title,
:host-context(body.theme-dark) .page-section-header,
:host-context(body.theme-dark) .page-section-title {
  background: transparent !important;
  background-color: transparent !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .dash-text,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .dash-text > div,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .main-title,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .title-tile,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .page-section-header,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .page-header,
:host-context(body.theme-dark) ::ng-deep .setting-dashboard .header-section {
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/settings/settings.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,kBAAA;AAEF;;AAAA;EACE,aAAA;AAGF;;AADA;EACE,cAAA;AAIF;;AAFA;EACE;IACE,cAAA;EAKF;EAHA;IACE,wBAAA;EAKF;AACF;AAHA;EACE,YAAA;EACA,mBAAA;AAKF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAMF;;AAJA;EACE,aAAA;EACA,mBAAA;AAOF;;AALA;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AAQF;;AANA;EACE,aAAA;EACA,mBAAA;AASF;;AAPA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAUF;;AARA;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAUF;;AARA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAUF;;AAPA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAUF;;AARA;EACE,mBAAA;AAWF;;AATA;EACE,kBAAA;EACA,8CAAA;EACA,WAAA;AAYF;;AATA;EACE,aAAA;AAYF;;AAVA;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AAYF;;AAVA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AAaF;;AAXA;EACE,WAAA;AAcF;;AAZA;EACE;qBAAA;EAEA,WAAA;AAeF;;AAbA;EACE,WAAA;AAgBF;;AAdA;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;AAiBF;;AAdA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AAiBF;;AAfA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AAkBF;;AAhBA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAmBF;AAVQ;EACE,6BAAA;AAYV;;AANA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AASF;;AANA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AASF;;AAPA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,6BAAA;AAUF;;AARA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;AAWF;;AATA;EACE,WAAA;AAYF;;AAVA;EACE,WAAA;AAaF;;AAXA;EACE,mBAAA;AAcF;;AAZA;EACE,gBAAA;EACA,gBAAA;EAEA,gBAAA;AAcF;;AAZA;EACE,mBAAA;EAGA,gBAAA;EACA,kBAAA;EACA,WAAA;EAEA,gBAAA;EACA,WAAA;AAYF;;AAVA;;EAEE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AAaF;;AAXA;EACE,mBAAA;EACA,WAAA;AAcF;;AAZA;EACE,kBAAA;AAeF;;AAHA;EACE,WAAA;EACA,kBAAA;AAMF;AALE;EACE,YAAA;EACA,WAAA;AAOJ;AANI;EACE,WAAA;AAQN;;AAJA;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;AAOF;;AADE;EACE,mBAAA;AAIJ;AAHI;EACE,WAAA;AAKN;AAFE;EACE,aAAA;EACA,mBAAA;AAIJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAJF;;AAQA;EACE,OAAA;AALF;;AAOA;EACE,aAAA;EACA,YAAA;AAJF;;AAMA;EACE,aAAA;EACA,WAAA;AAHF;;AAKA;EACE,OAAA;AAFF;;AAIA;EACE,kBAAA;AADF;;AAIA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AADF;;AAGA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAAF;;AAGA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;AAEI;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAAN;AACM;EACE,kBAAA;AACR;AAEI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAAN;;AAKE;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;AAHJ;;AAYA;EACE,aAAA;AATF;;AAYA;EACE;IACE,aAAA;EATF;EAWA;IACE,WAAA;IACA,SAAA;EATF;EAWA;IACE,eAAA;EATF;EAUE;IACE,YAAA;IACA,WAAA;EARJ;EASI;IACE,OAAA;EAPN;EAWA;IACE,aAAA;EATF;EAUE;IACE,aAAA;EARJ;EAeE;IACE,WAAA;EAbJ;EAgBA;IACE,aAAA;EAdF;EAgBA;IACE,UAAA;EAdF;EAeE;IACE,aAAA;EAbJ;EAgBA;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;EAdF;EAeE;IACE,gBAAA;IACA,aAAA;EAbJ;EAcI;IACE,6BAAA;EAZN;EAcI;IACE,yBAAA;EAZN;EAcI;IACE,2BAAA;IACA,oDAAA;EAZN;EAcI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EAZN;EAaM;IACE,6BAAA;IACA,sBAAA;EAXR;EAgBI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EAdN;EAeM;IACE,aAAA;IACA,mBAAA;EAbR;EAiBI;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EAfN;EAiBI;IACE,aAAA;IACA,uBAAA;EAfN;EAgBM;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EAdR;EAgBM;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EAdR;EAkBE;IACE,aAAA;EAhBJ;EAiBI;IACE,OAAA;IACA,YAAA;EAfN;AACF;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,2DAAA;AAlBF;;AAqBA;EACE,mCAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;AAlBF;;AAqBA;EACE,2BAAA;AAlBF;;AAqBA;EAEE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,WAAA;AAnBF;;AAsBA;EACE,cAAA;EACA,mBAAA;AAnBF;;AAsBA;;EAEE,mBAAA;AAnBF;;AAsBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAnBF;;AAsBA;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AAnBF;;AAqBA;EACE,yBAAA;EACA,YAAA;AAlBF;;AAoBA,eAAA;AACA;EACE,yBAAA;EACA,WAAA;AAjBF;;AAoBA;;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,yBAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,yBAAA;AAjBF;;AAoBA;EACE,sBAAA;EACA,WAAA;AAjBF;;AAoBA;EACE,4BAAA;EACA,iBAAA;AAjBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,UAAA,EAAA,kCAAA;EACA,oBAAA,EAAA,yCAAA;AAhBF;;AAmBA;EACE,kBAAA,EAAA,4CAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAhBF;;AAmBE;;EAEE,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAhBJ;AAmBI;EACE,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,0BAAA;AAjBN;;AAsBA;EACE,2BAAA;EACA,kBAAA;AAnBF;;AAsBA;EACE,kBAAA;AAnBF;;AAqBA;EACE,YAAA;EACA,mBAAA;AAlBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAjBF;;AAmBA;EACE,aAAA;EACA,mBAAA;AAhBF;;AAkBA;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AAfF;;AAiBA;EACE,aAAA;EACA,mBAAA;AAdF;;AAgBA;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAbF;;AAeA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;AAZF;;AAcA;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAZF;;AAcA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAZF;;AAeA;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAZF;;AAcA;EACE,mBAAA;AAXF;;AAaA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;AAVF;;AAaA;EACE,aAAA;AAVF;;AAYA;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AAVF;;AAYA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AATF;;AAWA;EACE,WAAA;AARF;;AAUA;EACE;qBAAA;EAEA,WAAA;AAPF;;AASA;EACE,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;AANF;;AASA;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AANF;;AAQA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AALF;;AAOA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAJF;AAaQ;EACE,6BAAA;AAXV;;AAiBA;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAdF;;AAiBA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAdF;;AAgBA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;AAbF;;AAeA;EACE,WAAA;AAZF;;AAcA;EACE,WAAA;AAXF;;AAaA;EACE,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAVF;;AAcA;EACE,OAAA;AAXF;;AAaA;EACE,aAAA;EACA,YAAA;AAVF;;AAYA;EACE,aAAA;EACA,WAAA;AATF;;AAWA;EACE,OAAA;AARF;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAPF;;AASA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AANF;;AASA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AANF;;AASA;EACE,aAAA;AANF;AAQI;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AANN;AAOM;EACE,kBAAA;AALR;AAQI;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AANN;;AAWE;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;AATJ;;AAkBA;EACE,aAAA;AAfF;;AAkBA;EACE;IACE,aAAA;EAfF;EAiBA;IACE,WAAA;IACA,SAAA;EAfF;EAiBA;IACE,eAAA;EAfF;EAgBE;IACE,YAAA;IACA,WAAA;EAdJ;EAeI;IACE,OAAA;EAbN;EAiBA;IACE,aAAA;EAfF;EAgBE;IACE,aAAA;EAdJ;EAqBE;IACE,WAAA;EAnBJ;EAsBA;IACE,aAAA;EApBF;EAsBA;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;EApBF;EAqBE;IACE,gBAAA;IACA,aAAA;EAnBJ;EAoBI;IACE,6BAAA;EAlBN;EAoBI;IACE,yBAAA;EAlBN;EAoBI;IACE,2BAAA;IACA,oDAAA;EAlBN;EAoBI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EAlBN;EAmBM;IACE,6BAAA;IACA,sBAAA;EAjBR;EAsBI;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EApBN;EAqBM;IACE,aAAA;IACA,mBAAA;EAnBR;EAuBI;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EArBN;EAuBI;IACE,aAAA;IACA,uBAAA;EArBN;EAsBM;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EApBR;EAsBM;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EApBR;EAwBE;IACE,aAAA;EAtBJ;EAuBI;IACE,OAAA;IACA,YAAA;EArBN;AACF;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,cAAA;AAxBF;;AA2BA;EACE,eAAA;EACA,WAAA;EACA,eAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,2DAAA;AAxBF;;AA2BA;EACE,mCAAA;AAxBF;;AA2BA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,+BAAA;AAxBF;;AA2BA;EACE,2BAAA;AAxBF;;AA2BA;EAEE,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,WAAA;AAzBF;;AA4BA;EACE,cAAA;EACA,mBAAA;AAzBF;;AA4BA;;EAEE,mBAAA;AAzBF;;AA4BA;EACE,UAAA;EACA,gBAAA;EACA,eAAA;AAzBF;;AA2BA;EACE,yBAAA;EACA,YAAA;AAxBF;;AA0BA;EACE,4BAAA;EACA,iBAAA;AAvBF;;AAyBA;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AAtBF;;AAyBA;EACE,kBAAA;EACA,UAAA,EAAA,kCAAA;EACA,oBAAA,EAAA,yCAAA;AAtBF;;AAyBA;EACE,kBAAA,EAAA,4CAAA;AAtBF;;AAyBA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AAtBF;;AAyBE;;EAEE,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AAtBJ;;AA0BA;EACE,2BAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,YAAA;EACA,WAAA;AAvBF;;AAyBA;EACE,mBAAA;EACA,6BAAA;AAtBF;;AAwBA;EACE,mBAAA;EAEA,iBAAA;EA0iBA,kCAAA;AA/jBF;AAsBE;EACE,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;AApBJ;AAqBI;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAnBN;AAoBM;EACE,OAAA;EACA,aAAA;AAlBR;AAmBQ;EACE,OAAA;EACA,wBAAA;AAjBV;AAkBU;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;AAhBZ;AAmBQ;EACE,OAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AAjBV;AAmBU;EACE,8BAAA;EACA,0BAAA;EACA,oCAAA;AAjBZ;AAmBU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AAjBZ;AAkBY;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAhBd;AAkBc;EACE,WAAA;EACA,kBAAA;EACA,cAAA;AAhBhB;AAkBkB;EACE,qCAAA;EACA,2BAAA;AAhBpB;AAiBoB;EACE,qCAAA;EACA,eAAA;AAftB;AAsBY;EACE,kBAAA;AApBd;AAsBY;EACE,OAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;AApBd;AAqBc;EACE,2BAAA;EACA,cAAA;AAnBhB;AAsBY;EACE,sBAAA;AApBd;AAuBc;EACE,iBAAA;AArBhB;AAwBY;EACE,kBAAA;EACA,eAAA;AAtBd;AAyBU;EACE,eAAA;EACA,kBAAA;EACA,aAAA;AAvBZ;AAwBY;EACE,gBAAA;EACA,WAAA;EACA,aAAA;AAtBd;AAwBc;EACE,YAAA;EACA,2BAAA;AAtBhB;AAuBgB;EACE,eAAA;EACA,WAAA;EACA,iDAAA;EACA,kBAAA;AArBlB;AAuBgB;EACE,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;AArBlB;AA+BY;EACE,OAAA;EACA,iBAAA;AA7Bd;AAmCI;EACE,wBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;EACA,2BAAA;AAjCN;AAmCM;EACE,kBAAA;EACA,iCAAA;EACA,2BAAA;EACA,mBAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;AAjCR;AAkCQ;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,OAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;EACA,2BAAA;AAhCV;AAiCU;EACE,UAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;AA/BZ;AAiCU;EACE,iBAAA;EACA,mBAAA;AA/BZ;AAiCU;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EAEA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAhCZ;AAiCY;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EAEA,WAAA;AAhCd;AAoCQ;EACE,aAAA;EACA,mBAAA;AAlCV;AAmCU;EACE,OAAA;AAjCZ;AAkCY;EACE,2BAAA;AAhCd;AAkCY;EACE,sBAAA;EACA,eAAA;AAhCd;AAmCU;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAjCZ;AAkCY;EACE,aAAA;EACA,mBAAA;AAhCd;AAqCM;EACE,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,OAAA;EACA,mBAAA;AAnCR;AAoCQ;EACE,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAlCV;AAoCU;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;AAlCZ;AAqCQ;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,gBAAA;AApCV;AAqCU;EAEE,0BAAA;EACA,YAAA;EACA,iBAAA;EAEA,gBAAA;EACA,sBAAA;AArCZ;AAuCU;EACE,kCAAA;EACA,2BAAA;EACA,sBAAA;AArCZ;AA+EE;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;AA7EJ;AA+EI;EACE,kBAAA;EACA,8BAAA;EACA,+CAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;AA9EN;AA+EM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AA7ER;AAgFI;EACE,kBAAA;EACA,8BAAA;EACA,+CAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,UAAA;AA/EN;AAiFM;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,cAAA;AA/ER;AA+FE;EACE,sBAAA;EACA,gBAAA;EACA,uBAAA;EAGA,wBAAA;EACA,mBAAA;EACA,kBAAA;AA/FJ;AAgGI;EAEE,eAAA;EACA,6BAAA;AA/FN;AAiGI;EACE,4BAAA;EACA,uBAAA;EAAA,kBAAA;EACA,2BAAA;AA/FN;AAiGI;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AA/FN;AAkGQ;EACE,wBAAA;AAhGV;AAoGQ;EACE,uBAAA;AAlGV;AAwGE;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAtGJ;AAuGI;EACE,OAAA;EACA,eAAA;EACA,WAAA;AArGN;AAuGI;EACE,gBAAA;AArGN;AAiIE;;EAEE,yBAAA;EACA,8BAAA;EACA,eAAA;EACA,aAAA;AA/HJ;AAiIE;EACE,WAAA;AA/HJ;AAkIE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAhIJ;AAkIE;EACE,iBAAA;EAEA,WAAA;EAEA,eAAA;EACA,mBAAA;AAlIJ;AAoIE;EACE,mBAAA;EACA,YAAA;AAlIJ;AAqIE;EACE,sBAAA;EACA,mBAAA;AAnIJ;AAoII;EACE,yBAAA;AAlIN;AAqIE;EACE,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAnIJ;AAsIE;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AApIJ;AAsIE;EACE,OAAA;EAEA,mBAAA;EACA,uBAAA;EACA,sBAAA;AArIJ;AA2II;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;AAzIN;AAwJM;EACE,oBAAA;AAtJR;AAgKQ;EACE,iBAAA;EACA,gBAAA;AA9JV;AA0KE;EACE,OAAA;EACA,sBAAA;AAxKJ;AA0KE;EACE,eAAA;AAxKJ;AA0KE;EACE,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;AAxKJ;AA0KE;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AAxKJ;AA0KE;EACE,iBAAA;AAxKJ;AA0KE;EACE,OAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iDAAA;EACA,gBAAA;AAxKJ;AA0KE;EACE,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;AAxKJ;AA0KE;EACE,aAAA;EACA,sBAAA;EACA,OAAA;EACA,oBAAA;EACA,YAAA;AAxKJ;AA0KE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,kBAAA;AAzKJ;AA0KI;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iDAAA;AAxKN;AA0KI;EACE,iBAAA;AAxKN;AAyKM;EACE,aAAA;AAvKR;AA2KE;EACE,gBAAA;AAzKJ;AAkLE;EAEE,0BAAA;EAEA,gBAAA;EACA,sBAAA;AAlLJ;AAoLE;EACE,wBAAA;AAlLJ;;AAqLA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AApLF;;AAsLA;EACE,YAAA;EAEA,8BAAA;EACA,iHAAA;EAEA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AArLF;;AAuLA;EACE,UAAA;EACA,aAAA;AApLF;;AAsLA;EACE,oDAAA;AAnLF;;AAqLA;EACE,yBAAA;EACA,0BAAA;AAlLF;;AAqLA;EACE,UAAA;EACA,aAAA;AAlLF;;AAoLA;EACE,oDAAA;AAjLF;;AAmLA;EACE,yBAAA;EACA,0BAAA;AAhLF;;AAmLA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,iDAAA;AAhLF;;AAyLA;EACE,aAAA;EACA,gBAAA;AAtLF;;AAwLA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;AArLF;;AAuLA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AApLF;;AAsLA;EACE,iCAAA;EACA,sCAAA;AAnLF;;AAsLA;EACE,eAAA;AAnLF;;AAsLA;EAGI;IACE,0BAAA;EArLJ;AACF;AAyLA;EAEI;IACE,aAAA;IACA,sBAAA;IACA,sBAAA;EAxLJ;EAyLI;IACE,sBAAA;EAvLN;EA0LM;IACE,sBAAA;IACA,QAAA;EAxLR;EAyLQ;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;EAvLV;EAyLQ;IACE,YAAA;EAvLV;EA0Lc;IACE,eAAA;EAxLhB;EA4LU;IACE,aAAA;IAEA,gBAAA;EA3LZ;EA4LY;IACE,gBAAA;EA1Ld;EA6LgB;IACE,eAAA;EA3LlB;EAgMc;IACE,4BAAA;EA9LhB;EAoMM;IACE,iBAAA;EAlMR;EAsME;IACE,sBAAA;IACA,WAAA;IACA,mBAAA;EApMJ;EAqMI;IACE,iBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;EAnMN;EAuMY;IACE,2BAAA;EArMd;EAyMQ;IACE,aAAA;IACA,sBAAA;IACA,UAAA;IACA,cAAA;EAvMV;EAwMU;IACE,kBAAA;EAtMZ;EAmNE;IACE,WAAA;IACA,qBAAA;EAjNJ;EAmNI;IACE,gBAAA;IACA,gBAAA;IACA,kCAAA;IACA,oBAAA;EAjNN;EAmNM;IACE,oBAAA;IAEA,kBAAA;EAlNR;EAqNI;IACE,YAAA;IACA,gBAAA;IACA,WAAA;EAnNN;EAuNM;IACE,WAAA;IACA,YAAA;EArNR;EAmOE;IACE,iBAAA;EAjOJ;EAsOI;IACE,sBAAA;IACA,2BAAA;IACA,0BAAA;EApON;EAqOM;IACE,WAAA;IACA,yBAAA;EAnOR;EAsOI;IACE,sBAAA;EApON;EAwOA;IACE,WAAA;IACA,WAAA;EAtOF;EAwOA;IACE,6BAAA;IACA,sCAAA;EAtOF;AACF;AA0OE;EACE,cAAA;AAxOJ;;AA4OE;;EAEE,aAAA;AAzOJ;;AA4OA;EAIQ;IACE,mBAAA;EA5OR;EA+OQ;IACE,kBAAA;IACA,eAAA;EA7OV;EA+OY;IACE,kBAAA;EA7Od;EAgPc;IACE,6BAAA;EA9OhB;EAoPc;IACE,0BAAA;EAlPhB;EAyPI;IACE,WAAA;IAGA,iBAAA;EAzPN;EA4PQ;IACE,iBAAA;EA1PV;EAgQQ;IACE,oBAAA;IAEA,kBAAA;EA/PV;EAmQQ;IACE,WAAA;EAjQV;EAmQQ;IACE,UAAA;EAjQV;AACF;AAwQA;EAIQ;IACE,WAAA;IACA,YAAA;EAzQR;EA0QQ;IACE,WAAA;EAxQV;EA0QQ;IACE,YAAA;EAxQV;AACF;AA8QA;EACE;IAQE,0BAAA;EAnRF;EAsRE;IACE,eAAA;EApRJ;EAwRE;IACE,WAAA;IACA,YAAA;EAtRJ;EAuRI;IACE,SAAA;EArRN;EAyRI;IACE,UAAA;EAvRN;EA6RA;IACE,WAAA;IACA,gBAAA;EA3RF;EA6RA;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,kBAAA;EA3RF;EA4RE;IACE,6BAAA;IACA,SAAA;EA1RJ;EA6RI;IACE,aAAA;IACA,mBAAA;EA3RN;EAoSE;;IAEE,cAAA;EAlSJ;EAuSE;IACE,wBAAA;EArSJ;EAySE;IACE,wBAAA;EAvSJ;EA0SA;IACE,0BAAA;IACA,sBAAA;EAxSF;EA0SA;IACE,aAAA;IACA,WAAA;EAxSF;EA0SA;IACE,iBAAA;EAxSF;EA0SA;IACE,iBAAA;EAxSF;EA6SA;IACE,iBAAA;EA3SF;EA6SA;IACE,cAAA;EA3SF;EA6SA;IACE,YAAA;IACA,iBAAA;EA3SF;AACF;AA8SA;EACE,2BAAA;EACA,8BAAA;EAEA,sBAAA;EACA,sBAAA;EACA,0BAAA;EACA,6BAAA;AA7SF;;AAgTA;EACE;IACE,uBAAA;EA7SF;AACF;AAgTA;EACE,eAAA;EAGA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,sBAAA;EAEA,gBAAA;AAjTF;AAkTE;EACE,aAAA;EACA,kBAAA;EACA,kCAAA;EACA,4BAAA;EACA,OAAA;EACA,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAhTJ;AAiTI;EACE,gBAAA;EACA,UAAA;AA/SN;AAkTI;EACE,gBAAA;EACA,UAAA;AAhTN;AAmTI;;;;EAIE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;AAjTN;AAmTI;;EAEE,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;AAjTN;AAmTI;EACE,kBAAA;AAjTN;AAmTI;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,iBAAA;AAjTN;AAmTI;EACE,OAAA;EACA,yBAAA;EACA,8BAAA;AAjTN;AAmTI;EACE,yBAAA;AAjTN;AAoTE;EACE,UAAA;EACA,aAAA;AAlTJ;AAoTE;EACE,oDAAA;AAlTJ;AAoTE;EACE,yBAAA;EACA,0BAAA;AAlTJ;;AAsTA;EACE,kBAAA;EACA,kCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAnTF;AAoTE;EACE,UAAA;EACA,wBAAA;AAlTJ;AAmTI;EACE,UAAA;AAjTN;AAmTI;EACE,UAAA;AAjTN;AAmTI;EAEE,gBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAlTN;AAoTM;EACE,OAAA;EACA,UAAA;EACA,qCAAA;EACA,2BAAA;AAlTR;AAoTM;EACE,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,qCAAA;EACA,2BAAA;AAlTR;;AAyTI;EACE,qBAAA;AAtTN;AA8TA;EACE,eAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AA5TF;AA6TE;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;AA3TJ;;AA8TA,yBAAA;AAGI;EACE,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AA7TN;AA8TM;EACE,qBAAA;AA5TR;AA6TQ;EACE,2BAAA;AA3TV;AA4TU;EACE,mCAAA;EACA,iBAAA;EACA,uBAAA;AA1TZ;AA4TU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA1TZ;AA4TU;EACE,aAAA;AA1TZ;AA2TY;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AAzTd;;AAiUA;EACE,aAAA;EACA,yBAAA;AA9TF;;AAiUA;EAIQ;IACE,qBAAA;EAjUR;EAmUU;IACE,aAAA;IACA,mBAAA;EAjUZ;EAkUY;IACE,sBAAA;EAhUd;EAkUY;IACE,sBAAA;EAhUd;EAkUY;IACE,4BAAA;EAhUd;AACF;AAwUA;EAIQ;IACE,qBAAA;EAzUR;EA2UU;IACE,aAAA;IACA,mBAAA;EAzUZ;EA0UY;IACE,sBAAA;EAxUd;EA0UY;IACE,sBAAA;EAxUd;EA0UY;IACE,4BAAA;EAxUd;AACF;AA2VE;EACE,6BAAA;EACA,4BAAA;AAzVJ;AA2VE;EACE,6BAAA;AAzVJ;;AA6VA;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AA1VF;;AAyWA;EACE,wBAAA;EACA,2BAAA;AAtWF;;AAyWA;EACE,WAAA;AAtWF;;AAyWA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,cAAA;AAtWF;;AAyWA;EACE,kBAAA;EAGA,qBAAA;EACA,qFAAA;AAxWF;;AA2WA;;;EAGE,0BAAA;AAxWF;;AA2WA;EACE,0BAAA;AAxWF;;AA2WA;EACE,eAAA;AAxWF;;AA2WA;EACE,aAAA;AAxWF;;AA2WA;EACE,aAAA;EACA,mBAAA;AAxWF;;AA0WA;EACE,mBAAA;AAvWF;;AAyWA;EACE,YAAA;EAEA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;AAvWF;;AA2WE;EACE,qBAAA;AAxWJ;AA0WE;EACE,YAAA;EACA,gBAAA;AAxWJ;AAgXE;EACE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AA9WJ;AA+WI;EACE,WAAA;AA7WN;AA+WI;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA7WN;AA8WM;EACE,uBAAA;AA5WR;AAgXI;EACE,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AA9WN;AA+WM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AA7WR;AA+WM;EACE,iBAAA;EACA,uBAAA;EACA,WAAA;AA7WR;AAgXI;EACE,WAAA;EACA,wBAAA;EACA,6BAAA;AA9WN;AAgXI;EACE,aAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AA9WN;;AAmXA;EAEI;IACE,qBAAA;IACA,iBAAA;EAjXJ;EAmXE;IACE,yBAAA;IACA,qBAAA;IACA,qBAAA;EAjXJ;EAsXE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EApXJ;EAqXI;IACE,WAAA;EAnXN;EAqXI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAnXN;EAqXI;IACE,0BAAA;IACA,sBAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;IACA,0BAAA;EAnXN;EAoXM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAlXR;EAoXM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAlXR;EAqXI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EAnXN;EAqXI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EAnXN;AACF;AAuXA;EAEI;IACE,qBAAA;IACA,iBAAA;EAtXJ;EAwXE;IACE,yBAAA;IACA,qBAAA;IACA,qBAAA;EAtXJ;EA2XE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,mBAAA;EAzXJ;EA0XI;IACE,WAAA;EAxXN;EA0XI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAxXN;EA0XI;IACE,0BAAA;IACA,sBAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EAxXN;EAyXM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAvXR;EAyXM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAvXR;EA0XI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EAxXN;EA0XI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EAxXN;EA4XA;IACE,kBAAA;EA1XF;AACF;AA4XA;EAEI;IACE,qBAAA;IACA,iBAAA;EA3XJ;EA6XE;IACE,2BAAA;IACA,uBAAA;IACA,UAAA;EA3XJ;EAoYE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EAlYJ;EAmYI;IACE,WAAA;EAjYN;EAmYI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAjYN;EAmYI;IACE,WAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EAjYN;EAkYM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAhYR;EAkYM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAhYR;EAkYM;IACE,0BAAA;IACA,sBAAA;EAhYR;EAmYI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EAjYN;EAmYI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EAjYN;EAqYA;IACE,kBAAA;EAnYF;AACF;AAqYA;EAEI;IACE,qBAAA;IACA,iBAAA;EApYJ;EAsYE;IACE,yBAAA;IACA,qBAAA;IACA,UAAA;EApYJ;EA6YE;IACE,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,gBAAA;IACA,yBAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;EA3YJ;EA4YI;IACE,WAAA;EA1YN;EA4YI;IACE,oBAAA;IACA,qBAAA;IACA,4BAAA;IACA,gBAAA;IACA,uBAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EA1YN;EA4YI;IACE,WAAA;IACA,sBAAA;IACA,aAAA;IACA,mBAAA;EA1YN;EA2YM;IACE,WAAA;IACA,YAAA;IACA,kBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,iBAAA;EAzYR;EA2YM;IACE,iBAAA;IACA,uBAAA;IACA,WAAA;EAzYR;EA2YM;IACE,0BAAA;IACA,sBAAA;EAzYR;EA4YI;IACE,WAAA;IACA,wBAAA;IACA,6BAAA;EA1YN;EA4YI;IACE,aAAA;IACA,iBAAA;IACA,WAAA;IACA,yBAAA;EA1YN;EA8YA;IACE,iBAAA;EA5YF;AACF;AA4ZA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,uBAAA;AA1ZF;AA4ZE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AA1ZJ;;AAkaE;EACE,OAAA;AA/ZJ;;AAmaA,oCAAA;AAGI;EACE,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AAlaN;AAmaM;EACE,qBAAA;AAjaR;AAkaQ;EACE,2BAAA;AAhaV;AAiaU;EACE,mCAAA;EACA,iBAAA;EACA,uBAAA;AA/ZZ;AAiaU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA/ZZ;AAiaU;EACE,aAAA;AA/ZZ;AAgaY;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AA9Zd;;AAuaA;EAIQ;IACE,qBAAA;EAvaR;EAyaU;IACE,aAAA;IACA,mBAAA;EAvaZ;EAwaY;IACE,sBAAA;EAtad;EAwaY;IACE,sBAAA;EAtad;EAwaY;IACE,4BAAA;EAtad;AACF;AA8aA;EAIQ;IACE,qBAAA;EA/aR;EAibU;IACE,aAAA;IACA,mBAAA;EA/aZ;EAgbY;IACE,sBAAA;EA9ad;EAgbY;IACE,sBAAA;EA9ad;EAgbY;IACE,4BAAA;EA9ad;AACF;AAubA;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AArbF;AAubE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AArbJ;;AA0bI;EACE,aAAA;AAvbN;AAwbM;EACE,sCAAA;AAtbR;;AAicE;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;EACA,6BAAA;AA9bJ;;AAocI;EACE,2BAAA;EACA,aAAA;EACA,2BAAA;EACA,WAAA;AAjcN;AAkcM;EACE,qBAAA;AAhcR;AAicQ;EACE,2BAAA;AA/bV;AAgcU;EACE,mCAAA;EACA,iBAAA;EACA,uBAAA;AA9bZ;AAgcU;EACE,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;AA9bZ;AAgcU;EACE,aAAA;AA9bZ;AA+bY;EACE,sBAAA;EACA,uBAAA;EACA,8BAAA;AA7bd;;AAscA;EAIQ;IACE,qBAAA;EAtcR;EAwcU;IACE,aAAA;IACA,mBAAA;EAtcZ;EAucY;IACE,sBAAA;EArcd;EAucY;IACE,sBAAA;EArcd;EAucY;IACE,4BAAA;EArcd;AACF;AA6cA;EAIQ;IACE,qBAAA;EA9cR;EAgdU;IACE,aAAA;IACA,mBAAA;EA9cZ;EA+cY;IACE,sBAAA;EA7cd;EA+cY;IACE,sBAAA;EA7cd;EA+cY;IACE,4BAAA;EA7cd;AACF;AAsdA;EACE;IACE,sBAAA;EApdF;EAsdA;IACE,sBAAA;IACA,2BAAA;EApdF;EAsdA;IACE,YAAA;IACA,iBAAA;EApdF;AACF;AAsdA;EACE;IACE,YAAA;IACA,WAAA;IACA,2BAAA;IACA,0BAAA;IACA,sBAAA;IACA,uBAAA;IACA,sBAAA;EApdF;EAsdE;IACE,YAAA;IACA,gCAAA;EApdJ;EAsdI;IACE,WAAA;EApdN;EAwdA;IACE,kBAAA;IACA,UAAA;EAtdF;AACF;AA+dA;EACE,0BAAA;EACA,sBAAA;EACA,qCAAA;EACA,iBAAA;AA7dF;;AAgeA;EACE,0BAAA;EACA,sBAAA;AA7dF;;AAgeA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;AA7dF;AA8dE;EACE,aAAA;AA5dJ;AA8dE;EACE,WAAA;EACA,cAAA;EACA,mBAAA;AA5dJ;AA8dE;EACE,aAAA;EACA,eAAA;EACA,WAAA;AA5dJ;AA6dI;EACE,sCAAA;EACA,kBAAA;AA3dN;;AAgeA;EACE,cAAA;EACA,WAAA;EACA,cAAA;EACA,2BAAA;EACA,sBAAA;EACA,iBAAA;AA7dF;AA+dE;EACE,sCAAA;AA7dJ;AA8dI;EACE,cAAA;AA5dN;;AAgeA;EACE,mBAAA;AA7dF;;AA+dA;EACE,uBAAA,EAAA,kBAAA,EACA,YAAA,EACA,UAAA;EACA,yBAAA;UAAA,iBAAA,EAAA,oBAAA;EACA,eAAA,EAAA,sCAAA;EACA,qCAAA;AA5dF;;AA8dA;EACE,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AA3dF;AA4dE;EACE,sBAAA;AA1dJ;;AA6dA;EACE,qBAAA;AA1dF;;AAqeA;EACE;IACE,oCAAA;IACA,4BAAA;EAleF;EAmeE;IACE,0BAAA;EAjeJ;EAoeA;IACE,8BAAA;EAleF;EAoeA;IACE,2BAAA;EAleF;AACF;AA2eE;EACE,kBAAA;AAzeJ;AA0eI;EACE,kBAAA;AAxeN;;AA6eA,iBAAA;AACA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,sBAAA;EACA,iDAAA;EACA,yBAAA;EACA,gCAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;EAEA,iBAAA;EAEA,8BAAA;EACA,kBAAA;EACA,mBAAA;AA5eF;AA8eE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AA5eJ;AA8eE;EACE,iBAAA;EACA,WAAA;AA5eJ;AA8eM;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,mBAAA;AA5eR;AA+eQ;EACE,WAAA;AA7eV;AAgfM;EACE,WAAA;EACA,mBAAA;AA9eR;AA+eQ;EACE,sBAAA;EACA,0BAAA;EACA,8BAAA;AA7eV;AA+eQ;EACE,sBAAA;EACA,2BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AA7eV;AAgfM;EACE,mBAAA;AA9eR;AAgfM;EACE,aAAA;EACA,eAAA;AA9eR;AA+eQ;EACE,WAAA;EACA,2BAAA;EACA,uBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,kCAAA;AA7eV;AA8eU;EACE,aAAA;EACA,wCAAA;EACA,mBAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;AA5eZ;AA6eY;EACE,sBAAA;AA3ed;AAkfE;EACE,WAAA;EAEA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,OAAA;EACA,mBAAA;AAjfJ;AAkfI;EACE,WAAA;AAhfN;AAmfE;EACE,mBAAA;EACA,iBAAA;EACA,WAAA;AAjfJ;AAkfI;;EAEE,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,2CAAA;AAhfN;AAifM;;EACE,sBAAA;AA9eR;AAgfM;;EACE,WAAA;EACA,+BAAA;EAEA,4BAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AA9eR;AAifI;EACE,aAAA;EACA,yBAAA;EACA,YAAA;AA/eN;AAgfM;EACE,aAAA;AA9eR;AAkfE;EACE,WAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;AAhfJ;AAifI;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;EACA,kBAAA;AA/eN;AAifM;EACE,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AA/eR;AAifM;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AA/eR;AAkfI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAhfN;;AAqfA;EAKE,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AAtfF;;AA2fA;EACE,gBAAA;EACA,UAAA;EACA,aAAA;EAGA,aAAA;EACA,WAAA;EACA,aAAA;AA1fF;;AA4fA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAzfF;AA4fE;EACE,WAAA;AA1fJ;;AA6fA;EACE,aAAA;AA1fF;;AA4fA;EACE,iBAAA;AAzfF;AA0fE;EAEE,uBAAA;AAzfJ;AA2fE;EACE,iBAAA;AAzfJ;;AA6fA;EACE;IACE,eAAA;IACA,WAAA;IACA,UAAA;IACA,aAAA;IACA,aAAA;IACA,qBAAA;IACA,gBAAA;IACA,sBAAA;IACA,iDAAA;IACA,yBAAA;IACA,gCAAA;IACA,gBAAA;IACA,WAAA;IACA,sBAAA;IACA,aAAA;IACA,eAAA;IACA,iBAAA;IACA,iBAAA;IACA,YAAA;IACA,kBAAA;IACA,mBAAA;IACA,SAAA;EA1fF;AACF;AA6fA;EACE,aAAA;EACA,SAAA;AA3fF;;AA8fA,0BAAA;AACA;EACE,WAAA;EACA,4BAAA;EACA,mBAAA;AA3fF;;AA8fA;EACE,mBAAA;EACA,kBAAA;AA3fF;;AA8fA;EACE,iBAAA;EAEA,YAAA;EACA,eAAA;AA5fF;;AA+fA;EAEE,0CAAA;AA7fF;;AAggBA,wBAAA;AACA;EACE,WAAA;EACA,kBAAA;AA7fF;;AAggBA;EACE,mBAAA;AA7fF;;AAggBA;;EAEE,cAAA;EACA,gBAAA;EACA,kBAAA;AA7fF;;AAigBE;EACE,WAAA;AA9fJ;AAggBE;EACE,WAAA;AA9fJ;;AAigBA;EACE,mBAAA;EAEA,aAAA;AA/fF;AAggBE;EACE,mBAAA;EACA,8BAAA;AA9fJ;;AAigBA;EACE,kBAAA;EACA,WAAA;AA9fF;;AAigBA;EACE,aAAA;EAEA,SAAA,EAAA,kCAAA;AA/fF;;AAkgBA;EACE,qBAAA,EAAA,gDAAA;AA/fF;;AAkgBA;EACE,gBAAA,EAAA,2BAAA;AA/fF;;AAigBA;EACE,yBAAA;AA9fF;;AAggBA,wCAAA;AACA;EACE,yBAAA;EACA,qBAAA;EACA,8BAAA;AA7fF;AA+fE;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA7fJ;;AAigBA,8CAAA;AACA;EACE,kBAAA;EACA,aAAA;AA9fF;;AAigBA,wCAAA;AACA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;AA9fF;;AAigBA,+BAAA;AACA;EACE,yBAAA;AA9fF;;AAggBA,0BAAA;AACA;EACE,aAAA,EAAA,iCAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,WAAA;EACA,wCAAA;AA7fF;;AAggBA;EACE,yBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA7fF;AAggBE;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA9fJ;;AAkgBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AA/fF;;AAkgBA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;AA/fF;;AAkgBA,yDAAA;AACA;EACE,4CAAA;AA/fF;;AAkgBA;EACE,UAAA;AA/fF;;AAkgBA;EACE,8CAAA;AA/fF;;AAigBA;EACE;IACE,aAAA;EA9fF;EAggBA;IACE,aAAA;EA9fF;AACF;AAggBA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA9fF;;AAmgBA;EACE,kBAAA;AAhgBF;;AAmgBA;EACE,WAAA;EACA,aAAA;EACA,gBAAA;AAhgBF;AAigBE;EACE,YAAA;EACA,mBAAA;AA/fJ;AAigBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;AA/fJ;AAigBE;EACE,aAAA;EACA,mBAAA;AA/fJ;AAigBE;EACE,OAAA;EACA,aAAA;EACA,yBAAA;AA/fJ;AAigBE;EACE,aAAA;EACA,mBAAA;AA/fJ;AAigBE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AA/fJ;AAkgBE;EACE,WAAA;EACA,aAAA;EAEA,gBAAA;AAjgBJ;AAmgBE;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EAEA,uBAAA;AAlgBJ;AAqgBE;EACE,gBAAA;EACA,YAAA;EACA,WAAA;AAngBJ;AAqgBE;EACE,mBAAA;AAngBJ;AA2gBE;EACE,mBAAA;EACA,YAAA;EAEA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,iDAAA;AA1gBJ;AA4gBE;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,iDAAA;EACA,SAAA;EACA,WAAA;AA1gBJ;AA4gBE;EACE,WAAA;AA1gBJ;AA4gBE;EACE;mBAAA;EAEA,WAAA;AA1gBJ;AA4gBE;EACE,WAAA;AA1gBJ;AA4gBE;EACE,WAAA;EACA,YAAA;EACA,YAAA;EAEA,kBAAA;EAGA,wBAAA;AA7gBJ;AAghBE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;AA9gBJ;AAghBE;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;AA9gBJ;AAghBE;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AA9gBJ;AAuhBU;EACE,6BAAA;AArhBZ;AA2hBE;EACE,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AAzhBJ;AA2hBE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAzhBJ;AA2hBE;EACE,2BAAA;EACA,kBAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;AAzhBJ;AA2hBE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oDAAA;AAzhBJ;AA2hBE;EACE,WAAA;AAzhBJ;AA2hBE;EACE,WAAA;AAzhBJ;AA2hBE;EACE,mBAAA;AAzhBJ;AA2hBE;EACE,gBAAA;EACA,gBAAA;EAEA,gBAAA;AA1hBJ;AA4hBE;EACE,mBAAA;EAGA,gBAAA;EACA,kBAAA;EACA,WAAA;EAEA,gBAAA;EACA,WAAA;AA7hBJ;AA+hBE;;EAEE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AA7hBJ;AA+hBE;EACE,mBAAA;EACA,WAAA;AA7hBJ;AA+hBE;EACE,kBAAA;AA7hBJ;AAyiBE;EACE,WAAA;EACA,kBAAA;AAviBJ;AAwiBI;EACE,YAAA;EACA,WAAA;AAtiBN;AAuiBM;EACE,WAAA;AAriBR;AAyiBE;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,mBAAA;AAviBJ;AA6iBI;EACE,mBAAA;AA3iBN;AA4iBM;EACE,WAAA;AA1iBR;AA6iBI;EACE,aAAA;EACA,mBAAA;AA3iBN;AAsjBE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AApjBJ;AAwjBE;EACE,OAAA;AAtjBJ;AAwjBE;EACE,aAAA;EACA,YAAA;AAtjBJ;AAwjBE;EACE,aAAA;EACA,WAAA;AAtjBJ;AAwjBE;EACE,OAAA;AAtjBJ;AAwjBE;EACE,kBAAA;AAtjBJ;AAyjBE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AAvjBJ;AAyjBE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;AAvjBJ;AA0jBE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AAxjBJ;AA2jBE;EACE,aAAA;AAzjBJ;AA2jBM;EACE,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AAzjBR;AA0jBQ;EACE,kBAAA;AAxjBV;AA2jBM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AAzjBR;AA8jBI;EACE,eAAA;EACA,gBAAA;EAEA,iBAAA;AA7jBN;AAskBE;EACE,aAAA;AApkBJ;;AAukBA;EAEI;IACE,aAAA;EArkBJ;EAukBE;IACE,WAAA;IACA,SAAA;EArkBJ;EAukBE;IACE,eAAA;EArkBJ;EAskBI;IACE,YAAA;IACA,WAAA;EApkBN;EAqkBM;IACE,OAAA;EAnkBR;EAukBE;IACE,aAAA;EArkBJ;EAskBI;IACE,aAAA;EApkBN;EA2kBI;IACE,WAAA;EAzkBN;EA4kBE;IACE,aAAA;EA1kBJ;EA4kBE;IACE,UAAA;EA1kBJ;EA2kBI;IACE,aAAA;EAzkBN;EA4kBE;IACE,kBAAA;IACA,qBAAA;IACA,cAAA;EA1kBJ;EA2kBI;IACE,gBAAA;IACA,aAAA;EAzkBN;EA0kBM;IACE,6BAAA;EAxkBR;EA0kBM;IACE,yBAAA;EAxkBR;EA0kBM;IACE,2BAAA;IACA,oDAAA;EAxkBR;EA0kBM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,aAAA;IACA,mBAAA;EAxkBR;EAykBQ;IACE,6BAAA;IACA,sBAAA;EAvkBV;EA4kBM;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EA1kBR;EA2kBQ;IACE,aAAA;IACA,mBAAA;EAzkBV;EA6kBM;IACE,kBAAA;IACA,wBAAA;IACA,WAAA;IACA,YAAA;EA3kBR;EA6kBM;IACE,aAAA;IACA,uBAAA;EA3kBR;EA4kBQ;IACE,WAAA;IACA,kBAAA;IACA,YAAA;EA1kBV;EA4kBQ;IACE,WAAA;IACA,gBAAA;IACA,iBAAA;EA1kBV;EA8kBI;IACE,aAAA;EA5kBN;EA6kBM;IACE,OAAA;IACA,YAAA;EA3kBR;AACF;AAilBA,yCAAA;AAEA;EACE,UAAA;EAEA,kBAAA;EACA,aAAA;EACA,gBAAA;AAjlBF;AAklBE;EACE,mBAAA;EACA,YAAA;EACA,WAAA;AAhlBJ;AAklBE;EACE,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;EACA,2BAAA;EACA,UAAA;AAhlBJ;AAilBI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;AA/kBN;AAilBI;EACE,2BAAA;AA/kBN;AAglBM;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,qBAAA;AA9kBR;AA+kBQ;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;AA7kBV;AA8kBU;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;AA5kBZ;AA8kBU;EAGE,WAAA;EACA,WAAA;EACA,OAAA;EACA,2BAAA;AA9kBZ;;AAqlBA;EACE,kBAAA;EACA,iBAAA;AAllBF;;AAqlBA;EACE,eAAA;EACA,WAAA;AAllBF;;AAolBA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,UAAA;AAjlBF;;AAmlBA;;EAEE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;AAhlBF;;AAklBA;;EAEE,sBAAA;EACA,eAAA;EACA,kBAAA;AA/kBF;;AAklBA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;EACA,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AA/kBF;;AAilBA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AA9kBF;;AAglBA;EACE,8BAAA;EACA,kBAAA;AA7kBF;;AA+kBA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;AA5kBF;;AA8kBA,0BAAA;AACA;EACE,8BAAA;EACA,kBAAA;AA3kBF;;AA8kBA,gBAAA;AACA;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;AA3kBF;;AA6kBA;EACE,WAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AA1kBF;;AA4kBA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EAEA,WAAA;EAEA,iBAAA;AA3kBF;;AA6kBA;EACE,gBAAA;EACA,qBAAA;EACA,2BAAA;EACA,WAAA;EACA,oBAAA;AA1kBF;AA2kBE;EACE,oBAAA;EACA,aAAA;AAzkBJ;;AA6kBA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AA1kBF;;AA6kBA;EACE,SAAA;EACA,WAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,+CAAA;EACA,QAAA;EACA,WAAA;AA1kBF;;AA4kBA;EACE,0BAAA;AAzkBF;;AA4kBA;EACE,wEAAA;EACA;IACE,8BAAA;IACA,gBAAA;IACA,4BAAA;IACA,aAAA;IACA,WAAA;IACA,yBAAA;EAzkBF;EA2kBA;IACE,2BAAA;IACA,kBAAA;EAzkBF;EA2kBA;IACE,8BAAA;IACA,2BAAA;IACA,WAAA;IACA,eAAA;IACA,iBAAA;IACA,0BAAA;IACA,iCAAA;IACA,2BAAA;IACA,wBAAA;IACA,mBAAA;EAzkBF;EA2kBA,gDAAA;EACA;;;IAGE,yBAAA;EAzkBF;EA2kBA,6DAAA;EACA;IACE,WAAA;IACA,eAAA;IACA,yCAAA;IACA,sDAAA;IACA,kBAAA;IACA,WAAA;IACA,4BAAA;IACA,yBAAA;IACA,aAAA;EAzkBF;EA2kBA;IACE,SAAA;IACA,4BAAA;EAzkBF;EA2kBA;IACE,WAAA;IACA,SAAA;EAzkBF;EA2kBA;IACE,YAAA;EAzkBF;EA2kBA;IACE,WAAA;IACA,yCAAA;IACA,YAAA;EAzkBF;EA2kBA;IACE,aAAA;EAzkBF;EA2kBA;IACE,aAAA;EAzkBF;EA2kBA,iDAAA;EAIA;IACE,aAAA;EA5kBF;EA8kBA;IACE,aAAA;EA5kBF;AACF;AA+kBA;;sDAAA;AAIA,oDAAA;AACA;EA+FE,iEAAA;EAsCA,4CAAA;EAYA,uCAAA;AA5tBF;AA4kBE;;;;;;;;;;;;;;;EAeE,8BAAA;EACA,yBAAA;EACA,iDAAA;EACA,2BAAA;AA1kBJ;AA6kBE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AA3kBJ;AA8kBE;;;;;;;;;;;;;;;EAeE,yBAAA;AA5kBJ;AA+kBE;;;;;;EAME,8BAAA;EACA,iDAAA;AA7kBJ;AAglBE;EACE,8BAAA;AA9kBJ;AAilBE;;;;;EAKE,8BAAA;EACA,yBAAA;EACA,kDAAA;AA/kBJ;AAklBE;;;;;;;;;;;;;;;;;;EAkBE,8BAAA;EACA,oCAAA;EACA,yBAAA;AAhlBJ;AAolBE;;;;;;;;EAQE,yBAAA;EACA,iDAAA;AAllBJ;AAqlBE;;;;;EAKE,8BAAA;EACA,oCAAA;AAnlBJ;AAslBE;;;;;;;;;;;EAWE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAplBJ;AAwlBE;;;;;EAKE,kCAAA;EACA,wCAAA;EACA,yBAAA;EACA,iDAAA;AAtlBJ;AA0lBE;;;;;;;EAOE,kCAAA;EACA,wCAAA;EACA,2BAAA;EACA,yBAAA;AAxlBJ","sourcesContent":["body {\n  overflow-x: hidden;\n}\n.mob-menu {\n  display: none;\n}\n.mob-hide {\n  display: block;\n}\n@media (max-width: 955px) {\n  .mob-menu {\n    display: block;\n  }\n  .mob-hide {\n    display: none !important;\n  }\n}\n.logo {\n  width: 100px;\n  margin-right: 100px;\n}\n.top-menu-wrap {\n  display: flex;\n  align-items: center;\n  padding: 20px 10px;\n}\n.user-name {\n  display: flex;\n  align-items: center;\n}\n.user-details {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n.user-name p {\n  display: flex;\n  align-items: center;\n}\n.user-name span {\n  width: 40px;\n  height: 40px;\n  background: red;\n  border-radius: 50%;\n  display: block;\n  margin-right: 10px;\n}\n.top-menu-wrap {\n  width: 100%;\n  height: 100px;\n\n  background: #fff;\n}\n.dash-details {\n  width: 100%;\n  display: flex;\n  max-height: 100vh;\n\n  /* background: green; */\n}\n\nul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\np {\n  margin-bottom: 10px;\n}\n.scroll-div {\n  position: absolute;\n  top: calc(var(--app-header) + 24px) !important;\n  width: 100%;\n}\n\n.scroll-div .dash-text {\n  padding: 15px;\n}\nul li {\n  margin-bottom: 10px;\n  height: 40px;\n\n  padding: 0px 10px;\n  position: relative;\n  z-index: 1;\n  color: #212529;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n}\nul li:before {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0px;\n  position: absolute;\n  background: #fff;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  width: 0%;\n  z-index: -1;\n}\nul li:hover {\n  color: #000;\n}\nul li:hover:before {\n  /* background: #fff;\n    color: #212529; */\n  width: 100%;\n}\n.table-bordered {\n  border: 0px;\n}\n.detail-description {\n  /* width: 100%; */\n  height: 100%;\n  padding: 0px;\n  width: calc(100% - 250px);\n  position: absolute;\n  left: 250px;\n  top: 120px;\n  /* background: purple; */\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\nh3 {\n  position: relative;\n  z-index: 3;\n  color: #fff;\n  font-weight: normal;\n}\n.com-record {\n  width: calc(100% - 250px);\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  // position: fixed;\n  // top:80px;\n  // left:250px;\n  // background: white;\n  // z-index: 100;\n  .followers-tag {\n    .box {\n      .text {\n        p.number {\n          font-family: Arial !important;\n        }\n      }\n    }\n  }\n}\n.com-record:after {\n  content: \"\";\n  width: 100%;\n  height: 60%;\n  /* background: gray; */\n  top: 0px;\n  position: absolute;\n  left: 0px;\n  z-index: 0;\n  //background: #ffffff;\n}\n.ico-box {\n  width: 40px;\n  height: 40px;\n  background: #efeeee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.table-wrap {\n  padding: 30px;\n  position: absolute;\n  top: 150px;\n  width: 100%;\n  /* width:calc(100% - 76px); */\n}\n.box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n}\n.filter-ico li {\n  width: 40px;\n}\n.filter-ico li i {\n  color: #000;\n}\n.text {\n  padding-right: 10px;\n}\n.table-parent {\n  overflow-x: auto;\n  margin-top: -8px;\n  // max-height: 400px;\n  overflow-y: auto;\n}\ntable {\n  margin-bottom: 20px;\n  // border-collapse:separate;\n  // border-spacing:0 0.5em;\n  border-left: 0px;\n  border-bottom: 0px;\n  border: 0px;\n  // max-height: 600px;\n  overflow-y: auto;\n  width: 100%;\n}\nth,\ntd {\n  border-bottom: 0px;\n  border: 1px solid gray;\n  /* background: white; */\n  color: #000;\n  padding: 10px 10px;\n  border-width: 1px !important;\n  min-width: 100px;\n  font-family: \"Raleway\";\n  vertical-align: top;\n}\nth {\n  background: #fefeff;\n  color: #fff;\n}\ntd[scope=\"row\"] {\n  position: relative;\n  // display: flex;\n  // flex-direction: column;\n  // &>div{\n  //   display: flex;\n  //   align-items: flex-start;\n  //   div{\n  //     margin: 0px !important;\n  //     width: 40px;\n  //   }\n  // }\n}\n.inner {\n  width: 100%;\n  margin-bottom: 0px;\n  td {\n    padding: 5px;\n    border: 0px;\n    &:first-child {\n      width: 30px;\n    }\n  }\n}\ntd[scope=\"row\"]:before {\n  content: \"\";\n  width: 5px;\n  height: calc(100% + 2px);\n  position: absolute;\n  left: 0px;\n  top: -1px;\n  background: #ffffff;\n}\ntbody tr {\n  &:first-child {\n    // display: flex;\n  }\n  &:hover {\n    background: #ffffff;\n    td {\n      color: #000;\n    }\n  }\n  span {\n    display: flex;\n    align-items: center;\n  }\n}\n// tr:nth-child(even){\n//     background: #5ea1d8;\n\n// }\n// tr:nth-child(even) td{\n//     color: #fff;\n// }\n\n.filter {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0px;\n  border: 1px solid #ddd;\n  border-bottom: 0px;\n  padding: 10px 10px;\n  // position: fixed;\n  // width:calc(100% - 250px);\n}\n.filter-title {\n  flex: 1;\n}\n.filter ul {\n  display: flex;\n  float: right;\n}\n.filter-bar {\n  display: flex;\n  width: 100%;\n}\n.filter-ico {\n  flex: 1;\n}\n.search-container {\n  position: relative;\n}\n\n.search-input {\n  width: 400px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  position: relative;\n}\n.search-input + i {\n  position: absolute;\n  right: 20px;\n  top: 37%;\n}\n\n.search-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.chekbox-image {\n  display: flex;\n  td {\n    &:first-child {\n      width: unset;\n      flex: 1;\n      min-width: 150px;\n      display: flex;\n      align-items: flex-start;\n      span {\n        padding-left: 13px;\n      }\n    }\n    &:last-child {\n      min-width: unset;\n      width: 40px;\n      display: flex;\n      align-items: flex-start;\n    }\n  }\n}\n.image-sec {\n  img {\n    max-width: 100%;\n    max-height: 80px;\n    // width: 100%;\n    object-fit: cover;\n  }\n}\n.bundel {\n  span {\n    img {\n    }\n  }\n}\n.mobile-design {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .detail-list {\n    display: none;\n  }\n  .detail-description {\n    width: 100%;\n    left: 0px;\n  }\n  .followers-tag {\n    flex-wrap: wrap;\n    .box {\n      margin: 10px;\n      width: 100%;\n      .text {\n        flex: 1;\n      }\n    }\n  }\n  .com-record {\n    padding: 15px;\n    &:after {\n      height: 130px;\n    }\n  }\n  .filter {\n    // display: none;\n  }\n  .search-container {\n    .search-input {\n      width: 100%;\n    }\n  }\n  .top-menu-wrap {\n    display: none;\n  }\n  .table-wrap {\n    top: unset;\n    .table-parent {\n      display: none;\n    }\n  }\n  .mobile-design {\n    padding: 20px 10px;\n    background: lightblue;\n    display: block;\n    .tile {\n      background: #fff;\n      padding: 10px;\n      & > div {\n        border-bottom: 1px solid #ddd;\n      }\n      p {\n        color: #5ea1d8 !important;\n      }\n      p.bold {\n        font-weight: 700 !important;\n        font-family: Arial, Helvetica, sans-serif !important;\n      }\n      .main-title {\n        display: flex;\n        align-items: center;\n        background: #5ea1d8;\n        padding: 10px;\n        margin-bottom: 10px;\n        h3 {\n          margin-bottom: 0px !important;\n          color: #fff !important;\n        }\n      }\n    }\n    .first-tile {\n      div {\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n        span {\n          display: flex;\n          align-items: center;\n        }\n      }\n\n      input {\n        position: relative;\n        margin: 0px 10px 0px 0px;\n        width: 20px;\n        height: 20px;\n      }\n      .img {\n        display: flex;\n        align-items: flex-start;\n        .bundle {\n          width: 30px;\n          margin-right: 10px;\n          height: 30px;\n        }\n        img {\n          width: 100%;\n          max-height: 80px;\n          object-fit: cover;\n        }\n      }\n    }\n    .common-tile {\n      display: flex;\n      .title-tile {\n        flex: 1;\n        padding: 3px;\n      }\n    }\n  }\n}\n\n.setting-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n\n.setting-label {\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n}\n\n.toggle-button {\n  width: 40px;\n  height: 20px;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #ddd;\n  border-radius: 10px;\n  position: relative;\n  outline: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.toggle-button:checked {\n  background-color: rgb(94, 161, 216);\n}\n\n.toggle-button:before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.2s ease;\n}\n\n.toggle-button:checked:before {\n  transform: translateX(20px);\n}\n\n.settings-container {\n  //  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  width: 100%;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 10px;\n}\n\nh3,\nh4 {\n  margin-bottom: 20px;\n}\n\n.price-per-slot {\n  margin-top: 20px;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  background-color: #f9f9f9;\n}\n\n.error {\n  color: red;\n  font-size: 0.9em;\n  margin-top: 5px;\n}\n.btn-primary {\n  background-color: #5ea1d8;\n  border: none;\n}\n/* styles.css */\ntable {\n  border-collapse: collapse;\n  width: 100%;\n}\n\nth,\ntd {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: left;\n}\n\nth {\n  background-color: #5ea1d8;\n  color: #fff;\n}\n\ntr:nth-child(even) {\n  background-color: #f2f2f2;\n}\n\ntr:hover {\n  background-color: #ddd;\n  color: #000;\n}\n\n.generate-btn {\n  padding: 10px 20px 10px 10px;\n  text-align: right;\n}\n.input-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.prefix {\n  position: absolute;\n  left: 10px; /* Adjust based on input padding */\n  pointer-events: none; /* Prevent interactions with the prefix */\n}\n\n.input-container input {\n  padding-left: 17px; /* Add padding to make room for the £ sign */\n}\n\n.setting-btn {\n  padding: 10px;\n  border: 1px solid #5ea1d8;\n  border-radius: 18px;\n  display: block;\n  margin: 0 12px 12px 0;\n}\n.setting-page {\n  input[type=\"time\"],\n  input[type=\"number\"] {\n    max-width: 100%;\n    height: 40px;\n    width: 100%;\n    margin-bottom: 10px;\n    border: 1px solid lightgray;\n    border-radius: 5px;\n  }\n  table {\n    button {\n      padding: 5px 10px;\n      border: 1px solid #5ea1d8;\n      border-radius: 18px;\n      display: block;\n      margin: 0 12px 12px 0;\n      font-size: 12px !important;\n    }\n  }\n}\n\n.setting-input {\n  border: 1px solid lightgray;\n  border-radius: 5px;\n}\n\nbody {\n  overflow-x: hidden;\n}\n.logo {\n  width: 100px;\n  margin-right: 100px;\n}\n.top-menu-wrap {\n  display: flex;\n  align-items: center;\n  padding: 20px 10px;\n}\n.user-name {\n  display: flex;\n  align-items: center;\n}\n.user-details {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n}\n.user-name p {\n  display: flex;\n  align-items: center;\n}\n.user-name span {\n  width: 40px;\n  height: 40px;\n  background: red;\n  border-radius: 50%;\n  display: block;\n  margin-right: 10px;\n}\n.dashbored-wrap {\n  width: 100%;\n  height: 100vh;\n  background: #fff;\n  /* background: red; */\n}\n.top-menu-wrap {\n  width: 100%;\n  height: 100px;\n\n  background: #fff;\n}\n.dash-details {\n  width: 100%;\n  display: flex;\n  max-height: 100vh;\n\n  /* background: green; */\n}\n\nul {\n  list-style: none;\n  padding: 0px;\n  margin: 0px;\n}\np {\n  margin-bottom: 10px;\n}\n.scroll-div {\n  position: absolute;\n  top: 120px !important;\n  width: 100%;\n}\n\n.scroll-div .dash-text {\n  padding: 15px;\n}\nul li {\n  margin-bottom: 10px;\n  height: 40px;\n\n  padding: 0px 10px;\n  position: relative;\n  z-index: 1;\n  color: #212529;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n}\nul li:before {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 100%;\n  left: 0px;\n  position: absolute;\n  background: #fff;\n  transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  width: 0%;\n  z-index: -1;\n}\nul li:hover {\n  color: #000;\n}\nul li:hover:before {\n  /* background: #fff;\n    color: #212529; */\n  width: 100%;\n}\n.detail-description {\n  /* width: 100%; */\n  height: 100%;\n  padding: 0px;\n  width: calc(100% - 250px);\n  position: absolute;\n  left: 250px;\n  top: 120px;\n  /* background: purple; */\n}\n\n.followers-tag {\n  display: flex;\n  position: relative;\n  z-index: 1;\n}\nh3 {\n  position: relative;\n  z-index: 3;\n  color: #fff;\n  font-weight: normal;\n}\n.com-record {\n  width: calc(100% - 250px);\n  width: 100%;\n  height: auto;\n  position: relative;\n  z-index: 0;\n  padding: 20px 30px 30px;\n  // position: fixed;\n  // top:80px;\n  // left:250px;\n  // background: white;\n  // z-index: 100;\n  .followers-tag {\n    .box {\n      .text {\n        p.number {\n          font-family: Arial !important;\n        }\n      }\n    }\n  }\n}\n.com-record:after {\n  content: \"\";\n  width: 100%;\n  height: 60%;\n  /* background: gray; */\n  top: 0px;\n  position: absolute;\n  left: 0px;\n  z-index: 0;\n  //background: #ffffff;\n}\n.ico-box {\n  width: 40px;\n  height: 40px;\n  background: #efeeee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.box {\n  width: auto;\n  padding: 5px 10px;\n  background: #fff;\n  margin-right: 20px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n}\n.filter-ico li {\n  width: 40px;\n}\n.filter-ico li i {\n  color: #000;\n}\n.text {\n  padding-right: 10px;\n}\n\n.filter {\n  display: flex;\n  align-items: center;\n  margin-bottom: 0px;\n  border: 1px solid #ddd;\n  border-bottom: 0px;\n  padding: 10px 10px;\n  // position: fixed;\n  // width:calc(100% - 250px);\n}\n.filter-title {\n  flex: 1;\n}\n.filter ul {\n  display: flex;\n  float: right;\n}\n.filter-bar {\n  display: flex;\n  width: 100%;\n}\n.filter-ico {\n  flex: 1;\n}\n.search-container {\n  position: relative;\n}\n\n.search-input {\n  width: 400px;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  position: relative;\n}\n.search-input + i {\n  position: absolute;\n  right: 20px;\n  top: 37%;\n}\n\n.search-icon {\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n}\n\n.chekbox-image {\n  display: flex;\n  td {\n    &:first-child {\n      width: unset;\n      flex: 1;\n      min-width: 150px;\n      display: flex;\n      align-items: flex-start;\n      span {\n        padding-left: 13px;\n      }\n    }\n    &:last-child {\n      min-width: unset;\n      width: 40px;\n      display: flex;\n      align-items: flex-start;\n    }\n  }\n}\n.image-sec {\n  img {\n    max-width: 100%;\n    max-height: 80px;\n    // width: 100%;\n    object-fit: cover;\n  }\n}\n.bundel {\n  span {\n    img {\n    }\n  }\n}\n.mobile-design {\n  display: none;\n}\n\n@media (max-width: 992px) {\n  .detail-list {\n    display: none;\n  }\n  .detail-description {\n    width: 100%;\n    left: 0px;\n  }\n  .followers-tag {\n    flex-wrap: wrap;\n    .box {\n      margin: 10px;\n      width: 100%;\n      .text {\n        flex: 1;\n      }\n    }\n  }\n  .com-record {\n    padding: 15px;\n    &:after {\n      height: 130px;\n    }\n  }\n  .filter {\n    // display: none;\n  }\n  .search-container {\n    .search-input {\n      width: 100%;\n    }\n  }\n  .top-menu-wrap {\n    display: none;\n  }\n  .mobile-design {\n    padding: 20px 10px;\n    background: lightblue;\n    display: block;\n    .tile {\n      background: #fff;\n      padding: 10px;\n      & > div {\n        border-bottom: 1px solid #ddd;\n      }\n      p {\n        color: #5ea1d8 !important;\n      }\n      p.bold {\n        font-weight: 700 !important;\n        font-family: Arial, Helvetica, sans-serif !important;\n      }\n      .main-title {\n        display: flex;\n        align-items: center;\n        background: #5ea1d8;\n        padding: 10px;\n        margin-bottom: 10px;\n        h3 {\n          margin-bottom: 0px !important;\n          color: #fff !important;\n        }\n      }\n    }\n    .first-tile {\n      div {\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n        span {\n          display: flex;\n          align-items: center;\n        }\n      }\n\n      input {\n        position: relative;\n        margin: 0px 10px 0px 0px;\n        width: 20px;\n        height: 20px;\n      }\n      .img {\n        display: flex;\n        align-items: flex-start;\n        .bundle {\n          width: 30px;\n          margin-right: 10px;\n          height: 30px;\n        }\n        img {\n          width: 100%;\n          max-height: 80px;\n          object-fit: cover;\n        }\n      }\n    }\n    .common-tile {\n      display: flex;\n      .title-tile {\n        flex: 1;\n        padding: 3px;\n      }\n    }\n  }\n}\n\n.setting-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 0;\n}\n\n.setting-label {\n  font-size: 16px;\n  color: #333;\n  cursor: pointer;\n}\n\n.toggle-button {\n  width: 40px;\n  height: 20px;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: #ddd;\n  border-radius: 10px;\n  position: relative;\n  outline: none;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n.toggle-button:checked {\n  background-color: rgb(94, 161, 216);\n}\n\n.toggle-button:before {\n  content: \"\";\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 16px;\n  height: 16px;\n  background-color: white;\n  border-radius: 50%;\n  transition: transform 0.2s ease;\n}\n\n.toggle-button:checked:before {\n  transform: translateX(20px);\n}\n\n.settings-container {\n  //  max-width: 400px;\n  margin: 0 auto;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  width: 100%;\n}\n\nlabel {\n  display: block;\n  margin-bottom: 10px;\n}\n\nh3,\nh4 {\n  margin-bottom: 20px;\n}\n\n.error {\n  color: red;\n  font-size: 0.9em;\n  margin-top: 5px;\n}\n.btn-primary {\n  background-color: #5ea1d8;\n  border: none;\n}\n.generate-btn {\n  padding: 10px 20px 10px 10px;\n  text-align: right;\n}\n.input-container {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.prefix {\n  position: absolute;\n  left: 10px; /* Adjust based on input padding */\n  pointer-events: none; /* Prevent interactions with the prefix */\n}\n\n.input-container input {\n  padding-left: 17px; /* Add padding to make room for the £ sign */\n}\n\n.setting-btn {\n  padding: 10px;\n  border: 1px solid #5ea1d8;\n  border-radius: 18px;\n  display: block;\n  margin: 0 12px 12px 0;\n}\n.setting-page {\n  input[type=\"time\"],\n  input[type=\"number\"] {\n    max-width: 100%;\n    height: 40px;\n    width: 100%;\n    margin-bottom: 10px;\n    border: 1px solid lightgray;\n    border-radius: 5px;\n  }\n}\n\n.setting-input {\n  border: 1px solid lightgray;\n  border-radius: 5px;\n}\n\n* {\n  padding: 0px;\n  margin: 0px;\n}\nbody {\n  background: #efeeee;\n  counter-reset: my-sec-counter;\n}\n.view-flow {\n  background: #efeeee;\n  // min-height: 89vh;\n  padding-top: 10px;\n  .container1 {\n    max-width: 1040px;\n    margin: 0px auto;\n    background: transparent;\n    padding-bottom: 30px;\n    padding: 0px 40px 20px;\n    .user-sec {\n      display: flex;\n      padding: 20px 20px;\n      background: #fff;\n      border: 1px solid #ddd;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      margin: 0px 20px 0px 20px;\n      border-radius: 10px;\n      position: relative;\n      .user-details {\n        flex: 1;\n        display: flex;\n        .user-ico {\n          flex: 1;\n          display: none !important;\n          img {\n            width: 180px !important;\n            height: 180px;\n            border-radius: 100%;\n            object-fit: cover;\n            max-width: 200px;\n          }\n        }\n        .ico-details {\n          flex: 4;\n          padding-left: 0px;\n          display: flex;\n          flex-direction: column;\n\n          p {\n            margin-bottom: 20px !important;\n            margin-top: 0px !important;\n            justify-content: flex-end !important;\n          }\n          .profilepic {\n            display: flex;\n            align-items: center;\n            margin-bottom: 20px;\n            flex-wrap: wrap;\n            .profinner {\n              max-width: 500px;\n              width: 100%;\n              display: flex;\n              align-items: center;\n              flex-wrap: wrap;\n\n              & > div {\n                width: auto;\n                margin-right: 20px;\n                display: block;\n                &:last-child {\n                  span {\n                    color: rgba(0, 0, 0, 0.54) !important;\n                    font-weight: 400 !important;\n                    .mat-icon {\n                      color: rgba(0, 0, 0, 0.54) !important;\n                      font-size: 18px;\n                    }\n                  }\n                }\n              }\n            }\n\n            .u-ico {\n              margin-right: 15px;\n            }\n            .qrcode {\n              flex: 1;\n              display: flex;\n              justify-content: flex-end;\n              align-items: flex-end;\n              span {\n                font-weight: 400 !important;\n                color: #212427;\n              }\n            }\n            p {\n              margin: 0px !important;\n            }\n            & > div {\n              &:last-child {\n                margin-right: 0px;\n              }\n            }\n            img {\n              border-radius: 50%;\n              cursor: pointer;\n            }\n          }\n          .like {\n            max-width: 100%;\n            margin-bottom: 0px;\n            display: flex;\n            ul {\n              max-width: 500px;\n              width: 100%;\n              display: flex;\n              // margin-left: -17px;\n              li {\n                height: 100%;\n                justify-content: flex-start;\n                i {\n                  font-size: 25px;\n                  color: gray;\n                  text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n                  margin-bottom: 5px;\n                }\n                span {\n                  font-size: 10px;\n                  font-family: \"Raleway\";\n                  font-weight: 600;\n                  text-align: center;\n                  color: #212427 !important;\n                  padding: 0px !important;\n                  min-height: 30px;\n                  margin-left: 0px;\n                }\n                // &:last-child{\n                //   display: none;\n                // }\n                // &:nth-last-child(2){\n                //   display: none;\n                // }\n              }\n            }\n            div {\n              flex: 1;\n              text-align: right;\n            }\n          }\n        }\n      }\n    }\n    .viewflow-step {\n      width: calc(100% - 40px);\n      display: flex;\n      padding: 20px 20px;\n      padding: 20px 10px 20px;\n      border: 1px solid #ddd;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n      position: relative;\n      border-radius: 10px;\n      flex-wrap: wrap;\n      display: flex;\n      background: #fff;\n      margin: 10px 20px 10px 20px;\n      //min-height: 300px;\n      .des-item {\n        border-radius: 0px;\n        border-right: 1px solid lightgray;\n        max-width: calc(50% - 20px);\n        padding-right: 10px;\n        flex-basis: calc(50% - 20px);\n        margin-right: 10px;\n        display: flex;\n        flex-direction: column;\n        position: relative;\n        z-index: 2;\n        .des {\n          box-shadow: none;\n          border: 0px;\n          padding: 0px 0px;\n          flex: 1;\n          border: 1px solid #ddd;\n          border: 0px !important;\n          margin-bottom: 0px;\n          border-radius: 0px;\n          padding: 0px 0px;\n          display: flex;\n          flex-direction: column;\n          box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n          box-shadow: none !important;\n          & > div {\n            flex: none;\n            color: #212427;\n            display: flex;\n            flex-wrap: wrap;\n          }\n          p {\n            max-height: 287px;\n            padding-right: 10px;\n          }\n          .s-num {\n            font-size: 16px;\n            width: 30px;\n            height: 30px;\n            color: #fff;\n            border: 0px solid #f3f3f3;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: space-around;\n            // box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n            font-family: \"Raleway\";\n            font-weight: 600;\n            margin-top: 0px;\n            margin-bottom: 20px;\n            position: relative;\n            z-index: 2;\n            &:before {\n              content: \"\";\n              width: 100%;\n              height: 100%;\n              border-radius: 50%;\n              left: 0px;\n              top: 0px;\n              position: absolute;\n              background: lightgray;\n              // border:1px solid #70bfe2;\n              z-index: -1;\n            }\n          }\n        }\n        .btm-btn {\n          display: flex;\n          align-items: center;\n          & > div {\n            flex: 1;\n            &:first-child {\n              justify-content: flex-start;\n            }\n            &:last-child {\n              justify-content: right;\n              text-align: end;\n            }\n          }\n          .lock {\n            display: flex;\n            align-items: center;\n            font-family: \"Raleway\";\n            & > span {\n              display: flex;\n              align-items: center;\n            }\n          }\n        }\n      }\n      .step-sec {\n        box-shadow: none;\n        border: 0px;\n        padding: 0px 0px 0px 0px;\n        margin-left: 10px;\n        width: 50%;\n        display: flex;\n        flex-direction: column;\n        flex: 1;\n        border-radius: 40px;\n        .progressbar {\n          border: 2px solid lightgray;\n          margin-bottom: 20px;\n          background: #fff;\n          border-radius: 10px;\n          padding: 5px;\n          // box-shadow:0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n          .w3-round {\n            height: 7px;\n            background: #5ea1d8;\n            background: lightgrey;\n          }\n        }\n        .img-wrap {\n          flex: 1;\n          display: flex;\n          align-items: center;\n          // max-height: 382px;\n          position: relative;\n          overflow: hidden;\n          img {\n            // width:auto !important;\n            max-width: 100% !important;\n            height: 100%;\n            object-fit: cover;\n            //max-height: 436px !important;\n            margin: 0px auto;\n            width: 100% !important;\n          }\n          & + .item {\n            width: calc(100% - 0px) !important;\n            margin: 17px 0px !important;\n            border: 0px !important;\n          }\n        }\n        // &:before{\n        //   content:\"‹\";\n\n        // background: #fafafa !important;\n        //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n        //     width: 35px;\n        //     height: 35px;\n        //     border-radius: 50%;\n        //     display:flex;\n        //     align-items: center;\n        //     justify-content: center;\n        //     outline:none;\n        //   position:absolute;\n        // left:-49px;\n        // top: calc(50% - 20px);\n        // font-size:35px;\n\n        // }\n        // &:after{\n        //   content:\"›\";\n\n        // background: #fafafa !important;\n        //     box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%), 0 1px 18px 0 rgb(0 0 0 / 12%);\n        //     width: 35px;\n        //     height: 35px;\n        //     border-radius: 50%;\n        //     display:flex;\n        //     align-items: center;\n        //     justify-content: center;\n        //     outline:none;\n        //   position:absolute;\n        // right:-49px;\n        // top: calc(50% - 20px);\n        // font-size:35px;\n\n        // }\n      }\n    }\n  }\n  .clickarrow {\n    width: 100%;\n    display: block;\n    position: absolute;\n    margin-top: 0px;\n    width: 100%;\n    height: 35px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: 1;\n    position: fixed;\n    max-width: 1000px;\n\n    button.owl-prev {\n      position: absolute;\n      background: #fafafa !important;\n      background: rgba(250, 250, 250, 0.7) !important;\n      box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      left: 0px;\n      span {\n        font-size: 57px;\n        line-height: 0px;\n        display: flex;\n        align-items: center;\n        margin-top: -15px;\n        font-weight: 400 !important;\n        color: #5ea1d8;\n      }\n    }\n    button.owl-next {\n      position: absolute;\n      background: #fafafa !important;\n      background: rgba(250, 250, 250, 0.7) !important;\n      box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n        0 1px 18px 0 rgb(0 0 0 / 12%);\n      width: 35px;\n      height: 35px;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      outline: none;\n      right: 0px;\n\n      span {\n        font-size: 57px;\n        line-height: 0px;\n        display: flex;\n        align-items: center;\n        margin-top: -15px;\n        font-weight: 400 !important;\n        color: #5ea1d8;\n      }\n    }\n  }\n  // .flowbycat {\n  //   height: 100%;\n  //   display: table;\n  //   text-align: center;\n  // }\n  // header {\n  //   width: 100%;\n  //   height: 100px;\n  //   background: #fff;\n  //   border-bottom: 2px solid #5ea1d8;\n  // }\n\n  .partOfBundle {\n    padding: 0px 20px 20px;\n    background: #fff;\n    background: transparent;\n    // border: 1px solid #ddd;\n    // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    margin: 0px 20px 0px 0px;\n    border-radius: 10px;\n    overflow-x: scroll;\n    h2 {\n      // position: absolute;\n      margin-top: 0px;\n      margin-bottom: 0px !important;\n    }\n    .row {\n      flex-wrap: nowrap !important;\n      width: fit-content;\n      margin-top: 10px !important;\n    }\n    .item {\n      background: #fff;\n      margin-left: 0px;\n      width: 170px !important;\n      padding: 10px;\n      margin-right: 10px;\n      position: relative;\n\n      & > div:first-child {\n        img {\n          height: 150px !important;\n        }\n      }\n      & > div:last-child {\n        p {\n          height: 25px !important;\n        }\n      }\n    }\n  }\n\n  .qr-ico {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    height: 100%;\n    position: absolute;\n    right: 20px;\n    i {\n      flex: 1;\n      font-size: 25px;\n      color: grey;\n    }\n    p {\n      font-weight: 600;\n    }\n  }\n\n  // .social-ico {\n  //   max-width: 275px;\n  //   margin-top: 20px;\n  // }\n  // .social-ico ul li .fa {\n  //   font-size: 27px;\n  //   color: gray;\n  //   text-shadow: 0px 2px 2px rgb(186 183 183 / 40%);\n  //   margin-bottom: 5px;\n  //   font-size: 30px;\n  // }\n  // .social-ico ul li .fa.fa-facebook-square {\n  //   color: #4266b2;\n  // }\n\n  // .social-ico ul li .fa.fa-twitter-square {\n  //   color: #55aded;\n  // }\n  // .social-ico ul li .fa.fa-linkedin-square {\n  //   color: #007ab9;\n  // }\n  // .social-ico ul li .fa.fa-xing-square {\n  //   color: #f96678;\n  // }\n  .material-icons,\n  .align-items-center {\n    color: #212427 !important;\n    font-weight: normal !important;\n    cursor: pointer;\n    display: flex;\n  }\n  img {\n    width: 100%;\n  }\n\n  p {\n    font-family: \"Raleway\";\n    font-size: 15px;\n    line-height: 20px;\n  }\n  button {\n    padding: 3px 10px;\n    // background: #5ea1d8;\n    border: 0px;\n    // color: #fff;\n    font-size: 15px;\n    border-radius: 15px;\n  }\n  button.active {\n    background: #5ea1d8;\n    color: white;\n  }\n\n  h2 {\n    font-family: \"Raleway\";\n    margin-bottom: 20px;\n    a {\n      color: #212427 !important;\n    }\n  }\n  h3 {\n    font-family: \"Raleway\";\n    margin-bottom: 20px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n\n  ul {\n    display: flex;\n    list-style: none;\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n  }\n  li {\n    flex: 1;\n    // display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    span {\n      // margin-left: 0px;\n    }\n  }\n  .like {\n    .qrcode {\n      flex: 1;\n      display: flex;\n      align-items: flex-end;\n      justify-content: flex-end;\n    }\n  }\n\n  /*description wrapper starts here*/\n  .description-wrapper {\n    // display: flex;\n    // background: #fff;\n    // margin: 10px 20px 10px 20px;\n    .des-item {\n      // flex-basis: calc(50% - 20px);\n      // // max-width: 3;\n      // margin-right: 10px;\n      // display: flex;\n      // flex-direction: column;\n      .des {\n        /*max-height:200px;*/\n        // flex: 1;\n        // border: 1px solid #ddd;\n        // margin-bottom: 0px;\n\n        // border-radius: 0px;\n        // padding: 40px 20px;\n        // display: flex;\n        // flex-direction: column;\n        // box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n        p {\n          max-height: 100px;\n          overflow-y: auto;\n        }\n      }\n    }\n  }\n\n  // .des-item .des > div {\n  //   flex: 1;\n  //   display: flex;\n  //   align-items: flex-start;\n  //   margin-top: 20px;\n  // }\n  .des-item .des > div span {\n    flex: 1;\n    font-family: \"RALEWAY\";\n  }\n  .des-item .des > div span.material-icons.ng-star-inserted {\n    max-width: 30px;\n  }\n  .des-item .des > div span:first-child {\n    align-items: flex-start;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n  }\n  .des-item .des > div span:last-child {\n    text-align: flex-end;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n  .des-item .des > div span i {\n    margin-right: 5px;\n  }\n  .des-item .item {\n    flex: 1;\n    border: 1px solid #ddd;\n    border-radius: 40px;\n    padding: 40px 20px;\n    box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    margin-top: 20px;\n  }\n  .des-item .item .list {\n    display: flex;\n    /* padding: 20px 0px; */\n    max-height: 150px;\n    overflow-y: auto;\n    align-items: flex-start;\n  }\n  .des-item .item .list ul {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    margin: 0px 0px 20px;\n    padding: 5px;\n  }\n  .des-item .item .list ul li {\n    font-family: \"Raleway\";\n    font-size: 14px;\n    line-height: 28px;\n    word-break: break-all;\n    position: relative;\n\n    padding-left: 17px;\n    &:before {\n      content: \"\";\n      width: 8px;\n      height: 8px;\n      background: grey;\n      position: absolute;\n      left: 0px;\n      top: 10px;\n      border-radius: 50%;\n      box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n    }\n    &:first-child {\n      padding-left: 0px;\n      &:before {\n        display: none;\n      }\n    }\n  }\n  .des-item .item .list ul li:first-child {\n    font-weight: 600;\n  }\n  // .step-sec {\n  //   flex: 1;\n  //   padding: 40px;\n  //   border: 1px solid #ddd;\n  //   border-radius: 40px;\n  // }\n\n  video {\n    // width:auto !important;\n    max-width: 100% !important;\n    //max-height: 300px !important;\n    margin: 0px auto;\n    width: 100% !important;\n  }\n  &:empty {\n    display: none !important;\n  }\n}\n.step-sec .img-wrap:after {\n  content: \"›\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  right: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n.step-sec .img-wrap:before {\n  content: \"‹\";\n\n  background: #fafafa !important;\n  box-shadow: 0 3px 5px -1px rgb(0 0 0 / 20%), 0 6px 10px 0 rgb(0 0 0 / 14%),\n    0 1px 18px 0 rgb(0 0 0 / 12%);\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  position: absolute;\n  left: -49px;\n  top: calc(50% - 20px);\n  font-size: 35px;\n  margin-top: -8px;\n  display: none;\n}\n.des-item .des p::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n.des-item .des p::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.des-item .des p::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.des-item .item .list::-webkit-scrollbar {\n  width: 4px;\n  height: 100px;\n}\n.des-item .item .list::-webkit-scrollbar-track {\n  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n.des-item .item .list::-webkit-scrollbar-thumb {\n  background-color: #5ea1d8;\n  outline: 1px solid #5ea1d8;\n}\n\n.step-sec {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -2px 2px 7px rgb(200 193 193 / 50%);\n}\n// .progressbar {\n//   flex: 1;\n//   display: table;\n//   align-items: center;\n//   height:30px;\n//   background:#fff;\n// }\n.progressbar ul {\n  display: flex;\n  flex-basis: 100%;\n}\n.progressbar ul li {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n.progressbar ul li a {\n  width: 20px;\n  height: 20px;\n  background: #5ea1d8;\n  border-radius: 50%;\n  color: #fff;\n  text-decoration: none;\n  text-align: center;\n  font-size: 12px;\n  font-family: \"RALEWAY\";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.progressbar ul li a:before {\n  counter-increment: my-sec-counter;\n  content: \"\" counter(my-sec-counter) \"\";\n}\n\nimg {\n  max-width: 100%;\n}\n\n@media only screen and (max-width: 1025px) and (min-width: 320px) {\n  .view-flow {\n    // background:#fff;\n    h2 {\n      font-size: 22px !important;\n      // word-break: break-all;\n    }\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 320px) {\n  .view-flow {\n    .container1 {\n      display: flex;\n      flex-direction: column;\n      padding: 0px 15px 20px;\n      .user-sec {\n        flex-direction: column;\n        // margin:0px;\n        // padding: 0rem 0px 2rem;\n        .user-details {\n          flex-direction: column;\n          order: 2;\n          .user-ico {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n          }\n          .ico-details {\n            padding: 0px;\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px;\n                }\n              }\n            }\n            .like {\n              display: flex;\n              // flex-direction: column;\n              margin-left: 0px;\n              ul {\n                margin-left: 0px;\n                // max-width: 100%;\n                li {\n                  i {\n                    font-size: 20px;\n                  }\n                }\n              }\n              .qrcode {\n                span {\n                  margin-right: 0px !important;\n                }\n              }\n            }\n          }\n        }\n        .qr-code {\n          padding: 10px 0px;\n        }\n      }\n    }\n    .description-wrapper {\n      flex-direction: column;\n      margin: 0px;\n      margin-bottom: 20px;\n      .des-item {\n        margin-right: 0px;\n        margin-bottom: 20px;\n        flex-basis: 100%;\n        max-width: unset;\n        border-right: 0px;\n        padding-right: 0px;\n        .des {\n          & > div {\n            span {\n              &:first-child {\n                justify-content: flex-start;\n              }\n            }\n          }\n          .timer-wrap {\n            display: flex;\n            flex-direction: column;\n            flex: none;\n            color: #212427;\n            > * {\n              margin-right: 10px;\n            }\n          }\n        }\n      }\n      .step-sec {\n        .img-wrap {\n          img {\n            //max-height: 300px !important;\n          }\n        }\n      }\n    }\n    .viewflow-step {\n      width: 100%;\n      margin: 0px auto 20px;\n\n      .des-item {\n        flex-basis: 100%;\n        max-width: unset;\n        border-bottom: 2px solid lightgrey;\n        padding-bottom: 20px;\n\n        .des {\n          padding-bottom: 20px;\n          // border-bottom:1px solid lightgray;\n          border-radius: 0px;\n        }\n      }\n      .step-sec {\n        padding: 0px;\n        margin-left: 0px;\n        width: 100%;\n      }\n\n      .clickarrow {\n        button {\n          width: 25px;\n          height: 25px;\n          &.owl-prev {\n            // left: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n          &.owl-next {\n            // right: -20px;\n            // background:transparent !important;\n            // box-shadow: none !important;\n          }\n        }\n      }\n    }\n    .ico-details .profilepic {\n      flex-wrap: nowrap;\n    }\n  }\n  .view-flow .container1 .user-sec .user-details .ico-details {\n    .profilepic {\n      .profinner {\n        width: 100% !important;\n        flex-basis: 100% !important;\n        max-width: 100% !important;\n        & + .qrcode {\n          width: 100%;\n          justify-content: flex-end;\n        }\n      }\n      & + .like-list {\n        flex-direction: column;\n      }\n    }\n  }\n  .view-flow .container1 .viewflow-step .step-sec {\n    width: 100%;\n    margin: 0px;\n  }\n  .supportingdoc {\n    position: relative !important;\n    padding: 10px 10px 10px 0px !important;\n  }\n}\n\n.like-list {\n  .fashion-btn {\n    display: block;\n  }\n}\n.qr-code {\n  .lock,\n  .fashion-btn {\n    display: none;\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 461px) {\n  .view-flow {\n    .container1 {\n      .user-sec {\n        .user-details {\n          flex-direction: row;\n          // margin-bottom:30px;\n          // padding-left:15px;\n          .ico-details {\n            padding-left: 15px;\n            max-width: 100%;\n            .like {\n              ul {\n                margin-left: -15px;\n              }\n              .qrcode {\n                span {\n                  margin-right: 15px !important;\n                }\n              }\n            }\n            .profilepic {\n              & > div {\n                p {\n                  font-size: 14px !important;\n                }\n              }\n            }\n          }\n        }\n      }\n      .description-wrapper {\n        width: auto;\n        // max-width:80%;\n        // max-width:calc(100% - 50px);\n        margin: 10px 20px;\n\n        .step-sec {\n          .img-wrap {\n            max-height: unset;\n          }\n        }\n      }\n      .viewflow-step {\n        .des-item {\n          .des {\n            padding-bottom: 20px;\n            // border-bottom:1px solid lightgray;\n            border-radius: 0px;\n          }\n        }\n        .clickarrow button {\n          &.owl-next {\n            right: -8px;\n          }\n          &.owl-prev {\n            left: -8px;\n          }\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .view-flow {\n    .viewflow-step {\n      .clickarrow {\n        button {\n          width: 35px;\n          height: 35px;\n          &.owl-prev {\n            left: -45px;\n          }\n          &.owl-next {\n            right: -45px;\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (max-width: 460px) and (min-width: 320px) {\n  .view-flow\n    .container1\n    .user-sec\n    .user-details\n    .ico-details\n    .profilepic\n    > div\n    p {\n    font-size: 11px !important;\n  }\n  .ico-details .profilepic > div:last-child {\n    span {\n      font-size: 11px;\n    }\n  }\n  .view-flow .viewflow-step .clickarrow {\n    button {\n      width: 35px;\n      height: 35px;\n      &.owl-prev {\n        left: 0px;\n        // background:transparent !important;\n        // box-shadow: none !important;\n      }\n      &.owl-next {\n        right: 0px;\n        // background:transparent !important;\n        // box-shadow: none !important;\n      }\n    }\n  }\n  .view-flow .viewflow-step {\n    width: auto;\n    margin: 10px 0px;\n  }\n  .qr-code {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    .priceIcon-wp {\n      position: relative !important;\n      top: -2px;\n    }\n    .lock {\n      > span {\n        display: flex;\n        align-items: center;\n      }\n    }\n    .qr-ico {\n      // width: 24px;\n      // background: gray;\n      // display: block;\n      // height: 35px;\n    }\n    .lock,\n    .fashion-btn {\n      display: block;\n    }\n  }\n\n  .profilepic {\n    .lock {\n      display: none !important;\n    }\n  }\n  .like-list {\n    .fashion-btn {\n      display: none !important;\n    }\n  }\n  .view-flow h2 span {\n    font-size: 20px !important;\n    word-break: break-word;\n  }\n  .view-flow .container1 .user-sec {\n    padding: 10px;\n    margin: 0px;\n  }\n  .ico-details .profilepic .profinner > div {\n    margin-right: 5px;\n  }\n  .ico-details .profilepic > div {\n    margin-right: 0px;\n  }\n  .like li:last-child {\n    // display: none !important;\n  }\n  .viewflow-step .des-item .des p {\n    max-height: 133px;\n  }\n  .view-flow .container1 .user-sec .user-details .ico-details .like ul li span {\n    font-size: 9px;\n  }\n  .partOfBundle {\n    padding: 0px;\n    margin-right: 5px;\n  }\n}\n\nbutton.common {\n  padding: 3px 6px !important;\n  background: #5ea1d8 !important;\n  // background: pink !important;\n  border: 0px !important;\n  color: #fff !important;\n  font-size: 13px !important;\n  border-radius: 5px !important;\n}\n\n@media (max-width: 500px) {\n  .ico-details .profilepic .qrcode {\n    justify-content: center;\n  }\n}\n\n.example-list {\n  max-width: 100%;\n  // border: solid 1px #ccc;\n  // min-height: 246px;\n  height: auto;\n  display: flex;\n  background: white;\n  flex-direction: column;\n  // border-radius: 4px;\n  overflow-y: auto;\n  .example-box {\n    display: flex;\n    padding: 15px 10px;\n    border-bottom: 1px solid lightgrey;\n    background: white !important;\n    flex: 1;\n    padding: 15px 10px;\n    border-bottom: solid 1px lightgray;\n    color: rgba(0, 0, 0, 0.87);\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: border-box;\n    cursor: move;\n    background: white;\n    font-size: 14px;\n    .item-name {\n      text-align: left;\n      width: 70%;\n    }\n\n    .item-value {\n      text-align: left;\n      width: 30%;\n    }\n\n    .item-name,\n    .item-delete,\n    .item-reorder,\n    .item-value {\n      text-align: left;\n      padding: 5px;\n      font-size: 14px;\n      font-weight: 400 !important;\n      overflow-wrap: break-word;\n    }\n    .item-delete,\n    .item-reorder {\n      float: right;\n      cursor: pointer;\n      font-size: 20px;\n      width: 10%;\n    }\n    &:last-child {\n      border-bottom: 0px;\n    }\n    img {\n      border-bottom: 0px;\n      width: 40px !important;\n      max-width: 40px;\n      height: 40px !important;\n      object-fit: cover;\n    }\n    & > * {\n      flex: 1;\n      color: #212427 !important;\n      font-weight: normal !important;\n    }\n    a {\n      color: #007bff !important;\n    }\n  }\n  &::-webkit-scrollbar {\n    width: 4px;\n    height: 100px;\n  }\n  &::-webkit-scrollbar-track {\n    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n  }\n  &::-webkit-scrollbar-thumb {\n    background-color: #5ea1d8;\n    outline: 1px solid #5ea1d8;\n  }\n}\n\n.example-box {\n  padding: 15px 10px;\n  border-bottom: solid 1px lightgray;\n  color: rgba(0, 0, 0, 0.87);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  box-sizing: border-box;\n  cursor: move;\n  background: white;\n  font-size: 14px;\n  & > div {\n    width: 50%;\n    display: flex !important;\n    &:first-child {\n      width: 80%;\n    }\n    &:last-child {\n      width: 17%;\n    }\n    & > span {\n      // width:48%;\n      text-align: left;\n      word-break: keep-all;\n      display: flex;\n      align-items: center;\n\n      &:first-child {\n        flex: 1;\n        width: 50%;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n      &:last-child {\n        width: 50%;\n        text-align: center;\n        display: flex;\n        align-items: center;\n        justify-content: end;\n        white-space: nowrap;\n        color: rgba(0, 0, 0, 0.54) !important;\n        font-weight: 400 !important;\n      }\n    }\n  }\n}\n.itemremove {\n  span {\n    &:first-child {\n      width: 90% !important;\n    }\n    &:nth-child(2) {\n      // display:none;\n    }\n  }\n}\n\n.img-div-left {\n  position: fixed;\n  z-index: 9999999 !important;\n  height: 100px;\n  width: 100px;\n  overflow: visible;\n  margin: auto;\n  top: 5% !important;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  img {\n    width: 100%;\n    height: 100%;\n    position: absolute !important;\n    top: 0% !important;\n  }\n}\n/*new design starts here*/\n.viewbundle {\n  .step-sec {\n    & + .row {\n      margin-top: 40px !important;\n      display: flex;\n      justify-content: flex-start;\n      width: 100%;\n      & > div {\n        width: 25% !important;\n        .item {\n          box-shadow: none !important;\n          img {\n            width: calc(100% - 20px) !important;\n            object-fit: cover;\n            margin: 10px !important;\n          }\n          p {\n            padding-left: 5px;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n          }\n          .with-icon {\n            display: flex;\n            img {\n              width: 30px !important;\n              height: 30px !important;\n              border-radius: 20px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n.mat-accent {\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n// .viewbundle {\n//   .img-wrap {\n//     & + .item {\n//       width: calc(100% - 0px) !important;\n//       margin: 17px 0px !important;\n//       border: 0px !important;\n//     }\n//   }\n// }\n.example-list .example-box {\n  .item-name {\n    padding-left: 10px !important;\n    border-right: 1px solid #ddd;\n  }\n  .item-value {\n    padding-left: 10px !important;\n  }\n}\n\n.textcolor {\n  background-color: #5ea1d8;\n  color: white;\n  position: relative;\n  text-decoration: none;\n  padding: 5px 10px;\n  font-family: \"Raleway\";\n  font-weight: 500;\n  cursor: pointer;\n  border-radius: 5px;\n}\n\n// .textcolor:hover {\n//   text-decoration: underline;\n// }\n// .item {\n//   // height: 220px !important;\n//   // background-color: lightgray;\n//   border: solid 1px;\n//   margin: 17px;\n//   width: 170px;\n//   border: solid 0.5px lightgrey;\n// }\n\n.item .img {\n  height: 150px !important;\n  background-color: lightgray;\n}\n\np {\n  margin: 0px;\n}\n\n.zoom {\n  cursor: pointer;\n  width: 100%;\n  height: 70%;\n  transition: transform 0.1s;\n  /* Animation */\n}\n\n.zoom:hover {\n  border-radius: 5px;\n  // -ms-transform: scale(1.2); /* IE 9 */\n  // -webkit-transform: scale(1.5); /* Safari 3-8 */\n  transform: scale(1.1);\n  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel button.owl-dot {\n  font-size: 55px !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"] {\n  font-size: 55px !important;\n}\n\nbutton span {\n  font-size: 55px;\n}\n\n.owl-nav {\n  display: none;\n}\n\n.with-icon {\n  display: flex;\n  align-items: center;\n}\n.mat-badge-content {\n  background: #5ea1d8;\n}\n.div1 {\n  height: 50px;\n  //border: 1px solid blue;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n  z-index: 100;\n}\n\n.user-pro {\n  .row {\n    justify-content: left;\n  }\n  .ng-star-inserted {\n    width: 15.6%;\n    margin-right: 1%;\n    // &:nth-child(6n+6){\n    //   .item{\n    //     margin-right:0px;\n    //   }\n\n    //       }\n  }\n  .item {\n    width: 100% !important;\n    overflow: hidden;\n    background: #fff;\n    border: 1px solid #dddddd;\n    margin: 0px;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    & > div {\n      margin: 5px;\n    }\n    p {\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      height: 33px !important;\n      white-space: normal;\n      word-break: break-word;\n      &:last-of-type {\n        height: auto !important;\n        // font-size: 12px !important;\n      }\n    }\n    .with-icon {\n      width: 100%;\n      font-family: \"Raleway\";\n      display: flex;\n      align-items: center;\n      > div {\n        width: 30px;\n        height: 30px;\n        border-radius: 50%;\n        overflow: hidden;\n        display: flex;\n        align-items: center;\n        margin-right: 5px;\n      }\n      img {\n        object-fit: cover;\n        height: 40px !important;\n        border: 0px;\n      }\n    }\n    .zoom {\n      margin: 5px;\n      width: calc(100% - 10px);\n      background-color: transparent;\n    }\n    img {\n      height: 150px;\n      object-fit: cover;\n      width: 100%;\n      border: 1px solid #dddddd;\n    }\n  }\n}\n\n@media only screen and (max-width: 1024px) and (min-width: 993px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n    .ng-star-inserted {\n      max-width: 18% !important;\n      width: 18% !important;\n      margin: 1% !important;\n      // &:nth-child(5n + 5){\n      //   margin-right:0px;\n      // }\n    }\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 20px;\n      & > div {\n        margin: 5px;\n      }\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n      .with-icon {\n        max-width: 100% !important;\n        width: 100% !important;\n        font-family: \"Raleway\";\n        display: flex;\n        align-items: center;\n        max-width: 100% !important;\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n      }\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n}\n@media only screen and (max-width: 992px) and (min-width: 768px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n    .ng-star-inserted {\n      max-width: 23% !important;\n      width: 23% !important;\n      margin: 1% !important;\n      // &:nth-child(4n + 4){\n      //   margin-right:0px;\n      // }\n    }\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 20px;\n      & > div {\n        margin: 5px;\n      }\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n      .with-icon {\n        max-width: 100% !important;\n        width: 100% !important;\n        font-family: \"Raleway\";\n        display: flex;\n        align-items: center;\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n      }\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n  h3 {\n    padding-left: 12px;\n  }\n}\n@media only screen and (max-width: 767px) and (min-width: 461px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n    .ng-star-inserted {\n      max-width: 31.3% !important;\n      width: 31.3% !important;\n      margin: 1%;\n      // &:nth-child(3n+3){\n      //   margin-right:0%;\n      //   // .item{\n      //   //   margin-right:0px;\n      //   // }\n\n      //       }\n    }\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 0px;\n      & > div {\n        margin: 5px;\n      }\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n      .with-icon {\n        width: 100%;\n        font-family: \"Raleway\";\n        display: flex;\n        align-items: center;\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n        &.ng-star-inserted {\n          max-width: 100% !important;\n          width: 100% !important;\n        }\n      }\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n  h3 {\n    padding-left: 12px;\n  }\n}\n@media screen and (max-width: 460px) {\n  .user-pro {\n    .row {\n      justify-content: left;\n      text-align: start;\n    }\n    .ng-star-inserted {\n      max-width: 48% !important;\n      width: 48% !important;\n      margin: 1%;\n      // &:nth-child(2n+2){\n      //   margin-right:0px;\n      //   // .item{\n      //   //   margin-right:0px;\n      //   // }\n\n      //       }\n    }\n    .item {\n      max-width: 100% !important;\n      width: 100% !important;\n      overflow: hidden;\n      background: #fff;\n      border: 1px solid #dddddd;\n      margin: 0px;\n      margin-right: 0px;\n      margin-bottom: 0px;\n      & > div {\n        margin: 5px;\n      }\n      p {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        height: 33px !important;\n        white-space: normal;\n        word-break: break-word;\n      }\n      .with-icon {\n        width: 100%;\n        font-family: \"Raleway\";\n        display: flex;\n        align-items: center;\n        > div {\n          width: 30px;\n          height: 30px;\n          border-radius: 50%;\n          overflow: hidden;\n          display: flex;\n          align-items: center;\n          margin-right: 5px;\n        }\n        img {\n          object-fit: cover;\n          height: 40px !important;\n          border: 0px;\n        }\n        &.ng-star-inserted {\n          max-width: 100% !important;\n          width: 100% !important;\n        }\n      }\n      .zoom {\n        margin: 5px;\n        width: calc(100% - 10px);\n        background-color: transparent;\n      }\n      img {\n        height: 150px;\n        object-fit: cover;\n        width: 100%;\n        border: 1px solid #dddddd;\n      }\n    }\n  }\n  h3 {\n    padding-left: 7px;\n  }\n}\n\n// .img-div-left{\n//   position: fixed;\n//   z-index: 999;\n//   height: 150px;\n//   width: 150px;\n//   overflow: visible;\n//   margin: auto;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n// }\n\n.scroll .item .uni-wrapper .bundleIcon {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  max-width: 25px !important;\n  height: 25px !important;\n\n  img {\n    width: 100% !important;\n    height: 20px !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n\n.uni-wrapper {\n  // display: flex;\n  // width: 100%;\n  // align-items: center;\n  P {\n    flex: 1;\n  }\n}\n\n/*new design starts here new bundle*/\n.viewbundle {\n  .step-sec {\n    & + .row {\n      margin-top: 40px !important;\n      display: flex;\n      justify-content: flex-start;\n      width: 100%;\n      & > div {\n        width: 25% !important;\n        .item {\n          box-shadow: none !important;\n          img {\n            width: calc(100% - 20px) !important;\n            object-fit: cover;\n            margin: 10px !important;\n          }\n          p {\n            padding-left: 5px;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n          }\n          .with-icon {\n            display: flex;\n            img {\n              width: 30px !important;\n              height: 30px !important;\n              border-radius: 20px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n.bundleIcons {\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px !important;\n  height: 25px !important;\n  padding-left: 5px;\n\n  img {\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n.partOfBundle {\n  .item {\n    .uni-wrapper {\n      display: flex;\n      p {\n        justify-content: flex-start !important;\n      }\n    }\n  }\n}\n\n.uni-wrapper {\n  // display: flex;\n  // width: 100%;\n  // align-items: center;\n  // height: 35px;\n  P {\n    flex: 1;\n    display: flex;\n    align-items: flex-end;\n    justify-content: flex-start;\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n}\n\n.viewbundle {\n  .step-sec {\n    & + .row {\n      margin-top: 40px !important;\n      display: flex;\n      justify-content: flex-start;\n      width: 100%;\n      & > div {\n        width: 25% !important;\n        .item {\n          box-shadow: none !important;\n          img {\n            width: calc(100% - 20px) !important;\n            object-fit: cover;\n            margin: 10px !important;\n          }\n          p {\n            padding-left: 5px;\n            display: -webkit-box;\n            -webkit-line-clamp: 2;\n            -webkit-box-orient: vertical;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            height: 33px !important;\n            white-space: normal;\n            word-break: break-word;\n          }\n          .with-icon {\n            display: flex;\n            img {\n              width: 30px !important;\n              height: 30px !important;\n              border-radius: 20px !important;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 460px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 50% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n@media only screen and (min-width: 461px) and (max-width: 767px) {\n  .viewbundle {\n    .step-sec {\n      & + .row {\n        & > div {\n          width: 33% !important;\n          .item {\n            .with-icon {\n              display: flex;\n              align-items: center;\n              & > div {\n                width: 30px !important;\n              }\n              img {\n                margin: 0px !important;\n              }\n              p {\n                padding-left: 5px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .view-flow .container1 .user-sec {\n    margin: 0px !important;\n  }\n  .view-flow .viewflow-step {\n    width: 100% !important;\n    margin: 10px 0px !important;\n  }\n  .partOfBundle {\n    padding: 0px;\n    margin-right: 5px;\n  }\n}\n@media (max-width: 992px) {\n  .view-flow .viewflow-step .des-item {\n    padding: 0px;\n    border: 0px;\n    flex-basis: 100% !important;\n    max-width: 100% !important;\n    margin: 0px !important;\n    padding: 0px !important;\n    border: 0px !important;\n\n    .des {\n      padding: 0px;\n      padding: 0px 0px 20px !important;\n\n      p {\n        margin: 0px;\n      }\n    }\n  }\n  .view-flow .qr-ico {\n    position: relative;\n    right: 0px;\n  }\n}\n// .step-sec{\n//   width:100% !important;\n//   flex-basis: 100% !important;\n//     max-width: 100% !important;\n//     margin-left: 0px !important;\n// }\n\n.font16 {\n  font-size: 14px !important;\n  font-family: \"Raleway\";\n  color: rgba(0, 0, 0, 0.54) !important;\n  font-weight: bold;\n}\n\n.priceIcon-p .font16 {\n  font-size: 10px !important;\n  color: #fff !important;\n}\n\n.timer-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 20px;\n  br {\n    display: none;\n  }\n  h6 {\n    width: 100%;\n    display: block;\n    margin-bottom: 15px;\n  }\n  .icon-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    .textbodycolor {\n      justify-content: flex-start !important;\n      padding-left: 10px;\n    }\n  }\n}\n\n.newdesignadd {\n  display: block;\n  width: 100%;\n  color: #212427;\n  border: 1px solid lightgray;\n  border: 0px !important;\n  padding-left: 0px;\n\n  .item-name {\n    justify-content: flex-start !important;\n    a {\n      color: #5ea1d8;\n    }\n  }\n}\n.timer-wrap + h6 {\n  margin-bottom: 15px;\n}\n.not-draggable {\n  -webkit-user-drag: none; /* Safari/Chrome */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* IE10+ */\n  user-select: none; /* Standard syntax */\n  cursor: default; /* Optional: Change the cursor style */\n  transform: translate(0, 0) !important;\n}\n.divscroll {\n  width: 100% !important;\n  display: flex;\n  flex-direction: row;\n  max-height: 100px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  div {\n    width: 100% !important;\n  }\n}\n.view-flow .container1 .viewflow-step .step-sec .img-wrap {\n  flex: none !important;\n}\n// .qr-codeadd {\n//   .lock {\n//     display: block !important;\n//     &>span:first-child{\n//       display: none !important;\n//     }\n//   }\n// }\n\n@media (max-width: 767px) {\n  .partOfBundle {\n    padding: 0px 0px 20px 0px !important;\n    margin-right: 0px !important;\n    h2 {\n      margin-top: 0px !important;\n    }\n  }\n  .view-flow .container1 .viewflow-step {\n    margin-bottom: 10px !important;\n  }\n  .view-flow .partOfBundle h2 {\n    margin-top: 15px !important;\n  }\n}\n.view-flow\n  .container1\n  .user-sec\n  .user-details\n  .ico-details\n  .profilepic\n  .profinner {\n  div:nth-child(4) {\n    position: relative;\n    span {\n      position: relative;\n    }\n  }\n}\n\n/*chatbot design*/\n.chatbot-wrapper {\n  position: fixed;\n  bottom: 0px;\n  right: 20px;\n  padding: 20px;\n  display: flex;\n  padding: 20px 0px 0px;\n  background: #fff;\n  border: 1px solid #ddd;\n  box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n  margin: 0px 20px 0px 20px;\n  border-radius: 10px 10px 0px 0px;\n  max-width: 400px;\n  width: 100%;\n  box-sizing: border-box;\n  z-index: 1000;\n  flex-wrap: wrap;\n  // max-height: 400px;\n  min-height: 400px;\n  // height: 100%;\n  max-height: calc(100% - 120px);\n  overflow-y: hidden;\n  flex-direction: row;\n\n  &:before {\n    content: \"\";\n    width: 100%;\n    height: 31%;\n    height: 124px;\n    background: rgb(94, 161, 216) !important;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    z-index: -1;\n  }\n  .chatbot-msg {\n    padding: 0px 20px;\n    width: 100%;\n    .chatbot-msgdetails {\n      .flora-close {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        color: #fff;\n        margin-bottom: 15px;\n        button {\n        }\n        h5 {\n          color: #fff;\n        }\n      }\n      .welcome-text {\n        color: #fff;\n        margin-bottom: 15px;\n        h2 {\n          color: #fff !important;\n          font-size: 20px !important;\n          margin-bottom: 10px !important;\n        }\n        p {\n          color: #fff !important;\n          font-weight: 400 !important;\n          margin: 0px !important;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          max-width: 100%;\n          overflow: hidden;\n        }\n      }\n      .image {\n        margin-bottom: 20px;\n      }\n      .chabot-category {\n        display: flex;\n        flex-wrap: wrap;\n        ul {\n          margin: 0px;\n          margin-top: 10px !important;\n          padding: 0px !important;\n          list-style-type: none;\n          display: flex;\n          flex-wrap: wrap;\n          background: transparent !important;\n          li {\n            padding: 10px;\n            background: rgb(94, 161, 216) !important;\n            border-radius: 10px;\n            border: 1px solid #ddd;\n            margin: 0px;\n            margin-right: 5px;\n            a {\n              color: #fff !important;\n            }\n          }\n        }\n      }\n    }\n  }\n  .chatbot-btn {\n    width: 100%;\n    // height: 98%;\n    cursor: pointer;\n    margin-bottom: 0px;\n    padding: 0px 0px 0px 20px;\n    display: flex;\n    align-items: end;\n    justify-content: flex-end;\n    flex: 1;\n    margin-bottom: 10px;\n    img {\n      width: 80px;\n    }\n  }\n  .chatbot-converasation {\n    margin-bottom: 20px;\n    padding: 0px 20px;\n    width: 100%;\n    .chat-user,\n    .new-user {\n      max-width: 75%;\n      padding: 10px 10px;\n      background: #f6f6f6;\n      display: inline-flex;\n      justify-content: flex-start;\n      margin-bottom: 20px;\n      align-items: flex-start;\n      position: relative;\n      margin-left: 35px;\n      border-radius: 5px;\n      box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);\n      p {\n        margin: 0px !important;\n      }\n      &:before {\n        content: \"\";\n        background: url(\"../../../assets/icons/chat-bot.png\");\n        // background: url(\"../../../assets/princess-light-skin-tone.png\");\n        background-repeat: no-repeat;\n        background-size: contain;\n        width: 30px;\n        height: 30px;\n        position: absolute;\n        left: -35px;\n        top: 50%;\n        transform: translateY(-50%);\n      }\n    }\n    .new-user {\n      display: flex;\n      justify-content: flex-end;\n      float: right;\n      &:before {\n        display: none;\n      }\n    }\n  }\n  .chatbot-stickyfooter {\n    width: 100%;\n    position: sticky;\n    bottom: 0px;\n    padding: 5px 20px;\n    background: #5ea1d8;\n    display: flex;\n    height: 50px;\n    .input {\n      position: relative;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      flex: 1;\n      margin-right: 10px;\n\n      input {\n        width: 100%;\n        border: 1px solid #000;\n        border-radius: 10px;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        position: absolute;\n        left: 0px;\n        height: 40px;\n        border: 0px;\n        padding-left: 30px;\n        outline: none !important;\n      }\n      i {\n        position: absolute;\n        z-index: 2;\n        left: 6px;\n      }\n    }\n    .mic {\n      width: 40px;\n      height: 100%;\n      background: #fff;\n      border-radius: 50%;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n}\n\n.scroll-div {\n  // height: calc(400px - 72px);\n  // height: 229px;\n  // height: 100%;\n  // height: calc(100% - 104px - 50px);\n  min-height: 224px !important;\n  overflow-y: scroll;\n  padding-bottom: 0px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  // display: inline-block;\n  // justify-content: flex-end;\n}\n\n.sticky-chat {\n  position: sticky;\n  top: -20px;\n  z-index: 1000;\n  // background-color: rgb(94, 161, 216);\n  // border-bottom: 2px solid #ccc;\n  padding: 10px;\n  width: 100%;\n  height: 104px;\n}\n.sticky-default {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  z-index: 10000;\n  // width: 100px;\n  // height: auto;\n  img {\n    width: 80px;\n  }\n}\n.chatbot-msg {\n  height: 104px;\n}\n.scroll-div {\n  max-height: 425px;\n  .chatbot-msg {\n    // height: 100%;\n    height: auto !important;\n  }\n  .faq-list {\n    padding: 0px 20px;\n  }\n}\n\n@media (max-width: 767px) {\n  .chatbot-wrapper {\n    position: fixed;\n    bottom: 0px;\n    right: 0px;\n    padding: 20px;\n    display: flex;\n    padding: 20px 0px 0px;\n    background: #fff;\n    border: 1px solid #ddd;\n    box-shadow: -2px 2px 7px rgba(200, 193, 193, 0.5);\n    margin: 0px 20px 0px 20px;\n    border-radius: 10px 10px 0px 0px;\n    max-width: 388px;\n    width: 100%;\n    box-sizing: border-box;\n    z-index: 1000;\n    flex-wrap: wrap;\n    max-height: 400px;\n    min-height: 400px;\n    height: 100%;\n    overflow-y: hidden;\n    flex-direction: row;\n    left: 0px;\n  }\n}\n\n.flow-container {\n  display: flex;\n  gap: 20px;\n}\n\n/* Left: Expansion Panel */\n.steps-panel {\n  width: 100%;\n  border-right: 2px solid #ddd;\n  padding-right: 10px;\n}\n\nmat-expansion-panel {\n  background: #f8f9fa;\n  margin-bottom: 5px;\n}\n\nmat-expansion-panel-header {\n  font-weight: bold;\n  // background-color: #5ea1d8;;\n  color: white;\n  cursor: pointer;\n}\n\nmat-expansion-panel-header:hover {\n  // background-color: #5ea1d8;\n  background-color: rgba(200, 193, 193, 0.5);\n}\n\n/* Right: Step Content */\n.step-content {\n  width: 100%;\n  padding-left: 10px;\n}\n\n.step-content h3 {\n  margin-bottom: 10px;\n}\n\n.step-content video,\n.step-content img {\n  display: block;\n  margin-top: 10px;\n  border-radius: 5px;\n}\n\n.viewflow-step {\n  .flow-container {\n    width: 100%;\n  }\n  .description {\n    width: 100%;\n  }\n}\n.steps-list {\n  margin-bottom: 10px;\n\n  display: flex;\n  button {\n    white-space: nowrap;\n    margin-bottom: 10px !important;\n  }\n}\n.step-scroll {\n  overflow-x: scroll;\n  width: 100%;\n}\n\n.toggle-container {\n  display: flex;\n  // align-items: center; /* Aligns items vertically */\n  gap: 10px; /* Adds spacing between elements */\n}\n\n.toggle-button {\n  transform: scale(1.2); /* Slightly increases the size of the checkbox */\n}\n\n.toggle-description {\n  max-width: 300px; /* Adjust width as needed */\n}\nmat-menu {\n  display: block !important;\n}\n/* Ensure custom menu panel is visible */\n.custom-menu-panel {\n  display: block !important;\n  opacity: 1 !important;\n  visibility: visible !important;\n\n  .active {\n    background-color: #5ea1d8;\n    color: white;\n    font-weight: bold;\n    border-radius: 4px;\n  }\n}\n\n/* Ensure parent element does not block menu */\n.menu-container {\n  position: relative;\n  z-index: 1000;\n}\n\n/* Ensure the icon button is clickable */\n.menu-icon-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n/* Override any hidden styles */\n.custom-mat-menu {\n  display: block !important;\n}\n/* Hamburger Menu Styles */\n.hamburger-menu {\n  display: none; /* Hidden by default on desktop */\n  padding: 10px;\n  background: #fff;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 2000;\n  width: 100%;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.hamburger-btn {\n  background-color: #5ea1d8;\n  color: white !important;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  // width: 40px;\n  // height: 40px;\n  .active {\n    background-color: #5ea1d8;\n    color: white;\n    font-weight: bold;\n    border-radius: 4px;\n  }\n}\n\n.hamburger-lines {\n  width: 30px;\n  height: 20px;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.hamburger-lines span {\n  display: block;\n  width: 100%;\n  height: 3px;\n  background: #212529;\n  border-radius: 2px;\n  transition: all 0.3s ease;\n}\n\n/* Optional: Transform lines into 'X' when menu is open */\n.hamburger-btn[aria-expanded=\"true\"] .hamburger-lines span:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\n\n.hamburger-btn[aria-expanded=\"true\"] .hamburger-lines span:nth-child(2) {\n  opacity: 0;\n}\n\n.hamburger-btn[aria-expanded=\"true\"] .hamburger-lines span:nth-child(3) {\n  transform: rotate(-45deg) translate(6px, -6px);\n}\n@media screen and (min-width: 993px) {\n  .mobileonly {\n    display: none;\n  }\n  .analyticmobile {\n    display: none;\n  }\n}\n.active {\n  background-color: #5ea1d8;\n  color: white;\n  font-weight: bold;\n  border-radius: 4px;\n}\n\n//\n\nbody {\n  overflow-x: hidden;\n}\n\n.dashbored-wrap {\n  width: 100%;\n  height: 100vh;\n  background: #fff;\n  .logo {\n    width: 100px;\n    margin-right: 100px;\n  }\n  .top-menu-wrap {\n    display: flex;\n    align-items: center;\n    padding: 20px 10px;\n  }\n  .user-name {\n    display: flex;\n    align-items: center;\n  }\n  .user-details {\n    flex: 1;\n    display: flex;\n    justify-content: flex-end;\n  }\n  .user-name p {\n    display: flex;\n    align-items: center;\n  }\n  .user-name span {\n    width: 40px;\n    height: 40px;\n    background: red;\n    border-radius: 50%;\n    display: block;\n    margin-right: 10px;\n  }\n\n  .top-menu-wrap {\n    width: 100%;\n    height: 100px;\n\n    background: #fff;\n  }\n  .dash-details {\n    width: 100%;\n    display: flex;\n    max-height: 100vh;\n\n    /* background: green; */\n  }\n\n  ul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n  }\n  p {\n    margin-bottom: 10px;\n  }\n  // .scroll-div {\n  //   position: absolute;\n  //   top: 120px !important;\n  //   width: 100%;\n  // }\n\n  ul li {\n    margin-bottom: 10px;\n    height: 40px;\n\n    padding: 0px 10px;\n    position: relative;\n    z-index: 1;\n    color: #212529;\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n  }\n  ul li:before {\n    bottom: 0;\n    content: \"\";\n    display: block;\n    height: 100%;\n    left: 0px;\n    position: absolute;\n    background: #fff;\n    transition: width 0.3s ease 0s, left 0.3s ease 0s;\n    width: 0%;\n    z-index: -1;\n  }\n  ul li:hover {\n    color: #000;\n  }\n  ul li:hover:before {\n    /* background: #fff;\n    color: #212529; */\n    width: 100%;\n  }\n  .table-bordered {\n    border: 0px;\n  }\n  .detail-description {\n    width: 100%;\n    height: 100%;\n    padding: 0px;\n    // width: calc(100% - 250px);\n    position: absolute;\n    // left: 250px;\n    // top: 120px;\n    /* background: purple; */\n  }\n\n  .followers-tag {\n    display: flex;\n    position: relative;\n    z-index: 1;\n  }\n  h3 {\n    position: relative;\n    z-index: 3;\n    color: #fff;\n    font-weight: normal;\n  }\n  .com-record {\n    width: calc(100% - 250px);\n    width: 100%;\n    height: auto;\n    position: relative;\n    z-index: 0;\n    padding: 20px 30px 30px;\n    // position: fixed;\n    // top:80px;\n    // left:250px;\n    // background: white;\n    // z-index: 100;\n    .followers-tag {\n      .box {\n        .text {\n          p.number {\n            font-family: Arial !important;\n          }\n        }\n      }\n    }\n  }\n  .com-record:after {\n    content: \"\";\n    width: 100%;\n    height: 60%;\n    /* background: gray; */\n    top: 0px;\n    position: absolute;\n    left: 0px;\n    z-index: 0;\n    background: #5ea1d8;\n  }\n  .ico-box {\n    width: 40px;\n    height: 40px;\n    background: #efeeee;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  .table-wrap {\n    padding: 30px 30px 30px 0px;\n    position: absolute;\n    top: 150px;\n    width: calc(100% - 30px);\n    width: 100%;\n    left: 0px;\n    /* width:calc(100% - 76px); */\n  }\n  .box {\n    width: auto;\n    padding: 5px 10px;\n    background: #fff;\n    margin-right: 20px;\n    border: 1px solid #ddd;\n    border-radius: 10px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 1px 1px 25px rgba(0, 0, 0, 0.1607843137);\n  }\n  .filter-ico li {\n    width: 40px;\n  }\n  .filter-ico li i {\n    color: #000;\n  }\n  .text {\n    padding-right: 10px;\n  }\n  .table-parent {\n    overflow-x: auto;\n    margin-top: -8px;\n    // max-height: 400px;\n    overflow-y: auto;\n  }\n  table {\n    margin-bottom: 20px;\n    // border-collapse:separate;\n    // border-spacing:0 0.5em;\n    border-left: 0px;\n    border-bottom: 0px;\n    border: 0px;\n    // max-height: 600px;\n    overflow-y: auto;\n    width: 100%;\n  }\n  th,\n  td {\n    border-bottom: 0px;\n    border: 1px solid gray;\n    /* background: white; */\n    color: #000;\n    padding: 10px 10px;\n    border-width: 1px !important;\n    min-width: 100px;\n    font-family: \"Raleway\";\n    vertical-align: top;\n  }\n  th {\n    background: #5ea1d8;\n    color: #fff;\n  }\n  td[scope=\"row\"] {\n    position: relative;\n    // display: flex;\n    // flex-direction: column;\n    // &>div{\n    //   display: flex;\n    //   align-items: flex-start;\n    //   div{\n    //     margin: 0px !important;\n    //     width: 40px;\n    //   }\n    // }\n  }\n  .inner {\n    width: 100%;\n    margin-bottom: 0px;\n    td {\n      padding: 5px;\n      border: 0px;\n      &:first-child {\n        width: 30px;\n      }\n    }\n  }\n  td[scope=\"row\"]:before {\n    content: \"\";\n    width: 5px;\n    height: calc(100% + 2px);\n    position: absolute;\n    left: 0px;\n    top: -1px;\n    background: #5ea1d8;\n  }\n  tbody tr {\n    &:first-child {\n      // display: flex;\n    }\n    &:hover {\n      background: #5ea1d8;\n      td {\n        color: #fff;\n      }\n    }\n    span {\n      display: flex;\n      align-items: center;\n    }\n  }\n  // tr:nth-child(even){\n  //     background: #5ea1d8;\n\n  // }\n  // tr:nth-child(even) td{\n  //     color: #fff;\n  // }\n\n  .filter {\n    display: flex;\n    align-items: center;\n    margin-bottom: 0px;\n    border: 1px solid #ddd;\n    border-bottom: 0px;\n    padding: 10px 10px;\n    // position: fixed;\n    // width:calc(100% - 250px);\n  }\n  .filter-title {\n    flex: 1;\n  }\n  .filter ul {\n    display: flex;\n    float: right;\n  }\n  .filter-bar {\n    display: flex;\n    width: 100%;\n  }\n  .filter-ico {\n    flex: 1;\n  }\n  .search-container {\n    position: relative;\n  }\n\n  .search-input {\n    width: 400px;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    position: relative;\n  }\n  .search-input + i {\n    position: absolute;\n    right: 20px;\n    top: 37%;\n  }\n\n  .search-icon {\n    position: absolute;\n    top: 50%;\n    right: 10px;\n    transform: translateY(-50%);\n  }\n\n  .chekbox-image {\n    display: flex;\n    td {\n      &:first-child {\n        width: unset;\n        flex: 1;\n        min-width: 150px;\n        display: flex;\n        align-items: flex-start;\n        span {\n          padding-left: 13px;\n        }\n      }\n      &:last-child {\n        min-width: unset;\n        width: 40px;\n        display: flex;\n        align-items: flex-start;\n      }\n    }\n  }\n  .image-sec {\n    img {\n      max-width: 100%;\n      max-height: 80px;\n      // width: 100%;\n      object-fit: cover;\n    }\n  }\n  .bundel {\n    span {\n      img {\n      }\n    }\n  }\n  .mobile-design {\n    display: none;\n  }\n}\n@media (max-width: 992px) {\n  .dashbored-wrap {\n    .detail-list {\n      display: none;\n    }\n    .detail-description {\n      width: 100%;\n      left: 0px;\n    }\n    .followers-tag {\n      flex-wrap: wrap;\n      .box {\n        margin: 10px;\n        width: 100%;\n        .text {\n          flex: 1;\n        }\n      }\n    }\n    .com-record {\n      padding: 15px;\n      &:after {\n        height: 130px;\n      }\n    }\n    .filter {\n      // display: none;\n    }\n    .search-container {\n      .search-input {\n        width: 100%;\n      }\n    }\n    .top-menu-wrap {\n      display: none;\n    }\n    .table-wrap {\n      top: unset;\n      .table-parent {\n        display: none;\n      }\n    }\n    .mobile-design {\n      padding: 20px 10px;\n      background: lightblue;\n      display: block;\n      .tile {\n        background: #fff;\n        padding: 10px;\n        & > div {\n          border-bottom: 1px solid #ddd;\n        }\n        p {\n          color: #5ea1d8 !important;\n        }\n        p.bold {\n          font-weight: 700 !important;\n          font-family: Arial, Helvetica, sans-serif !important;\n        }\n        .main-title {\n          display: flex;\n          align-items: center;\n          background: #5ea1d8;\n          padding: 10px;\n          margin-bottom: 10px;\n          h3 {\n            margin-bottom: 0px !important;\n            color: #fff !important;\n          }\n        }\n      }\n      .first-tile {\n        div {\n          display: flex;\n          align-items: center;\n          margin-bottom: 10px;\n          span {\n            display: flex;\n            align-items: center;\n          }\n        }\n\n        input {\n          position: relative;\n          margin: 0px 10px 0px 0px;\n          width: 20px;\n          height: 20px;\n        }\n        .img {\n          display: flex;\n          align-items: flex-start;\n          .bundle {\n            width: 30px;\n            margin-right: 10px;\n            height: 30px;\n          }\n          img {\n            width: 100%;\n            max-height: 80px;\n            object-fit: cover;\n          }\n        }\n      }\n      .common-tile {\n        display: flex;\n        .title-tile {\n          flex: 1;\n          padding: 3px;\n        }\n      }\n    }\n  }\n}\n\n/* new setting common design starts here*/\n\n.setting-dashboard {\n  padding: 0;\n  // height: 100vh;\n  position: relative;\n  margin-top: 0;\n  background: #fff;\n  .row {\n    flex-direction: row;\n    height: 100%;\n    margin: 0px;\n  }\n  .left-user {\n    background: #5ea1d8;\n    position: relative;\n    padding: 0 0 0 30px;\n    position: fixed;\n    top: 120px;\n    height: calc(100vh - 100px);\n    z-index: 3;\n    .collapse-btn {\n      position: absolute;\n      width: 25px;\n      height: 25px;\n      background: #5ea1d8;\n      border-radius: 50%;\n      right: -12.5px;\n      top: 26px;\n      border: 2px solid #fff;\n      box-shadow: 0 0 3px #171717;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      color: #fff;\n      transform: rotate(180deg);\n    }\n    .dash-elemenet {\n      height: calc(100vh - 180px);\n      ul {\n        padding: 0px;\n        margin: 0px;\n        width: 100%;\n        list-style-type: none;\n        li {\n          height: 40px;\n          margin-bottom: 10px;\n          position: relative;\n          display: flex;\n          align-items: center;\n          transition: all 0.5s linear;\n          padding-left: 10px;\n          &:after {\n            bottom: 0;\n            content: \"\";\n            display: block;\n            height: 1px;\n            height: 100%;\n            left: 0%;\n            position: absolute;\n            background: #fff;\n            background: #1d67a3;\n            transition: all 0.5s linear;\n            width: 0;\n            z-index: -1;\n          }\n          &:hover:after,\n          &:active:after,\n          &:focus:after {\n            content: \"\";\n            width: 100%;\n            left: 0;\n            transition: all 0.5s linear;\n          }\n        }\n      }\n    }\n  }\n}\n.dashbored-wrap {\n  padding-left: 10px;\n  margin-top: 120px;\n}\n\n.setting-dashboard .left-user .dash-title {\n  position: unset;\n  width: 100%;\n}\n.setting-dashboard .dash-title {\n  height: 80px;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  color: #fff;\n  position: fixed;\n  z-index: 2;\n  top: 120px;\n}\n.setting-dashboard .dash-title h6,\n.setting-dashboard .dash-title .h6 {\n  display: flex;\n  align-items: center;\n  font-weight: 500 !important;\n  color: #fff !important;\n}\n.setting-dashboard .dash-title h6 span,\n.setting-dashboard .dash-title .h6 span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n\n.setting-dashboard .dash-elemenet {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex-direction: column;\n  margin-top: 1rem;\n  height: calc(100vh - 220px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding-right: 20px;\n}\n.setting-dashboard .dash-elemenet > div {\n  width: 100%;\n  line-height: 26px;\n  margin-bottom: 10px;\n  font-size: 13px;\n  font-weight: 400;\n  cursor: pointer;\n  color: #fff;\n  transition: all 0.5slinear;\n  position: relative;\n  padding-bottom: 0;\n  z-index: 2;\n  min-height: 40px;\n  display: flex;\n  align-items: center;\n}\n.left-user .selected-item {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n.setting-dashboard .left-user .dash-elemenet > div span {\n  width: auto !important;\n  font-size: 20px;\n  margin-right: 10px;\n}\n/* In your component CSS */\nli.active {\n  background: #1d67a3 !important;\n  padding-left: 10px;\n}\n\n/*right section*/\n.setting-dashboard .submission-field {\n  left: 16.666667%;\n  padding-right: 0;\n  position: fixed;\n  position: absolute;\n  top: 0px;\n  width: 83.333333%;\n  padding-left: 0px;\n  border-left: 1px solid #fff;\n}\n.setting-dashboard .submission-field .hamburger {\n  width: 100%;\n  background: #985ce1;\n  display: flex;\n  position: relative;\n}\n.setting-dashboard .submission-field .hamburger .dash-title {\n  padding-left: 15px;\n  background: #5ea1d8;\n  display: flex;\n  // border-left: 1px solid #fff;\n  color: #fff;\n  // left: 16.666667%;\n  width: 83.333333%;\n}\n.scroll-div {\n  position: sticky;\n  top: 180px !important;\n  margin-top: 80px !important;\n  width: 100%;\n  padding-bottom: 20px;\n  .dash-text {\n    padding: 15px 15px 0;\n    padding: 15px;\n  }\n}\n\n.mat-mdc-tab-group {\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n}\n\n.setting-dashboard .dash-elemenet > div:after {\n  bottom: 0;\n  content: \"\";\n  display: block;\n  height: 1px;\n  height: 100%;\n  left: 0%;\n  position: absolute;\n  background: #fff;\n  background: #6322b2;\n  transition: width 0.5sease 0s, left 0.5sease 0s;\n  width: 0;\n  z-index: -1;\n}\n.setting-dashboard .dash-elemenet > div span:last-child {\n  font-size: 12px !important;\n}\n\n@media (max-width: 767px) {\n  /* Make the mobile Settings subheader stick right under the app header */\n  .mob-menu {\n    background: #5d9fd5 !important;\n    position: sticky;\n    top: var(--app-header, 56px);\n    z-index: 1500;\n    width: 100%;\n    display: block !important;\n  }\n  .navbar {\n    justify-content: flex-start;\n    margin-bottom: 0px;\n  }\n  .mob-menu button {\n    background: #5d9fd5 !important;\n    margin-bottom: 0 !important;\n    color: #fff;\n    font-size: 14px;\n    padding: 10px 5px;\n    text-transform: capitalize;\n    border: 1px solid #fff !important;\n    box-shadow: none !important;\n    display: flex !important;\n    align-items: center;\n  }\n  /* Override mob-hide when show-menu is applied */\n  .setting-dashboard .row.show-menu,\n  .setting-dashboard .show-menu.mob-hide,\n  .setting-dashboard .mob-hide.show-menu {\n    display: block !important;\n  }\n  /* Slide-in left menu should start below header + subheader */\n  .setting-dashboard .left-user {\n    width: 59vw;\n    position: fixed;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: calc(100vh - (var(--app-header, 56px) + 48px));\n    padding-left: 10px;\n    left: -59vw;\n    transition: left 0.5s linear;\n    display: block !important;\n    z-index: 1600;\n  }\n  .setting-dashboard .show-menu .left-user {\n    left: 0px;\n    transition: left 0.5s linear;\n  }\n  .setting-dashboard .submission-field {\n    width: 100%;\n    left: 0px;\n  }\n  .dashbored-wrap .table-wrap {\n    padding: 0px;\n  }\n  .setting-dashboard .submission-field .hamburger .dash-title {\n    width: 100%;\n    top: calc(var(--app-header, 56px) + 48px);\n    height: 40px;\n  }\n  .setting-dashboard .left-user .dash-title {\n    display: none;\n  }\n  .setting-dashboard .left-user .collapse-btn {\n    display: none;\n  }\n  /* Push page content below the sticky subheader */\n  .dashbored-wrap {\n    // margin-top: calc(var(--app-header, 56px) + 48px);\n  }\n  .dashbored-wrap .mobile-design {\n    padding: 20px;\n  }\n  .dashbored-wrap .com-record:after {\n    height: 133px;\n  }\n}\n\n/* NOTE: We intentionally do NOT hide the Settings subheader or left menu on small\n   screens anymore so that the mobile hamburger + slide-out menu continue to work\n   consistently across dashboard and settings pages. */\n\n/* Dark mode foundation for settings + child pages */\n:host-context(body.theme-dark) {\n  .setting-dashboard,\n  .dashbored-wrap,\n  .dashbored-wrap .top-menu-wrap,\n  .dashbored-wrap .detail-description,\n  .dashbored-wrap .table-wrap,\n  .dashbored-wrap .com-record,\n  .dashbored-wrap .mobile-design,\n  .dashbored-wrap .tile,\n  .dashbored-wrap .box,\n  .dashbored-wrap .filter,\n  .dashbored-wrap .search-input,\n  .dashbored-wrap .detail-list,\n  .settings-container,\n  .setting-page,\n  .price-per-slot {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n    box-shadow: none !important;\n  }\n\n  .setting-dashboard .left-user,\n  .setting-dashboard .dash-title,\n  .setting-dashboard .submission-field {\n    background: #0f172a !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .dashbored-wrap p,\n  .dashbored-wrap span,\n  .dashbored-wrap label,\n  .dashbored-wrap li,\n  .dashbored-wrap td,\n  .dashbored-wrap th,\n  .dashbored-wrap h1,\n  .dashbored-wrap h2,\n  .dashbored-wrap h3,\n  .dashbored-wrap h4,\n  .dashbored-wrap h5,\n  .dashbored-wrap h6,\n  .dashbored-wrap i,\n  .setting-label,\n  .prefix {\n    color: #ffffff !important;\n  }\n\n  .dashbored-wrap table,\n  .dashbored-wrap thead,\n  .dashbored-wrap tbody,\n  .dashbored-wrap tr,\n  .dashbored-wrap td,\n  .dashbored-wrap th {\n    background: #111827 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .dashbored-wrap tbody tr:hover {\n    background: #1f2937 !important;\n  }\n\n  .setting-page input,\n  .setting-page select,\n  .setting-page textarea,\n  .setting-input,\n  .toggle-button {\n    background: #0f172a !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.35) !important;\n  }\n\n  .dashbored-wrap [style*=\"background: white\"],\n  .dashbored-wrap [style*=\"background:white\"],\n  .dashbored-wrap [style*=\"background-color: white\"],\n  .dashbored-wrap [style*=\"background-color:white\"],\n  .dashbored-wrap [style*=\"background: #fff\"],\n  .dashbored-wrap [style*=\"background:#fff\"],\n  .dashbored-wrap [style*=\"background: #ffffff\"],\n  .dashbored-wrap [style*=\"background:#ffffff\"],\n  .dashbored-wrap [style*=\"background-color: #fff\"],\n  .dashbored-wrap [style*=\"background-color:#fff\"],\n  .dashbored-wrap [style*=\"background-color: #ffffff\"],\n  .dashbored-wrap [style*=\"background-color:#ffffff\"],\n  .dashbored-wrap [style*=\"background: rgb(255, 255, 255)\"],\n  .dashbored-wrap [style*=\"background:rgb(255,255,255)\"],\n  .dashbored-wrap [style*=\"background-color: rgb(255, 255, 255)\"],\n  .dashbored-wrap [style*=\"background-color:rgb(255,255,255)\"],\n  .dashbored-wrap [style*=\"background: var(--white)\"],\n  .dashbored-wrap [style*=\"background-color: var(--white)\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n    color: #ffffff !important;\n  }\n\n  /* Hardening: catch routed child content outside dashbored-wrap */\n  .setting-dashboard router-outlet ~ *,\n  .setting-dashboard router-outlet + *,\n  .setting-dashboard .submission-field > *,\n  .setting-dashboard .submission-field > * *,\n  .setting-dashboard .detail-description,\n  .setting-dashboard .detail-description *,\n  .setting-dashboard .scroll-div,\n  .setting-dashboard .scroll-div * {\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .setting-dashboard router-outlet ~ *[style*=\"background\"],\n  .setting-dashboard router-outlet + *[style*=\"background\"],\n  .setting-dashboard .submission-field *[style*=\"background\"],\n  .setting-dashboard .detail-description *[style*=\"background\"],\n  .setting-dashboard .scroll-div *[style*=\"background\"] {\n    background: #111827 !important;\n    background-color: #111827 !important;\n  }\n\n  .setting-dashboard .mat-mdc-card,\n  .setting-dashboard .mat-card,\n  .setting-dashboard .mat-expansion-panel,\n  .setting-dashboard .mat-mdc-tab-body-content,\n  .setting-dashboard .mat-mdc-tab-body,\n  .setting-dashboard .mat-mdc-tab-body-wrapper,\n  .setting-dashboard .table,\n  .setting-dashboard table,\n  .setting-dashboard tbody,\n  .setting-dashboard tr,\n  .setting-dashboard td {\n    background: #111827 !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  /* Title/header bars: remove white patches */\n  .setting-dashboard .dash-title,\n  .setting-dashboard .submission-field .hamburger .dash-title,\n  .setting-dashboard .left-user .dash-title,\n  .page-section-header,\n  .page-section-title {\n    background: transparent !important;\n    background-color: transparent !important;\n    color: #ffffff !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  /* Title card container (child pages) */\n  ::ng-deep .setting-dashboard .dash-text,\n  ::ng-deep .setting-dashboard .dash-text > div,\n  ::ng-deep .setting-dashboard .main-title,\n  ::ng-deep .setting-dashboard .title-tile,\n  ::ng-deep .setting-dashboard .page-section-header,\n  ::ng-deep .setting-dashboard .page-header,\n  ::ng-deep .setting-dashboard .header-section {\n    background: transparent !important;\n    background-color: transparent !important;\n    box-shadow: none !important;\n    color: #ffffff !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
